webpackJsonp([43,0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1755);


/***/ },

/***/ 2:
/***/ function(module, exports) {

	module.exports = React;

/***/ },

/***/ 3:
/***/ function(module, exports) {

	module.exports = Aisc;

/***/ },

/***/ 4:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _exceed = __webpack_require__(28);
	
	var _exceed2 = _interopRequireDefault(_exceed);
	
	var _aisc = __webpack_require__(3);
	
	var _api = __webpack_require__(25);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Toast = _aisc.Feedback.toast;
	
	// Exceed文档 - http://web.npm.alibaba-inc.com/package/exceed
	var exceed = new _exceed2.default({
	  ENV: 'production'
	});
	
	exceed.interceptors.request.push(function (requestParams) {
	  requestParams.headers = {
	    'X-CSRF-TOKEN': window.csrfToken,
	    'Ao-Region': window.AK_GLOBAL.region,
	    'Ao-Region-Id': window.AK_GLOBAL.regionId
	  };
	});
	if (window.AoneLayout) {
	  AoneLayout.utils.ajaxFilterThunk('exceed', exceed, function (text) {
	    Toast.error(text, 'danger');
	  });
	}
	
	exceed.interceptors.response.error.push(function (response, msg, t, config) {
	  if (msg) {
	    Toast.error(msg);
	  }
	});
	
	function apiMapCreator(apimapArr) {
	  return apimapArr.map(function (item) {
	    return {
	      name: item.name || item,
	      id: item.id || item,
	      method: item.method || 'get',
	      urls: {
	        production: item.urls || '/api/' + item
	      },
	      type: item.type
	    };
	  });
	}
	
	exceed.use(apiMapCreator(_api2.default));
	
	exports.default = exceed;

/***/ },

/***/ 5:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIELD_FORMAT_MAP = exports.NameSpace = undefined;
	exports.cs = cs;
	exports.formateToDateTime = formateToDateTime;
	exports.formateToDate = formateToDate;
	exports.formateTimeStampToDate = formateTimeStampToDate;
	exports.formateToDateByTimeStamp = formateToDateByTimeStamp;
	exports.formateToDayByTimeStamp = formateToDayByTimeStamp;
	exports.dateAdd = dateAdd;
	exports.i18n = i18n;
	exports.aoneNav = aoneNav;
	exports.getCookie = getCookie;
	exports.getLocale = getLocale;
	exports.isPrivateCloud = isPrivateCloud;
	exports.calculateDateGap = calculateDateGap;
	
	var _lodash = __webpack_require__(7);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _en_US = __webpack_require__(32);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _zh_CN = __webpack_require__(33);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tools = {
	  getToken: function getToken() {
	    var $token = document.getElementsByName('_tb_token_');
	    return $token.length ? $token[0].value : '';
	  },
	  isDaily: function isDaily() {
	    var host = window.location.host;
	    return host.indexOf('daily') > -1;
	  },
	  copyToClipboard: function copyToClipboard(string) {
	    var parentDom = document.createElement('div');
	    var textarea = document.createElement('textarea');
	    textarea.value = string;
	    parentDom.appendChild(textarea);
	    document.body.appendChild(parentDom);
	    textarea.select();
	    document.execCommand('copy');
	    parentDom.removeChild(textarea);
	  },
	  getQueryString: function getQueryString(name) {
	    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	    var r = window.location.search.substr(1).match(reg);
	    if (r != null) return unescape(r[2]);
	    return null;
	  },
	  urlToObj: function urlToObj(str) {
	    if (!str) {
	      return {};
	    }
	    var pairs = str.substring(1).split('&');
	    var obj = {};
	
	    for (var i in pairs) {
	      if (pairs[i] && pairs[i] !== '' && typeof pairs[i] === 'string') {
	        var pair = pairs[i].split('=');
	        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
	      }
	    }
	    return obj;
	  },
	  objToUrl: function objToUrl(obj) {
	    if (Object.keys(obj).length === 0) {
	      return '';
	    }
	    var str = [];
	    for (var k in obj) {
	      str.push(k + '=' + obj[k]);
	    }
	    return str.join('&');
	  },
	  getUrlParam: function getUrlParam(name) {
	    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
	    var r = decodeURIComponent((window.location.search + window.location.hash).substr(1)).match(reg);
	    if (r !== null) return unescape(r[2]);
	    return '';
	  },
	  getParams: function getParams() {
	    return this.extend(this.urlToObj(window.location.search), this.urlToObj(window.location.hash));
	  },
	  setSearch: function setSearch(key, value) {
	    var searchObj = this.urlToObj(window.location.search);
	    searchObj[key] = value;
	    window.location.search = this.objToUrl(searchObj);
	  },
	  setHash: function setHash(key, value) {
	    var hashObj = this.urlToObj(window.location.hash);
	    hashObj[key] = value;
	    window.location.hash = this.objToUrl(hashObj);
	  },
	  isArray: function isArray(object) {
	    return object instanceof Array;
	  },
	  isWindow: function isWindow(obj) {
	    return obj != null && obj == obj.window;
	  },
	  isDocument: function isDocument(obj) {
	    return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
	  },
	  isObject: function isObject(obj) {
	    return this._type(obj) == 'object';
	  },
	  isFunction: function isFunction(fn) {
	    return this._type(fn) == 'function';
	  },
	  isPlainObject: function isPlainObject(obj) {
	    return this.isObject(obj) && !this.isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	  },
	  _type: function _type(obj) {
	    var class2type = {};
	    var toString = class2type.toString;
	    return obj == null ? String(obj) : class2type[toString.call(obj)] || 'object';
	  },
	  isString: function isString(str) {
	    return typeof str === 'string';
	  },
	  extend: function extend() {
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var result = {};
	    for (var key in source) {
	      if (source[key]) {
	        result[key] = source[key];
	      }
	    }
	    for (var _key in target) {
	      if (target[_key]) {
	        result[_key] = target[_key];
	      }
	    }
	    return result;
	  },
	  namespace: function namespace(name) {
	    return function (v) {
	      return name + '-' + v;
	    };
	  },
	  getIconMap: function getIconMap(stamp) {
	    var stampIconMap = {
	      Req: 'bookmark',
	      Task: 'tasks',
	      Bug: 'bug',
	      Risk: 'exclamation-triangle'
	    };
	    if (!stamp) {
	      stamp = 'Req';
	    }
	    return stampIconMap[stamp] ? stampIconMap[stamp] : 'bookmark';
	  }
	};
	
	var NameSpace = exports.NameSpace = tools.namespace.bind(tools);
	exports.default = tools;
	var FIELD_FORMAT_MAP = exports.FIELD_FORMAT_MAP = {
	  string: '文本',
	  text: '长段文本',
	  int: '整数',
	  float: '浮点数',
	  list: '单选列表',
	  multiList: '多选列表',
	  dynamicList: '动态单选列表',
	  dynamicMultiList: '动态多选列表',
	  date: '日期',
	  bool: '布尔型',
	  keyword: '模糊搜索',
	  'int~object': '对象'
	};
	
	function cs() {
	  for (var _len = arguments.length, classNames = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    classNames[_key2] = arguments[_key2];
	  }
	
	  return _lodash2.default.filter(classNames).join(' ');
	}
	
	function formateToDateTime(time) {
	  var timeStamp = Date.parse(time);
	  var date = new Date(timeStamp);
	  var year = date.getUTCFullYear();
	  var month = date.getUTCMonth();
	  var day = date.getUTCDate();
	  var hour = date.getUTCHours();
	  var minute = date.getUTCMinutes();
	  var second = date.getUTCSeconds();
	  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
	}
	
	function formateToDate(time) {
	  var timeStamp = Date.parse(time);
	  var date = new Date(timeStamp);
	  var year = date.getFullYear();
	  var month = date.getMonth() + 1;
	  var day = date.getDate();
	  return year + '-' + month + '-' + day;
	}
	
	function checkTime(i) {
	  if (i < 10) {
	    i = '0' + i;
	  }
	  return i;
	}
	
	function formateTimeStampToDate(timeStamp) {
	  var date = new Date(timeStamp);
	  var year = date.getFullYear();
	  var month = date.getMonth() + 1;
	  var day = date.getDate();
	  return year + '-' + checkTime(month) + '-' + checkTime(day);
	}
	
	function formateToDateByTimeStamp(timeStamp) {
	  var date = new Date(timeStamp);
	  var year = date.getFullYear();
	  var month = date.getMonth() + 1;
	  var day = date.getDate();
	  var hour = date.getHours();
	  var minute = date.getMinutes();
	  var second = date.getSeconds();
	  return year + '-' + month + '-' + day + ' ' + checkTime(hour) + ':' + checkTime(minute) + ':' + checkTime(second);
	}
	
	function formateToDayByTimeStamp(timeStamp) {
	  var date = new Date(timeStamp);
	  var year = date.getFullYear();
	  var month = date.getMonth() + 1;
	  var day = date.getDate();
	  return year + '-' + checkTime(month) + '-' + checkTime(day);
	}
	function dateAdd(interval, number, date) {
	  /*
	    *   功能:实现VBScript的DateAdd功能.
	    *   参数:interval,字符串表达式，表示要添加的时间间隔.
	    *   参数:number,数值表达式，表示要添加的时间间隔的个数.
	    *   参数:date,时间对象.
	    *   返回:新的时间对象.
	    *   var   now   =   new   Date();
	    *   var   newDate   =   DateAdd( "d ",5,now);
	    *---------------   DateAdd(interval,number,date)   -----------------
	    */
	  number = parseInt(number);
	  var year = parseInt(date.getFullYear());
	  var month = parseInt(date.getMonth());
	  var day = parseInt(date.getDate());
	  var hour = parseInt(date.getHours());
	  var minute = parseInt(date.getMinutes());
	  var second = parseInt(date.getSeconds());
	
	  switch (interval) {
	    case 'year':
	      {
	        date.setFullYear(year + number);
	        return date;
	      }
	    case 'month':
	      {
	        var newMonth = month + number;
	        date.setMonth(newMonth);
	        return date;
	      }
	    case 'week':
	      {
	        date.setDate(day + number * 7);
	        return date;
	      }
	    case 'day':
	      {
	        date.setDate(day + number);
	        return date;
	      }
	    case 'hour':
	      {
	        date.setHours(hour + number);
	        return date;
	      }
	    case 'miute':
	      {
	        date.setMinutes(minute + number);
	        return date;
	      }
	    case 'second':
	      {
	        date.setSeconds(second + number);
	        return date;
	      }
	    default:
	      {
	        date.setDate(day + number);
	        return date;
	      }
	  }
	}
	
	function i18n() {
	  var isEn = /ak_user_locale=en_US/.test(document.cookie);
	
	  for (var _len2 = arguments.length, lang = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	    lang[_key3] = arguments[_key3];
	  }
	
	  if (lang.length === 1) {
	    if (isEn) {
	      return _en_US2.default[lang[0]] || '';
	    }
	    return _zh_CN2.default[lang[0]] || '';
	  } else if (isEn) {
	    return lang[1] || '';
	  }
	  return lang[0] || '';
	}
	
	// define remove function
	function removeElements(elms) {
	  Array.from(elms).forEach(function (el) {
	    return el.remove();
	  });
	}
	
	function aoneNav(opts) {
	  var el = document.querySelector('.aone-nav ');
	  var ifUseAkProjectApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-project';
	  if (ifUseAkProjectApi) {
	    return;
	  }
	  var params = Object.assign({
	    type: 'ajax',
	    ajax: {
	      url: '/api/anonymous/getProjectNavs',
	      dataType: 'jsonp',
	      data: {
	        staffId: window.AK_GLOBAL.keludeUser.staffId,
	        key: opts.key,
	        projectId: window.AK_GLOBAL.projectId
	      },
	      success: function success() {
	        if (el) {
	          removeElements(document.querySelectorAll('.aone-nav'));
	        }
	      },
	      format: function format(data) {
	        return data.result;
	      }
	    }
	  }, opts);
	  window.aoneLayout.aoneNav(params);
	  return true;
	}
	
	function getCookie(name) {
	  var value = '; ' + document.cookie;
	  var parts = value.split('; ' + name + '=');
	  if (parts.length === 2) {
	    return parts.pop().split(';').shift();
	  }
	  return null;
	}
	
	function getLocale() {
	  var locale = getCookie('ak_user_locale');
	  if (locale === 'en_US') {
	    return 'en-us';
	  }
	  return 'zh-cn';
	}
	
	function isPrivateCloud() {
	  return window.AK_GLOBAL.siteType === 'vpc';
	}
	
	function calculateDateGap(date) {
	  var today = formateTimeStampToDate(new Date());
	  var dateTimeStamp = new Date(date);
	  var todayTimeStamp = new Date(today);
	  return (dateTimeStamp - todayTimeStamp) / (24 * 60 * 60 * 1000);
	}

/***/ },

/***/ 7:
/***/ function(module, exports) {

	module.exports = _;

/***/ },

/***/ 8:
/***/ function(module, exports) {

	module.exports = ReactRedux;

/***/ },

/***/ 9:
/***/ function(module, exports) {

	module.exports = Redux;

/***/ },

/***/ 11:
/***/ function(module, exports) {

	module.exports = ReactDOM;

/***/ },

/***/ 12:
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var callbackPrefix = 'exceed_' + +new Date();
	
	function getCallbackPrefix() {
	  return callbackPrefix;
	}
	
	function toQueryString(o, trad) {
	  var prefix = void 0,
	      i = void 0,
	      traditional = trad || false,
	      s = [],
	      enc = encodeURIComponent,
	      add = function add(key, value) {
	    // If value is a function, invoke it and return its value
	    value = typeof value === 'function' ? value() : value == null ? '' : value;
	    s[s.length] = enc(key) + '=' + enc(value);
	  };
	  // If an array was passed in, assume that it is an array of form elements.
	  if (Array.isArray(o)) {
	    for (i = 0; o && i < o.length; i++) {
	      add(o[i].name, o[i].value);
	    }
	  } else {
	    // If traditional, encode the "old" way (the way 1.3.2 or older
	    // did it), otherwise encode params recursively.
	    for (prefix in o) {
	      if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add);
	    }
	  }
	
	  // spaces should be + according to spec
	  return s.join('&').replace(/%20/g, '+');
	}
	
	function buildParams(prefix, obj, traditional, add) {
	  var name = void 0,
	      i = void 0,
	      v = void 0,
	      rbracket = /\[\]$/;
	
	  if (Array.isArray(obj)) {
	    // Serialize array item.
	    for (i = 0; obj && i < obj.length; i++) {
	      v = obj[i];
	      if (traditional || rbracket.test(prefix)) {
	        // Treat each array item as a scalar.
	        add(prefix, v);
	      } else {
	        buildParams(prefix + '[' + ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? i : '') + ']', v, traditional, add);
	      }
	    }
	  } else if (obj && obj.toString() === '[object Object]') {
	    // Serialize object item.
	    for (name in obj) {
	      buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
	    }
	  } else {
	    // Serialize scalar item.
	    add(prefix, obj);
	  }
	}
	
	// normalize newline variants according to spec -> CRLF
	function normalize(s) {
	  return s ? s.replace(/\r?\n/g, '\r\n') : '';
	}
	
	function serial(el, cb) {
	  var n = el.name,
	      t = el.tagName.toLowerCase(),
	      optCb = function optCb(o) {
	    // IE gives value="" even where there is no value attribute
	    // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	    if (o && !o.disabled) {
	      cb(n, normalize(o.attributes.value && o.attributes.value.specified ? o.value : o.text));
	    }
	  },
	      ch = void 0,
	      ra = void 0,
	      val = void 0,
	      i = void 0;
	
	  // don't serialize elements that are disabled or without a name
	  if (el.disabled || !n) return;
	
	  switch (t) {
	    case 'input':
	      if (!/reset|button|image|file/i.test(el.type)) {
	        ch = /checkbox/i.test(el.type);
	        ra = /radio/i.test(el.type);
	        val = el.value
	        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val));
	      }
	      break;
	    case 'textarea':
	      cb(n, normalize(el.value));
	      break;
	    case 'select':
	      if (el.type.toLowerCase() === 'select-one') {
	        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null);
	      } else {
	        for (i = 0; el.length && i < el.length; i++) {
	          el.options[i].selected && optCb(el.options[i]);
	        }
	      }
	      break;
	  }
	}
	
	module.exports = {
	  getCallbackPrefix: getCallbackPrefix,
	  toQueryString: toQueryString,
	  buildParams: buildParams,
	  normalize: normalize,
	  serial: serial
	};

/***/ },

/***/ 18:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * mustache.js - Logic-less {{mustache}} templates with JavaScript
	 * http://github.com/janl/mustache.js
	 */
	
	/*global define: false Mustache: true*/
	
	(function defineMustache (global, factory) {
	  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
	    factory(exports); // CommonJS
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
	  } else {
	    global.Mustache = {};
	    factory(global.Mustache); // script, wsh, asp
	  }
	}(this, function mustacheFactory (mustache) {
	
	  var objectToString = Object.prototype.toString;
	  var isArray = Array.isArray || function isArrayPolyfill (object) {
	    return objectToString.call(object) === '[object Array]';
	  };
	
	  function isFunction (object) {
	    return typeof object === 'function';
	  }
	
	  /**
	   * More correct typeof string handling array
	   * which normally returns typeof 'object'
	   */
	  function typeStr (obj) {
	    return isArray(obj) ? 'array' : typeof obj;
	  }
	
	  function escapeRegExp (string) {
	    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
	  }
	
	  /**
	   * Null safe way of checking whether or not an object,
	   * including its prototype, has a given property
	   */
	  function hasProperty (obj, propName) {
	    return obj != null && typeof obj === 'object' && (propName in obj);
	  }
	
	  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
	  // See https://github.com/janl/mustache.js/issues/189
	  var regExpTest = RegExp.prototype.test;
	  function testRegExp (re, string) {
	    return regExpTest.call(re, string);
	  }
	
	  var nonSpaceRe = /\S/;
	  function isWhitespace (string) {
	    return !testRegExp(nonSpaceRe, string);
	  }
	
	  var entityMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '/': '&#x2F;',
	    '`': '&#x60;',
	    '=': '&#x3D;'
	  };
	
	  function escapeHtml (string) {
	    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
	      return entityMap[s];
	    });
	  }
	
	  var whiteRe = /\s*/;
	  var spaceRe = /\s+/;
	  var equalsRe = /\s*=/;
	  var curlyRe = /\s*\}/;
	  var tagRe = /#|\^|\/|>|\{|&|=|!/;
	
	  /**
	   * Breaks up the given `template` string into a tree of tokens. If the `tags`
	   * argument is given here it must be an array with two string values: the
	   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
	   * course, the default is to use mustaches (i.e. mustache.tags).
	   *
	   * A token is an array with at least 4 elements. The first element is the
	   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
	   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
	   * all text that appears outside a symbol this element is "text".
	   *
	   * The second element of a token is its "value". For mustache tags this is
	   * whatever else was inside the tag besides the opening symbol. For text tokens
	   * this is the text itself.
	   *
	   * The third and fourth elements of the token are the start and end indices,
	   * respectively, of the token in the original template.
	   *
	   * Tokens that are the root node of a subtree contain two more elements: 1) an
	   * array of tokens in the subtree and 2) the index in the original template at
	   * which the closing tag for that section begins.
	   */
	  function parseTemplate (template, tags) {
	    if (!template)
	      return [];
	
	    var sections = [];     // Stack to hold section tokens
	    var tokens = [];       // Buffer to hold the tokens
	    var spaces = [];       // Indices of whitespace tokens on the current line
	    var hasTag = false;    // Is there a {{tag}} on the current line?
	    var nonSpace = false;  // Is there a non-space char on the current line?
	
	    // Strips all whitespace tokens array for the current line
	    // if there was a {{#tag}} on it and otherwise only space.
	    function stripSpace () {
	      if (hasTag && !nonSpace) {
	        while (spaces.length)
	          delete tokens[spaces.pop()];
	      } else {
	        spaces = [];
	      }
	
	      hasTag = false;
	      nonSpace = false;
	    }
	
	    var openingTagRe, closingTagRe, closingCurlyRe;
	    function compileTags (tagsToCompile) {
	      if (typeof tagsToCompile === 'string')
	        tagsToCompile = tagsToCompile.split(spaceRe, 2);
	
	      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
	        throw new Error('Invalid tags: ' + tagsToCompile);
	
	      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
	      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
	      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
	    }
	
	    compileTags(tags || mustache.tags);
	
	    var scanner = new Scanner(template);
	
	    var start, type, value, chr, token, openSection;
	    while (!scanner.eos()) {
	      start = scanner.pos;
	
	      // Match any text between tags.
	      value = scanner.scanUntil(openingTagRe);
	
	      if (value) {
	        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
	          chr = value.charAt(i);
	
	          if (isWhitespace(chr)) {
	            spaces.push(tokens.length);
	          } else {
	            nonSpace = true;
	          }
	
	          tokens.push([ 'text', chr, start, start + 1 ]);
	          start += 1;
	
	          // Check for whitespace on the current line.
	          if (chr === '\n')
	            stripSpace();
	        }
	      }
	
	      // Match the opening tag.
	      if (!scanner.scan(openingTagRe))
	        break;
	
	      hasTag = true;
	
	      // Get the tag type.
	      type = scanner.scan(tagRe) || 'name';
	      scanner.scan(whiteRe);
	
	      // Get the tag value.
	      if (type === '=') {
	        value = scanner.scanUntil(equalsRe);
	        scanner.scan(equalsRe);
	        scanner.scanUntil(closingTagRe);
	      } else if (type === '{') {
	        value = scanner.scanUntil(closingCurlyRe);
	        scanner.scan(curlyRe);
	        scanner.scanUntil(closingTagRe);
	        type = '&';
	      } else {
	        value = scanner.scanUntil(closingTagRe);
	      }
	
	      // Match the closing tag.
	      if (!scanner.scan(closingTagRe))
	        throw new Error('Unclosed tag at ' + scanner.pos);
	
	      token = [ type, value, start, scanner.pos ];
	      tokens.push(token);
	
	      if (type === '#' || type === '^') {
	        sections.push(token);
	      } else if (type === '/') {
	        // Check section nesting.
	        openSection = sections.pop();
	
	        if (!openSection)
	          throw new Error('Unopened section "' + value + '" at ' + start);
	
	        if (openSection[1] !== value)
	          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
	      } else if (type === 'name' || type === '{' || type === '&') {
	        nonSpace = true;
	      } else if (type === '=') {
	        // Set the tags for the next time around.
	        compileTags(value);
	      }
	    }
	
	    // Make sure there are no open sections when we're done.
	    openSection = sections.pop();
	
	    if (openSection)
	      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
	
	    return nestTokens(squashTokens(tokens));
	  }
	
	  /**
	   * Combines the values of consecutive text tokens in the given `tokens` array
	   * to a single token.
	   */
	  function squashTokens (tokens) {
	    var squashedTokens = [];
	
	    var token, lastToken;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      if (token) {
	        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
	          lastToken[1] += token[1];
	          lastToken[3] = token[3];
	        } else {
	          squashedTokens.push(token);
	          lastToken = token;
	        }
	      }
	    }
	
	    return squashedTokens;
	  }
	
	  /**
	   * Forms the given array of `tokens` into a nested tree structure where
	   * tokens that represent a section have two additional items: 1) an array of
	   * all tokens that appear in that section and 2) the index in the original
	   * template that represents the end of that section.
	   */
	  function nestTokens (tokens) {
	    var nestedTokens = [];
	    var collector = nestedTokens;
	    var sections = [];
	
	    var token, section;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      token = tokens[i];
	
	      switch (token[0]) {
	        case '#':
	        case '^':
	          collector.push(token);
	          sections.push(token);
	          collector = token[4] = [];
	          break;
	        case '/':
	          section = sections.pop();
	          section[5] = token[2];
	          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
	          break;
	        default:
	          collector.push(token);
	      }
	    }
	
	    return nestedTokens;
	  }
	
	  /**
	   * A simple string scanner that is used by the template parser to find
	   * tokens in template strings.
	   */
	  function Scanner (string) {
	    this.string = string;
	    this.tail = string;
	    this.pos = 0;
	  }
	
	  /**
	   * Returns `true` if the tail is empty (end of string).
	   */
	  Scanner.prototype.eos = function eos () {
	    return this.tail === '';
	  };
	
	  /**
	   * Tries to match the given regular expression at the current position.
	   * Returns the matched text if it can match, the empty string otherwise.
	   */
	  Scanner.prototype.scan = function scan (re) {
	    var match = this.tail.match(re);
	
	    if (!match || match.index !== 0)
	      return '';
	
	    var string = match[0];
	
	    this.tail = this.tail.substring(string.length);
	    this.pos += string.length;
	
	    return string;
	  };
	
	  /**
	   * Skips all text until the given regular expression can be matched. Returns
	   * the skipped string, which is the entire tail if no match can be made.
	   */
	  Scanner.prototype.scanUntil = function scanUntil (re) {
	    var index = this.tail.search(re), match;
	
	    switch (index) {
	      case -1:
	        match = this.tail;
	        this.tail = '';
	        break;
	      case 0:
	        match = '';
	        break;
	      default:
	        match = this.tail.substring(0, index);
	        this.tail = this.tail.substring(index);
	    }
	
	    this.pos += match.length;
	
	    return match;
	  };
	
	  /**
	   * Represents a rendering context by wrapping a view object and
	   * maintaining a reference to the parent context.
	   */
	  function Context (view, parentContext) {
	    this.view = view;
	    this.cache = { '.': this.view };
	    this.parent = parentContext;
	  }
	
	  /**
	   * Creates a new context using the given view with this context
	   * as the parent.
	   */
	  Context.prototype.push = function push (view) {
	    return new Context(view, this);
	  };
	
	  /**
	   * Returns the value of the given name in this context, traversing
	   * up the context hierarchy if the value is absent in this context's view.
	   */
	  Context.prototype.lookup = function lookup (name) {
	    var cache = this.cache;
	
	    var value;
	    if (cache.hasOwnProperty(name)) {
	      value = cache[name];
	    } else {
	      var context = this, names, index, lookupHit = false;
	
	      while (context) {
	        if (name.indexOf('.') > 0) {
	          value = context.view;
	          names = name.split('.');
	          index = 0;
	
	          /**
	           * Using the dot notion path in `name`, we descend through the
	           * nested objects.
	           *
	           * To be certain that the lookup has been successful, we have to
	           * check if the last object in the path actually has the property
	           * we are looking for. We store the result in `lookupHit`.
	           *
	           * This is specially necessary for when the value has been set to
	           * `undefined` and we want to avoid looking up parent contexts.
	           **/
	          while (value != null && index < names.length) {
	            if (index === names.length - 1)
	              lookupHit = hasProperty(value, names[index]);
	
	            value = value[names[index++]];
	          }
	        } else {
	          value = context.view[name];
	          lookupHit = hasProperty(context.view, name);
	        }
	
	        if (lookupHit)
	          break;
	
	        context = context.parent;
	      }
	
	      cache[name] = value;
	    }
	
	    if (isFunction(value))
	      value = value.call(this.view);
	
	    return value;
	  };
	
	  /**
	   * A Writer knows how to take a stream of tokens and render them to a
	   * string, given a context. It also maintains a cache of templates to
	   * avoid the need to parse the same template twice.
	   */
	  function Writer () {
	    this.cache = {};
	  }
	
	  /**
	   * Clears all cached templates in this writer.
	   */
	  Writer.prototype.clearCache = function clearCache () {
	    this.cache = {};
	  };
	
	  /**
	   * Parses and caches the given `template` and returns the array of tokens
	   * that is generated from the parse.
	   */
	  Writer.prototype.parse = function parse (template, tags) {
	    var cache = this.cache;
	    var tokens = cache[template];
	
	    if (tokens == null)
	      tokens = cache[template] = parseTemplate(template, tags);
	
	    return tokens;
	  };
	
	  /**
	   * High-level method that is used to render the given `template` with
	   * the given `view`.
	   *
	   * The optional `partials` argument may be an object that contains the
	   * names and templates of partials that are used in the template. It may
	   * also be a function that is used to load partial templates on the fly
	   * that takes a single argument: the name of the partial.
	   */
	  Writer.prototype.render = function render (template, view, partials) {
	    var tokens = this.parse(template);
	    var context = (view instanceof Context) ? view : new Context(view);
	    return this.renderTokens(tokens, context, partials, template);
	  };
	
	  /**
	   * Low-level method that renders the given array of `tokens` using
	   * the given `context` and `partials`.
	   *
	   * Note: The `originalTemplate` is only ever used to extract the portion
	   * of the original template that was contained in a higher-order section.
	   * If the template doesn't use higher-order sections, this argument may
	   * be omitted.
	   */
	  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
	    var buffer = '';
	
	    var token, symbol, value;
	    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
	      value = undefined;
	      token = tokens[i];
	      symbol = token[0];
	
	      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
	      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
	      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
	      else if (symbol === '&') value = this.unescapedValue(token, context);
	      else if (symbol === 'name') value = this.escapedValue(token, context);
	      else if (symbol === 'text') value = this.rawValue(token);
	
	      if (value !== undefined)
	        buffer += value;
	    }
	
	    return buffer;
	  };
	
	  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
	    var self = this;
	    var buffer = '';
	    var value = context.lookup(token[1]);
	
	    // This function is used to render an arbitrary template
	    // in the current context by higher-order sections.
	    function subRender (template) {
	      return self.render(template, context, partials);
	    }
	
	    if (!value) return;
	
	    if (isArray(value)) {
	      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
	        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
	      }
	    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
	      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
	    } else if (isFunction(value)) {
	      if (typeof originalTemplate !== 'string')
	        throw new Error('Cannot use higher-order sections without the original template');
	
	      // Extract the portion of the original template that the section contains.
	      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
	
	      if (value != null)
	        buffer += value;
	    } else {
	      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
	    }
	    return buffer;
	  };
	
	  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
	    var value = context.lookup(token[1]);
	
	    // Use JavaScript's definition of falsy. Include empty arrays.
	    // See https://github.com/janl/mustache.js/issues/186
	    if (!value || (isArray(value) && value.length === 0))
	      return this.renderTokens(token[4], context, partials, originalTemplate);
	  };
	
	  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
	    if (!partials) return;
	
	    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
	    if (value != null)
	      return this.renderTokens(this.parse(value), context, partials, value);
	  };
	
	  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return value;
	  };
	
	  Writer.prototype.escapedValue = function escapedValue (token, context) {
	    var value = context.lookup(token[1]);
	    if (value != null)
	      return mustache.escape(value);
	  };
	
	  Writer.prototype.rawValue = function rawValue (token) {
	    return token[1];
	  };
	
	  mustache.name = 'mustache.js';
	  mustache.version = '2.3.2';
	  mustache.tags = [ '{{', '}}' ];
	
	  // All high-level mustache.* functions use this writer.
	  var defaultWriter = new Writer();
	
	  /**
	   * Clears all cached templates in the default writer.
	   */
	  mustache.clearCache = function clearCache () {
	    return defaultWriter.clearCache();
	  };
	
	  /**
	   * Parses and caches the given template in the default writer and returns the
	   * array of tokens it contains. Doing this ahead of time avoids the need to
	   * parse templates on the fly as they are rendered.
	   */
	  mustache.parse = function parse (template, tags) {
	    return defaultWriter.parse(template, tags);
	  };
	
	  /**
	   * Renders the `template` with the given `view` and `partials` using the
	   * default writer.
	   */
	  mustache.render = function render (template, view, partials) {
	    if (typeof template !== 'string') {
	      throw new TypeError('Invalid template! Template should be a "string" ' +
	                          'but "' + typeStr(template) + '" was given as the first ' +
	                          'argument for mustache#render(template, view, partials)');
	    }
	
	    return defaultWriter.render(template, view, partials);
	  };
	
	  // This is here for backwards compatibility with 0.4.x.,
	  /*eslint-disable */ // eslint wants camel cased function name
	  mustache.to_html = function to_html (template, view, partials, send) {
	    /*eslint-enable*/
	
	    var result = mustache.render(template, view, partials);
	
	    if (isFunction(send)) {
	      send(result);
	    } else {
	      return result;
	    }
	  };
	
	  // Export the escaping function so that the user may override it.
	  // See https://github.com/janl/mustache.js/issues/244
	  mustache.escape = escapeHtml;
	
	  // Export these mainly for testing, but also for advanced usage.
	  mustache.Scanner = Scanner;
	  mustache.Context = Context;
	  mustache.Writer = Writer;
	
	  return mustache;
	}));


/***/ },

/***/ 21:
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },

/***/ 24:
/***/ function(module, exports) {

	module.exports = XMLHttpRequest;


/***/ },

/***/ 25:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// url默认为 `/api/${item}`， method默认为 get
	
	var ifUseAkMyApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-my';
	var ifUseAkProjectApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-project';
	
	var apiOrigin = [
	// my
	'getMyIssueSummary', 'myIssueList', 'getIssueStatus', 'getTodo', 'getTodoCount', 'setIssueStatus',
	// project
	'getProjectNum', 'getProjectList', 'addWatcher', 'cancleWatcher', 'getPermission',
	// companySwitch
	'setUserChooseRegion',
	// companyMemberSetting
	'company/memberList', 'invitationList', 'refusedList', 'waitingForApprovalList',
	// query process of generating code by template
	'queryProcessOfGenerateCode',
	// get all code template
	'getCodeTemplate',
	// search git by name
	'searchGitByName', 'rammember', {
	  name: 'ramSync',
	  id: 'ramSync',
	  method: 'POST',
	  urls: '/api/ramSync'
	}, {
	  name: 'addRamMember',
	  id: 'addRamMember',
	  method: 'POST',
	  urls: '/api/addRamMember'
	}, {
	  name: 'billingStatus',
	  id: 'billingStatus',
	  method: 'GET',
	  urls: '/api/billingStatus'
	}, {
	  name: 'memberQuotaRemain',
	  id: 'memberQuotaRemain',
	  method: 'GET',
	  urls: '/api/memberQuotaRemain'
	}, {
	  name: 'memberQuotaRemainWithExtraNumber',
	  id: 'memberQuotaRemainWithExtraNumber',
	  method: 'GET',
	  urls: '/api/memberQuotaRemainWithExtraNumber'
	}, {
	  name: 'convertBillingPolicy',
	  id: 'convertBillingPolicy',
	  method: 'POST',
	  urls: '/api/convertBillingPolicy'
	}, {
	  name: 'getSupportPlanStatus',
	  id: 'getSupportPlanStatus',
	  method: 'GET',
	  urls: '/api/supportPlanStatus'
	}, {
	  name: 'ucDoLogin',
	  id: 'ucDoLogin',
	  method: 'POST',
	  urls: '/internal/doLogin'
	}, {
	  name: 'ucDoRegister',
	  id: 'ucDoRegister',
	  method: 'POST',
	  urls: '/internal/doRegister'
	}, {
	  name: 'approveJoinApplication',
	  id: 'approveJoinApplication',
	  method: 'POST',
	  urls: '/api/approveJoinApplication'
	}, {
	  name: 'rejectJoinApplication',
	  id: 'rejectJoinApplication',
	  method: 'POST',
	  urls: '/api/rejectJoinApplication'
	},
	// search member
	'showProjectMember', {
	  name: 'showProjectMember',
	  id: 'showProjectMember',
	  method: 'GET',
	  urls: '/api/showProjectMember'
	},
	// search project for program
	'searchForRelation',
	// get project custom fields
	'getCustomField', 'getCustomOption', 'getTaobaoBattleField', 'joinCode',
	// companyJoin
	'company/basicInfo', 'inviteLinkStatus', {
	  name: 'getUserProfile',
	  id: 'getUserProfile',
	  method: 'GET',
	  urls: ifUseAkMyApi ? '/user/profile' : '/api/user/profile'
	}, {
	  name: 'setUserProfile',
	  id: 'setUserProfile',
	  method: 'POST',
	  urls: '/api/user/profile'
	}, {
	  name: 'submitCompanyJoinApply',
	  id: 'submitCompanyJoinApply',
	  method: 'POST',
	  urls: '/api/submitCompanyJoinApply'
	}, {
	  name: 'removeMember',
	  id: 'removeMember',
	  method: 'POST',
	  urls: '/api/company/removeMember'
	}, {
	  name: 'setAdmin',
	  id: 'setAdmin',
	  method: 'POST',
	  urls: '/api/company/setAdmin'
	}, {
	  name: 'cancelAdmin',
	  id: 'cancelAdmin',
	  method: 'POST',
	  urls: '/api/company/cancelAdmin'
	}, {
	  name: 'inviteMember',
	  id: 'inviteMember',
	  method: 'POST',
	  urls: '/api/company/invite'
	}, {
	  name: 'checkProjectName',
	  id: 'checkProjectName',
	  method: 'POST',
	  urls: '/api/checkProjectName'
	}, {
	  name: 'updateProject',
	  id: 'updateProject',
	  method: 'POST',
	  urls: '/api/updateProject'
	}, {
	  name: 'createGroup',
	  id: 'createGroup',
	  method: 'POST',
	  urls: '/api/createGroup'
	}, {
	  name: 'quickNewRepo',
	  id: 'quickNewRepo',
	  method: 'POST',
	  urls: '/api/quickNewRepo'
	}, {
	  name: 'quickNewProject',
	  id: 'quickNewProject',
	  method: 'POST',
	  urls: '/api/quickNewProject'
	}, {
	  name: 'quickNewCodeByTemplateAndRepo',
	  id: 'quickNewCodeByTemplateAndRepo',
	  method: 'POST',
	  urls: '/api/quickNewCodeByTemplateAndRepo'
	}, {
	  name: 'createApplication',
	  id: 'createApplication',
	  method: 'POST',
	  urls: '/api/createApplication'
	},
	// companyCreate
	'region/searchRegion', {
	  name: 'createNewCompany',
	  id: 'createNewCompany',
	  method: 'POST',
	  urls: '/api/region/new'
	}, 'user/profile', 'company/basicInfo', {
	  name: 'updateUserProfile',
	  id: 'updateUserProfile',
	  method: 'POST',
	  urls: '/api/user/profile'
	},
	// admin/dockerAccount
	{
	  name: 'createNewConfigItem',
	  id: 'createNewConfigItem',
	  method: 'POST',
	  urls: '/api/admin/createNewConfigItem'
	}, {
	  name: 'deleteConfigItem',
	  id: 'deleteConfigItem',
	  method: 'POST',
	  urls: '/api/admin/deleteConfigItem'
	}, {
	  name: 'getConfigItemByRegion',
	  id: 'getConfigItemByRegion',
	  method: 'GET',
	  urls: '/api/admin/getConfigItemByRegion'
	}, {
	  name: 'getConfigItemByName',
	  id: 'getConfigItemByName',
	  method: 'GET',
	  urls: '/api/admin/getConfigItemByName'
	}, {
	  name: 'getContainerCertificate',
	  id: 'getContainerCertificate',
	  method: 'GET',
	  urls: '/api/admin/getContainerCertificate'
	}, {
	  name: 'importContainerCertificate',
	  id: 'importContainerCertificate',
	  method: 'POST',
	  urls: '/api/admin/importContainerCertificate'
	}, {
	  name: 'deleteContainerCertificate',
	  id: 'deleteContainerCertificate',
	  method: 'POST',
	  urls: '/api/admin/deleteContainerCertificate'
	},
	// project/addGroup
	{
	  name: 'newPortfolio',
	  id: 'newPortfolio',
	  method: 'POST',
	  urls: '/api/newPortfolio'
	}, {
	  name: 'bindRepo',
	  id: 'bindRepo',
	  method: 'POST',
	  urls: '/api/user/bindRepo'
	}, {
	  name: 'writeReleaseFile',
	  id: 'writeReleaseFile',
	  method: 'POST',
	  urls: '/api/writeReleaseFileToGitRepo'
	},
	
	// portfolio
	'portfolioTree', 'portfolioSubTree', 'getPortfolioMiniInfo', 'listSubPortfolios', 'getRiskList', 'getRiskSummary', {
	  name: 'addRelatedComponents',
	  id: 'addRelatedComponents',
	  method: 'POST',
	  urls: '/api/addRelatedComponents'
	}, {
	  name: 'quickNewSprint',
	  id: 'quickNewSprint',
	  method: 'POST',
	  urls: '/api/quickNewSprint'
	},
	// 根据应用id，申请机器和临时环境，返回异步任务的id
	{
	  name: 'configMachine',
	  id: 'configMachine',
	  method: 'POST',
	  urls: '/api/configMachine'
	},
	// 根据申请机器和临时环境的任务id，查询任务的执行进度
	'queryProcessOfConfigMachine',
	// 根据创建应用的任务id，轮询任务的执行状态
	'queryProcessOfCreateApp',
	// 根据应用id,开启日常环境的构建和部署
	{
	  name: 'startApplicationFlowWithTrunk',
	  id: 'startApplicationFlowWithTrunk',
	  method: 'POST',
	  urls: '/api/startApplicationFlowWithTrunk'
	},
	// 根据应用id,查询流水线类型
	{
	  name: 'getIsSystemInDiyPipelineMode',
	  id: 'getIsSystemInDiyPipelineMode',
	  method: 'GET',
	  urls: '/api/isSystemInDiyPipelineMode'
	},
	// 增加项目成员
	{
	  name: 'addMembers',
	  id: 'addMembers',
	  method: 'POST',
	  urls: '/api/addMembers'
	}, 'getFlowInstDetail', 'getProjectInfo',
	// 开启scrum
	{
	  name: 'openScrum',
	  id: 'openScrum',
	  method: 'POST',
	  urls: '/api/openScrum'
	},
	// 校验应用的名称是否合法
	'checkAppNameValid',
	// 查询关联的项目
	'getSpaceList', 'getRiskRiseShowType', {
	  name: 'setRiskRiseShowType',
	  id: 'setRiskRiseShowType',
	  method: 'POST',
	  urls: '/api/setRiskRiseShowType'
	}, {
	  name: 'getCrpRrojectList',
	  id: 'getCrpRrojectList',
	  method: 'GET',
	  urls: '/crp/getCrpRrojectList'
	}, {
	  name: 'migrateCrpRrojectList',
	  id: 'migrateCrpRrojectList',
	  method: 'POST',
	  urls: '/crp/migrationCrpRrojectList'
	}, {
	  name: 'getCrpUserList',
	  id: 'getCrpUserList',
	  method: 'GET',
	  urls: '/crp/getCrpUserList'
	}, {
	  name: 'migrateCrpUserList',
	  id: 'migrateCrpUserList',
	  method: 'POST',
	  urls: '/crp/migrationCrpUserList'
	}, {
	  name: 'getCrpGitGroupList',
	  id: 'getCrpGitGroupList',
	  method: 'GET',
	  urls: '/crp/getCrpGitGroupList'
	}, {
	  name: 'migrateCrpGitGroupList',
	  id: 'migrateCrpGitGroupList',
	  method: 'POST',
	  urls: '/crp/migrationCrpGitGroupList'
	}, {
	  name: 'getCrpGitUrlList',
	  id: 'getCrpGitUrlList',
	  method: 'GET',
	  urls: '/crp/getCrpGitUrlList'
	}, {
	  name: 'migrateCrpGitUrlList',
	  id: 'migrateCrpGitUrlList',
	  method: 'POST',
	  urls: '/crp/migrationCrpGitUrlList'
	}, {
	  name: 'getCrpMachineList',
	  id: 'getCrpMachineList',
	  method: 'GET',
	  urls: '/crp/getCrpMachineList'
	}, {
	  name: 'migrateCrpMachineList',
	  id: 'migrateCrpMachineList',
	  method: 'POST',
	  urls: '/crp/migrationCrpMachineList'
	}, {
	  name: 'checkRepoMasterAccess',
	  id: 'checkRepoMasterAccess',
	  method: 'GET',
	  urls: '/api/checkRepoMasterAccess'
	},
	/*
	 * created by chifan.sdd
	 * 项目的后台设置
	 * */
	// 项目设置-基本设置
	'getProjectInfo', 'getProjectInfoForDelete', 'getCustomField', 'searchProduct', 'searchParentSpaces', 'searchProSet', 'searchPortfolio', 'getDefaultSpaceIcons', 'searchForRelation', 'searchNewProduct', {
	  name: 'updateProject',
	  id: 'updateProject',
	  method: 'POST',
	  urls: '/api/updateProject'
	}, {
	  name: 'deleteProject',
	  id: 'deleteProject',
	  method: 'POST',
	  urls: '/api/deleteProject'
	}, {
	  name: 'cancelTaskForDelete',
	  id: 'cancelTaskForDelete',
	  method: 'POST',
	  urls: '/api/cancelTaskForDelete'
	}, {
	  name: 'updatePortfolio',
	  id: 'updatePortfolio',
	  method: 'POST',
	  urls: '/api/updatePortfolio'
	}, {
	  name: 'addWatcher',
	  id: 'addWatcher',
	  method: 'POST',
	  urls: '/api/addWatcher'
	}, {
	  name: 'cancleWatcher',
	  id: 'cancleWatcher',
	  method: 'POST',
	  urls: '/api/cancleWatcher'
	}, {
	  name: 'setProjectActived',
	  id: 'setProjectActived',
	  method: 'POST',
	  urls: '/api/active'
	}, {
	  name: 'setProjectArchived',
	  id: 'setProjectArchived',
	  method: 'POST',
	  urls: '/api/archive'
	},
	// 项目设置-成员
	'getMembersForEdit', 'listMembersForCollab', 'getProjectRolesForEdit', 'getProjectRoles', 'searchBreadList', 'exportMembers', 'getMemberInfo', 'getPermissionSettingInProject', {
	  name: 'addRoleByName',
	  id: 'addRoleByName',
	  method: 'POST',
	  urls: '/api/addRoleByName'
	}, {
	  name: 'updateRolePositionInProject',
	  id: 'updateRolePositionInProject',
	  method: 'POST',
	  urls: '/api/updateRolePositionInProject'
	}, {
	  name: 'updateRoleInProject',
	  id: 'updateRoleInProject',
	  method: 'POST',
	  urls: '/api/updateRoleInProject'
	}, {
	  name: 'updatePermissionInProject',
	  id: 'updatePermissionInProject',
	  method: 'POST',
	  urls: '/api/updatePermissionInProject'
	}, {
	  name: 'updateCustomRoleType',
	  id: 'updateCustomRoleType',
	  method: 'POST',
	  urls: '/api/updateCustomRoleType'
	}, {
	  name: 'addMembers',
	  id: 'addMembers',
	  method: 'POST',
	  urls: '/api/addMembers'
	}, {
	  name: 'deleteMembers',
	  id: 'deleteMembers',
	  method: 'POST',
	  urls: '/api/deleteMembers'
	}, {
	  name: 'addProjectRoles',
	  id: 'addProjectRoles',
	  method: 'POST',
	  urls: '/api/addProjectRoles'
	}, {
	  name: 'deleteProjectRoles',
	  id: 'deleteProjectRoles',
	  method: 'POST',
	  urls: '/api/deleteProjectRoles'
	}, {
	  name: 'updateProjectRole',
	  id: 'updateProjectRole',
	  method: 'POST',
	  urls: '/api/updateProjectRole'
	}, {
	  name: 'importMembers',
	  id: 'importMembers',
	  method: 'POST',
	  urls: '/api/importMembers'
	}, {
	  name: 'editMemRoles',
	  id: 'editMemRoles',
	  method: 'POST',
	  urls: '/api/editMemRoles'
	},
	// 项目设置-公告
	'getNotice', {
	  name: 'updateNotice',
	  id: 'updateNotice',
	  method: 'POST',
	  urls: '/api/updateNotice'
	},
	// 项目设置-版本
	'getVersionDetail', 'searchForEdit', {
	  name: 'getVersionListOfProject',
	  id: 'getVersionListOfProject',
	  method: 'GET',
	  urls: '/api/getvListOfProject'
	}, {
	  name: 'getVersionListByParent',
	  id: 'getVersionListByParent',
	  method: 'GET',
	  urls: '/api/getListByParent'
	}, {
	  name: 'deleteVersion',
	  id: 'deleteVersion',
	  method: 'POST',
	  urls: '/api/deleteVersion'
	}, {
	  name: 'createVersion',
	  id: 'createVersion',
	  method: 'POST',
	  urls: '/api/newProVersion'
	}, {
	  name: 'updateVersion',
	  id: 'updateVersion',
	  method: 'POST',
	  urls: '/api/updateProVersion'
	},
	// 项目设置-服务
	'getServices', {
	  name: 'getMyServices',
	  id: 'getMyServices',
	  method: 'GET',
	  urls: ifUseAkMyApi ? '/service/list' : '/api/getMyServices'
	}, {
	  name: 'configSpaceService',
	  id: 'configSpaceService',
	  method: 'POST',
	  urls: '/api/configSpaceService'
	}, {
	  name: 'configMyService',
	  id: 'configMyService',
	  method: 'POST',
	  urls: ifUseAkMyApi ? '/service/config' : '/api/configMyService'
	}, {
	  name: 'sortServices',
	  id: 'sortServices',
	  method: 'POST',
	  urls: '/api/sortServices'
	}, {
	  name: 'sortMyServices',
	  id: 'sortMyServices',
	  method: 'POST',
	  urls: ifUseAkMyApi ? '/service/sort' : '/api/sortMyServices'
	},
	// 项目设置-模块
	'getModuleTree', 'subModuleTree', 'getModuleDetail', 'checkPermission', 'getParentProject', 'inheritModuleTree', 'inheritSubModuleTree', 'getInheritModuleIds', // 获取已选中的ids
	{
	  name: 'searchModules',
	  id: 'searchModules',
	  method: 'GET',
	  urls: '/api/parentModules'
	}, {
	  name: 'deleteModule',
	  id: 'deleteModule',
	  method: 'POST',
	  urls: '/api/deleteModule'
	}, {
	  name: 'createModule',
	  id: 'createModule',
	  method: 'POST',
	  urls: '/api/createModule'
	}, {
	  name: 'updateModule',
	  id: 'updateModule',
	  method: 'POST',
	  urls: '/api/updateModule'
	}, {
	  name: 'updateModuleOwner',
	  id: 'updateModuleOwner',
	  method: 'POST',
	  urls: '/api/updateModuleOwner'
	}, {
	  name: 'saveInheritModules',
	  id: 'saveInheritModules',
	  method: 'POST',
	  urls: '/api/saveInheritModules'
	}, {
	  name: 'inheritParent',
	  id: 'inheritParent',
	  method: 'POST',
	  urls: '/api/inheritParent'
	},
	// 项目设置-里程碑
	'getLMList', 'getModules', 'getLMDetail', {
	  name: 'createLandmark',
	  id: 'createLandmark',
	  method: 'POST',
	  urls: '/api/createLandmark'
	}, {
	  name: 'updateLandmark',
	  id: 'updateLandmark',
	  method: 'POST',
	  urls: '/api/updateLandmark'
	}, 'checkPermissionToAddProjectInDivision', {
	  name: 'createSpace',
	  id: 'createSpace',
	  method: 'POST',
	  urls: '/api/createSpace'
	}, {
	  name: 'selectGlobalRegionByGuid',
	  id: 'selectGlobalRegionByGuid',
	  method: 'GET',
	  urls: '/api/selectGlobalRegionByGuid'
	}, {
	  name: 'initiateCollabProject',
	  id: 'initiateCollabProject',
	  method: 'POST',
	  urls: '/api/initiateCollabProject'
	}, {
	  name: 'participateCollabProject',
	  id: 'participateCollabProject',
	  method: 'POST',
	  urls: '/api/participateCollabProject'
	}, {
	  name: 'generateInviteCode',
	  id: 'generateInviteCode',
	  method: 'POST',
	  urls: '/api/generateInviteCode'
	}, {
	  name: 'getProjectByInviteCode',
	  id: 'getProjectByInviteCode',
	  method: 'GET',
	  urls: '/api/getProjectByInviteCode'
	},
	// 新建项目获取自定义字段
	'getProjectTemplateForCreate', {
	  name: 'ucSendValidationEmail',
	  id: 'ucSendValidationEmail',
	  method: 'POST',
	  type: 'text',
	  urls: '/user/profile/sendValidationEmail'
	}, {
	  name: 'updateEmailWithValidationCode',
	  id: 'updateEmailWithValidationCode',
	  method: 'POST',
	  urls: '/user/profile/updateEmailWithValidationCode'
	}, {
	  name: 'postUserProfile',
	  id: 'postUserProfile',
	  method: ifUseAkMyApi ? 'PUT' : 'POST',
	  urls: ifUseAkMyApi ? '/user/profile' : '/api/user/profile'
	}, {
	  name: 'resetPassword',
	  id: 'resetPassword',
	  method: 'POST',
	  urls: '/internal/resetPassword'
	}, {
	  name: 'updateLoginType',
	  id: 'updateLoginType',
	  method: 'POST',
	  urls: '/system/updateLoginType'
	}, {
	  name: 'setRegionUserOutSource',
	  id: 'setRegionUserOutSource',
	  method: 'POST',
	  urls: '/api/setRegionUserOutSource'
	}, {
	  name: 'setRegionUserFulltime',
	  id: 'setRegionUserFulltime',
	  method: 'POST',
	  urls: '/api/setRegionUserFulltime'
	}, 'user/profile', {
	  name: 'getCollabProjectSetting',
	  id: 'getCollabProjectSetting',
	  method: 'GET',
	  urls: '/api/getCollabProjectSetting'
	}, {
	  name: 'setProjectCollab',
	  id: 'setProjectCollab',
	  method: 'POST',
	  urls: '/api/setProjectCollab'
	}, {
	  name: 'syncHistoryDataToCollabProject',
	  id: 'syncHistoryDataToCollabProject',
	  method: 'POST',
	  urls: '/api/collab/project/syncHistoryDataToCollabProject'
	}, 'getDingtalkSerialNumber',
	
	// 获取企业构建物配置内容
	'getCompanyBuildPackageConfig', {
	  name: '获取企业构建物配置内容',
	  id: 'getCompanyBuildPackageConfig',
	  method: 'get',
	  urls: '/api/service/company/buildPackage/config'
	},
	// 更新企业构建物配置
	'updateCompanyBuildPackageConfig', {
	  name: '更新企业配置',
	  id: 'updateCompanyBuildPackageConfig',
	  method: 'get',
	  urls: '/api/service/company/buildPackage/config/updateConfig'
	},
	// 获取企业应用构建物信息
	'getAppBuildPackageDetail', {
	  name: '获取企业应用构建物信息',
	  id: 'getAppBuildPackageDetail',
	  method: 'get',
	  urls: '/api/service/company/buildPackage/package/detail'
	}, {
	  name: '获取某成员在某企业下的权限',
	  id: 'permissionList',
	  method: 'get',
	  urls: '/api/company/permissionList'
	}, {
	  name: 'getIssueType',
	  id: 'getIssueType',
	  method: 'get',
	  urls: '/setting/issue/type/detail'
	}, {
	  name: '获取规则的列表',
	  id: 'getRuleList',
	  method: 'get',
	  urls: '/rule/list'
	}, {
	  name: '获取状态信息',
	  id: 'searchStatus',
	  method: 'get',
	  urls: '/v3/issue/status/search'
	}, {
	  name: '获取项目下过滤面板的自定义属性列表',
	  id: 'getColumns',
	  method: 'get',
	  urls: '/v3/issue/getColumns'
	}, {
	  name: '获取用户信息',
	  id: 'getUserById',
	  method: 'get',
	  urls: '/admin/user/getUserById'
	}, {
	  name: '获取规则详情',
	  id: 'getRuleDetail',
	  method: 'get',
	  urls: '/rule/detail'
	}, {
	  name: '规则保存',
	  id: 'saveRule',
	  method: 'post',
	  urls: '/rule/save'
	}, {
	  name: '规则删除',
	  id: 'deleteRule',
	  method: 'post',
	  urls: '/rule/delete'
	}, {
	  name: '规则继承字段保存',
	  id: 'saveInherit',
	  method: 'post',
	  urls: '/rule/config/save'
	}, {
	  name: '更新规则的启用字段',
	  id: 'updateRuleEnable',
	  method: 'post',
	  urls: '/rule/config/enable'
	}, {
	  name: '规则继承字段获取',
	  id: 'getInherit',
	  method: 'get',
	  urls: '/rule/config/getInherit'
	},
	// 里程碑计划
	{
	  name: '项目集里程碑计划视图获取根节点项目集信息',
	  id: 'getProjectSetForMilestonePlan',
	  method: 'get',
	  urls: '/api/getProjectSetForMilestonePlan'
	}, {
	  name: '项目集里程碑计划视图获取关联项目信息',
	  id: 'getRelatedProjectsForMilestonePlan',
	  method: 'get',
	  urls: '/api/getRelatedProjectsForMilestonePlan'
	}, {
	  name: '项目集里程碑计划视图获取关联项目子节点信息',
	  id: 'getSubRelatedProjectsForMilestonePlan',
	  method: 'get',
	  urls: '/api/getSubRelatedProjectsForMilestonePlan'
	}, {
	  name: '父项目里程碑计划视图获取根节点父项目信息',
	  id: 'getParentProjectForMilestonePlan',
	  method: 'get',
	  urls: '/api/getParentProjectForMilestonePlan'
	}, {
	  name: '父项目里程碑计划视图获取子项目信息',
	  id: 'getChildProjectsForMilestonePlan',
	  method: 'get',
	  urls: '/api/getChildProjectsForMilestonePlan'
	}, {
	  name: '父项目里程碑计划视图获取子节点项目信息',
	  id: 'getSubChildProjectsForMilestonePlan',
	  method: 'get',
	  urls: '/api/getSubChildProjectsForMilestonePlan'
	
	}, {
	  name: '关联项目里程碑计划视图获取上次使用的过滤器',
	  id: 'getMilestoneRelatedProjectLastFilter',
	  method: 'get',
	  urls: '/api/getMilestoneRelatedProjectLastFilter'
	}, {
	  name: '父项目里程碑计划视图获取上次使用的过滤器',
	  id: 'getMilestoneChildProjectLastFilter',
	  method: 'get',
	  urls: '/api/getMilestoneChildProjectLastFilter'
	}, {
	  name: '关联项目里程碑计划视图获取显示列',
	  id: 'getMilestoneRelatedProjectColumnSetting',
	  method: 'get',
	  urls: '/api/getMilestoneRelatedProjectColumnSetting'
	}, {
	  name: '父项目里程碑计划视图获取显示列',
	  id: 'getMilestoneChildProjectColumnSetting',
	  method: 'get',
	  urls: '/api/getMilestoneChildProjectColumnSetting'
	}, {
	  name: '关联项目里程碑计划视图获取显示列',
	  id: 'milestoneRelatedProjectSaveColumn',
	  method: 'post',
	  urls: '/api/milestoneRelatedProjectSaveColumn'
	}, {
	  name: '父项目里程碑计划视图获取显示列',
	  id: 'milestoneChildProjectSaveColumn',
	  method: 'get',
	  urls: '/api/milestoneChildProjectSaveColumn'
	}, {
	  name: '里程碑计划视图设置根节点是否展开',
	  id: 'setMilestoneProjectRootNodeOpen',
	  method: 'post',
	  urls: '/api/setMilestoneProjectRootNodeOpen'
	}, {
	  name: '重置特定角色的项目成员',
	  id: 'resetProjectMembersByRole',
	  method: 'post',
	  urls: '/api/resetProjectMembersByRole'
	}, {
	  name: '获取支持的部署系统列表',
	  id: 'availableDeployOptions',
	  method: 'get',
	  urls: '/ec/ajax/availableDeployOptions'
	}, {
	  name: '购买ECS机器',
	  id: 'buyEcsMachine',
	  method: 'post',
	  urls: '/expand/service/company/buyEcsMachine'
	}, {
	  name: '查询机器状态',
	  id: 'getEcsMachineStatus',
	  method: 'get',
	  urls: '/expand/service/company/getEcsMachineStatus'
	}, {
	  name: '获取用户配置的第三方代码库',
	  id: 'getThirdCodeRepoList',
	  method: 'get',
	  urls: '/api/service/getThirdCodeReopList'
	}, {
	  name: '获取当前企业的授权信息',
	  id: 'getRamAuthorization',
	  method: 'get',
	  urls: '/expand/service/company/ram/authorization/detail'
	}, {
	  name: 'ram云效授权',
	  id: 'addRdcRamAuthorization',
	  method: 'post',
	  urls: '/expand/service/company/ram/authorization/add'
	}, {
	  name: 'ram云效重新授权',
	  id: 'updateRdcRamAuthorization',
	  method: 'post',
	  urls: '/expand/service/company/ram/authorization/update'
	}, {
	  name: '删除ram云效授权',
	  id: 'deleteRdcRamAuthorization',
	  method: 'post',
	  urls: '/expand/service/company/ram/authorization/delete'
	}, {
	  name: '检查ram是否有默认授权账户',
	  id: 'checkRdcRamAuthorization',
	  method: 'get',
	  urls: '/expand/service/company/ram/authorization/check'
	}, {
	  name: '获取过滤器的数据',
	  id: 'getFilterBoard',
	  method: 'get',
	  urls: '/v3/issue/getFilterBoard'
	},
	// 获取镜像模板列表
	'getImageTemplateList', {
	  name: 'getBlackBoard',
	  id: 'getBlackBoard',
	  method: 'get',
	  urls: ifUseAkMyApi ? '/news/list' : '/api/getBlackBoard'
	}, 'getMyWatched', 'getBranch', {
	  name: '获取镜像模板列表',
	  id: 'getImageTemplateList',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getImageTemplateList'
	},
	// 删除镜像模板
	'delEcsTemplate', {
	  name: '删除镜像模板',
	  id: 'delEcsTemplate',
	  method: 'post',
	  urls: '/expand/service/company/ecsTemplateManage/delEcsTemplate'
	},
	// 添加镜像模板
	'addEcsTemplate', {
	  name: '添加镜像模板',
	  id: 'addEcsTemplate',
	  method: 'post',
	  urls: '/expand/service/company/ecsTemplateManage/addEcsTemplate'
	},
	// 更新镜像模板
	'updateEcsTemplate', {
	  name: '更新镜像模板',
	  id: 'updateEcsTemplate',
	  method: 'post',
	  urls: '/expand/service/company/ecsTemplateManage/updateEcsTemplate'
	},
	// 根据id获取EcsTemplate
	'fetchEcsTemplate', {
	  name: '根据ID获取EcsTemplate',
	  id: 'fetchEcsTemplate',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/fetchEcsTemplate'
	}, 'getImageByRegion', {
	  name: '获取当前region下的image',
	  id: 'getImageByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getImageByRegion'
	}, 'getSecurityGroupByRegion', {
	  name: '获取当前region下的安全组',
	  id: 'getSecurityGroupByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getSecurityGroupByRegion'
	}, 'getVpcByRegion', {
	  name: '获取当前region下的vpc',
	  id: 'getVpcByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getVpcByRegion'
	}, 'getVswitchByRegion', {
	  name: '获取当前region下的vSwitch',
	  id: 'getVswitchByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getVswitchByRegion'
	}, 'getResourceSpecificationByRegion', {
	  name: '获取资源你规格',
	  id: 'getResourceSpecificationByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getResourceSpecificationByRegion'
	}, 'getRegionMachines', {
	  name: '获取当前企业下机器列表',
	  id: 'getRegionMachines',
	  method: 'get',
	  urls: '/expand/service/company/machine/getRegionMachines'
	}, 'getAddMachineCommand', {
	  name: '获取添加机器命令',
	  id: 'getAddMachineCommand',
	  method: 'get',
	  urls: '/expand/service/company/machine/getAddMachineCommand'
	}, 'updateMachine', {
	  name: '更新机器相关信息',
	  id: 'updateMachine',
	  method: 'post',
	  urls: '/expand/service/company/machine/updateMachine'
	}, 'removeMachine', {
	  name: '删除机器',
	  id: 'removeMachine',
	  method: 'post',
	  urls: '/expand/service/company/machine/removeMachine'
	}, 'getEcsHistoryList', {
	  name: '获取当前企业购买机器历史',
	  id: 'getEcsHistoryList',
	  method: 'get',
	  urls: '/expand/service/company/ecs/getEcsHistoryList'
	}, 'getEcsHistoryById', {
	  name: '获取购买机器状态',
	  id: 'getEcsHistoryById',
	  method: 'get',
	  urls: '/expand/service/company/ecs/getEcsHistoryById'
	}, 'getBuildImageList', {
	  name: '获取当前region下的构建镜像列表',
	  id: 'getBuildImageList',
	  method: 'get',
	  urls: '/api/getBuildImageList'
	}, 'insertBuildImage', {
	  name: '新增构建镜像',
	  id: 'insertBuildImage',
	  method: 'post',
	  urls: '/api/buildImage/insert'
	}, 'updateBuildImage', {
	  name: '更新构建镜像',
	  id: 'updateBuildImage',
	  method: 'post',
	  urls: '/api/buildImage/update'
	}, {
	  name: '导出里程碑',
	  id: 'exportMilestone',
	  method: 'post',
	  urls: '/api/exportMilestone'
	}, 'getResourceSpecificationByRegion', {
	  name: '获取资源规格',
	  id: 'getResourceSpecificationByRegion',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getResourceSpecificationByRegion'
	}, 'getDiskTypeByRegionAndResource', {
	  name: '根据区域和资源规格获取磁盘类型',
	  id: 'getDiskTypeByRegionAndResource',
	  method: 'get',
	  urls: '/expand/service/company/ecsTemplateManage/getDiskTypeByRegionAndResource'
	}, 'getQuota', {
	  name: '获取资源配额情况',
	  id: 'getQuota',
	  method: 'get',
	  urls: '/api/anonymous/getQuota'
	}, 'queryImagePullRecord', {
	  name: '获取镜像下载的情况',
	  id: 'queryImagePullRecord',
	  method: 'get',
	  urls: '/api/buildImage/getRecordList'
	}, {
	  name: '删除里程碑',
	  id: 'deleteMilestone',
	  method: 'post',
	  urls: '/api/deleteMilestone'
	}, {
	  name: '添加到钉钉日历',
	  id: 'addToDingdingCalendar',
	  method: 'get',
	  urls: '/api/addToDingdingCalendar'
	}, {
	  name: '搜索标签',
	  id: 'searchTags',
	  method: 'get',
	  urls: '/api/searchTags'
	}, {
	  name: '添加标签',
	  id: 'newProjectTag',
	  method: 'post',
	  urls: '/api/newProjectTag'
	}, {
	  name: '删除标签',
	  id: 'delTaggingProject',
	  method: 'post',
	  urls: '/api/deleteTag'
	}, {
	  name: '编辑标签',
	  id: 'updateProjectTag',
	  method: 'post',
	  urls: '/api/updateProjectTag'
	}, {
	  name: '分享标签',
	  id: 'shareTags',
	  method: 'post',
	  urls: '/api/shareTags'
	}, 'deleteBuildImage', {
	  name: '删除构建镜像',
	  id: 'deleteBuildImage',
	  method: 'post',
	  urls: '/api/buildImage/delete'
	}, {
	  name: '查询是否支持购买机器',
	  id: 'geBuyEcsSupport',
	  method: 'get',
	  urls: '/expand/service/company/machine/buyEcsSupport'
	}, {
	  name: '搜索项目',
	  id: 'searchProjectList',
	  method: 'get',
	  urls: 'issue/searchProjectList'
	}, {
	  name: '里程碑计划页面子项目列表获取单个项目节点',
	  id: 'childProjectItemForMilestone',
	  method: 'get',
	  urls: '/api/childProjectItemForMilestone'
	}, {
	  name: '里程碑计划页面关联项目列表获取单个项目节点',
	  id: 'relatedProjectItemForMilestone',
	  method: 'get',
	  urls: '/api/relatedProjectItemForMilestone'
	}, {
	  name: '项目资源接口获取分组及投入',
	  id: 'listResourceGroupAndInvestment',
	  method: 'get',
	  urls: '/api/listResourceGroupAndInvestment'
	}, {
	  name: '里程碑计划页面批量更新里程碑计划完成时间',
	  id: 'batchUpdateMilestoneEndDate',
	  method: 'post',
	  urls: '/api/batchUpdateMilestoneEndDate'
	}, {
	  name: '搜索项目标签',
	  id: 'searchProjectTags',
	  method: 'get',
	  urls: '/api/searchTags'
	}, {
	  name: '保存里程碑计划页面过滤器',
	  id: 'saveMilestonePlanFilter',
	  method: 'post',
	  urls: '/api/saveMilestonePlanFilter'
	}, {
	  name: '资源管理隐藏角色分组成员',
	  id: 'resourceHideMembersInRole',
	  method: 'post',
	  urls: '/api/resourceHideMembersInRole'
	}, {
	  name: '资源管理隐藏角色分组',
	  id: 'resourceHideRoleInGroup',
	  method: 'post',
	  urls: '/api/resourceHideRoleInGroup'
	}, {
	  name: '资源管理删除自定义分组成员',
	  id: 'resourceRemoveMemberFromCustomGroup',
	  method: 'post',
	  urls: '/api/resourceRemoveMemberFromCustomGroup'
	}, {
	  name: '资源管理删除自定义分组',
	  id: 'resourceDeleteCustomGroup',
	  method: 'post',
	  urls: '/api/resourceDeleteCustomGroup'
	}, {
	  name: '资源管理添加自定义分组',
	  id: 'resourceAddCustomGroup',
	  method: 'post',
	  urls: '/api/resourceAddCustomGroup'
	}, {
	  name: '资源管理获取用户分组选择',
	  id: 'resourceGetResourceGroupView',
	  method: 'get',
	  urls: '/api/resourceGetResourceGroupView'
	}, {
	  name: '资源管理保存用户分组选择',
	  id: 'resourceSaveResourceGroupView',
	  method: 'post',
	  urls: '/api/resourceSaveResourceGroupView'
	}, {
	  name: '获取被隐藏的角色分组',
	  id: 'resourceListHiddenRoleGroup',
	  method: 'get',
	  urls: '/api/resourceListHiddenRoleGroup'
	}, {
	  name: '获取自定义分组',
	  id: 'resourceGetCustomGroupList',
	  method: 'get',
	  urls: '/api/resourceGetCustomGroupList'
	}, {
	  name: '获取自定义分组可选用户',
	  id: 'resourceGetOptionalMembersForCustomGroup',
	  method: 'get',
	  urls: '/api/resourceGetOptionalMembersForCustomGroup'
	}, {
	  name: '获取角色分组可选用户',
	  id: 'resourceListHiddenMembers',
	  method: 'get',
	  urls: '/api/resourceListHiddenMembers'
	}, {
	  name: '增加角色分组成员',
	  id: 'resourceShowMembersInRole',
	  method: 'post',
	  urls: '/api/resourceShowMembersInRole'
	}, {
	  name: '增加自定义分组成员',
	  id: 'resourceAddMemberToCustomGroup',
	  method: 'post',
	  urls: '/api/resourceAddMemberToCustomGroup'
	}, {
	  name: '编辑自定义分组',
	  id: 'resourceUpdateCustomGroup',
	  method: 'post',
	  urls: '/api/resourceUpdateCustomGroup'
	}, {
	  name: '保存成员投入',
	  id: 'saveResourceMemberInvestment',
	  method: 'post',
	  urls: '/api/saveResourceMemberInvestment'
	}, {
	  name: '删除成员投入',
	  id: 'deleteResourceMemberInvestment',
	  method: 'post',
	  urls: '/api/deleteResourceMemberInvestment'
	}, {
	  name: '获取项目公告列表',
	  id: 'listProjectAnnouncements',
	  method: 'get',
	  urls: '/api/listProjectAnnouncements'
	}, {
	  name: '里程碑计划关联项目显示列配置',
	  id: 'getMilestoneRelatedProjectListColumns',
	  method: 'get',
	  urls: '/api/getMilestoneRelatedProjectListColumns'
	}, {
	  name: '里程碑计划子项目显示列配置',
	  id: 'getMilestoneChildProjectListColumns',
	  method: 'get',
	  urls: '/api/getMilestoneChildProjectListColumns'
	}, {
	  name: '获取用户mini信息',
	  id: 'getUserMiniInfo',
	  method: 'get',
	  urls: '/api/getUserMiniInfo'
	}, {
	  name: '添加关联项目',
	  id: 'addRelatedProjects',
	  method: 'POST',
	  urls: '/api/addRelatedPro'
	}, {
	  name: '获取用户在项目中的权限',
	  id: 'getPermissionInProject',
	  method: 'GET',
	  urls: '/api/getPermissionInProject'
	}, {
	  name: '设置项目需求锁定',
	  id: 'configProjectReqLock',
	  method: 'POST',
	  urls: '/api/configProjectReqLock'
	}, {
	  name: '退出项目',
	  id: 'quitProject',
	  method: 'POST',
	  urls: '/api/quitProject'
	}, {
	  name: '收藏项目',
	  id: 'watchProject',
	  method: 'POST',
	  urls: '/api/addWatcher'
	}, {
	  name: '取消收藏项目',
	  id: 'cancelWatchProject',
	  method: 'POST',
	  urls: '/api/cancleWatcher'
	}, {
	  name: '获取项目信息-概述页',
	  id: 'getProjectDetail',
	  method: 'GET',
	  urls: '/api/getProjectDetail'
	}, {
	  name: '获取立项审批状态',
	  id: 'appInitGetApprovalStatus',
	  method: 'GET',
	  urls: '/api/appInitGetApprovalStatus'
	}, {
	  name: '获取立项模板',
	  id: 'appInitGetTemplate',
	  method: 'GET',
	  urls: '/api/appInitGetTemplate'
	}, {
	  name: '创建立项审批单',
	  id: 'appInitNew',
	  method: 'POST',
	  urls: '/api/appInitNew'
	}, {
	  name: '获取成员列表(概述页)',
	  id: 'getMemberList',
	  method: 'GET',
	  urls: '/api/getMemberList'
	}, {
	  name: '获取项目动态',
	  id: 'getActivities',
	  method: 'GET',
	  urls: '/api/getActivities'
	}, {
	  name: '获取单个项目的里程碑数据',
	  id: 'getLMTimeline',
	  method: 'POST',
	  urls: '/api/getLMTimeline'
	}, {
	  name: '搜索AoneData数据模块',
	  id: 'searchAoneDataInTerm',
	  method: 'get',
	  urls: '/doc/searchAoneDataInTerm'
	}, {
	  name: '获取当前项目下所有关联的词条',
	  id: 'getAllTermsInScope',
	  method: 'get',
	  urls: '/doc/getAllTermsInScope'
	}, {
	  name: '根据词条ID获取当前项目下的引用',
	  id: 'getTermReferenceByTermIdInScope',
	  method: 'get',
	  urls: '/doc/getTermReferenceByTermIdInScope'
	}, {
	  name: '在当前项目下关联词条和引用',
	  id: 'createTermAndAssociateToReference',
	  method: 'POST',
	  urls: '/doc/createTermAndAssociateToReference'
	}, {
	  name: '删除词条',
	  id: 'deleteTerm',
	  method: 'POST',
	  urls: '/doc/deleteTermInScope'
	}, {
	  name: '获取词条引用',
	  id: 'getTermReferenceByTermIdInScope',
	  method: 'get',
	  urls: '/doc/getTermReferenceByTermIdInScope'
	}, {
	  name: '关联项目树根节点',
	  id: 'relatedProjectTree',
	  method: 'POST',
	  urls: '/api/relatedProjectTree'
	}, {
	  name: '子项目树根节点',
	  id: 'childProjectTree',
	  method: 'POST',
	  urls: '/api/childProjectTree'
	}, {
	  name: '关联项目树根节点',
	  id: 'relatedProjectSubTree',
	  method: 'POST',
	  urls: '/api/relatedProjectSubTree'
	}, {
	  name: '子项目树子节点',
	  id: 'childProjectSubTree',
	  method: 'POST',
	  urls: '/api/childProjectSubTree'
	}, {
	  name: '概述页获取变更列表',
	  id: 'searchCRList',
	  method: 'get',
	  urls: '/ec/ajax/base/service/search'
	}, {
	  name: '概述页变更列表获取成员信息',
	  id: 'getCRListUsers',
	  method: 'POST',
	  urls: '/ec/ajax/users'
	}, {
	  name: '概述页变更环形图数据',
	  id: 'getCRChart',
	  method: 'get',
	  urls: '/ec/ajax/project/kelude/cr/charts'
	}, {
	  name: '概述页Aone2变更项目环境查询',
	  id: 'queryAone2Env',
	  method: 'get',
	  urls: '/ec/ajax/aone2/test/env/query'
	}, {
	  name: '概述页新版变更项目环境查询',
	  id: 'queryEnv',
	  method: 'get',
	  urls: '/ec/ajax/test/env/query'
	}, {
	  name: 'listK8sCluster',
	  id: 'listK8sCluster',
	  method: 'GET',
	  urls: '/api/admin/listK8sCluster'
	}, {
	  name: 'importK8sClusterCert',
	  id: 'importK8sClusterCert',
	  method: 'POST',
	  urls: '/api/admin/importK8sClusterCert'
	}, {
	  name: 'removeK8sCluster',
	  id: 'removeK8sCluster',
	  method: 'POST',
	  urls: '/api/admin/removeK8sCluster'
	}, {
	  name: '概述页布局配置弹框获取布局信息',
	  id: 'getPanelSetting',
	  method: 'get',
	  urls: '/api/getPanelSetting'
	}, {
	  name: '保存概述页布局配置',
	  id: 'savePanelSetting',
	  method: 'POST',
	  urls: '/api/savePanelSetting'
	}, {
	  name: '概述页获取布局配置',
	  id: 'getOrderedPanels',
	  method: 'get',
	  urls: '/api/getOrderedPanels'
	}, {
	  name: '获取aone2的项目id',
	  id: 'getAone2Id',
	  method: 'get',
	  urls: '/api/getAone2Id'
	}, {
	  name: '记录最近访问的项目',
	  id: 'recordRecentVisit',
	  method: 'post',
	  urls: '/api/recordRecentVisit'
	}, {
	  name: '查询私有云代理机列表',
	  id: 'listPrivateProxyMachine',
	  method: 'get',
	  urls: '/expand/service/company/machine/listPrivateProxyMachine'
	}, {
	  name: '查询私有云代理机',
	  id: 'getPrivateProxyMachine',
	  method: 'get',
	  urls: '/expand/service/company/machine/getPrivateProxyMachine'
	}, {
	  name: '查询私有云代理机列表',
	  id: 'addPrivateProxyMachine',
	  method: 'post',
	  urls: '/expand/service/company/machine/addPrivateProxyMachine'
	}, {
	  name: '查询私有云代理机列表',
	  id: 'updatePrivateProxyMachine',
	  method: 'post',
	  urls: '/expand/service/company/machine/updatePrivateProxyMachine'
	}, {
	  name: '查询私有云代理机列表',
	  id: 'delPrivateProxyMachine',
	  method: 'post',
	  urls: '/expand/service/company/machine/delPrivateProxyMachine'
	}, {
	  name: '保存手动导入的集群',
	  id: 'saveManualInputK8sCluster',
	  method: 'post',
	  urls: '/api/admin/saveManualInputK8sCluster'
	}, {
	  name: '获取关联项目列表的过滤条件',
	  id: 'relatedProjectListFilter',
	  method: 'get',
	  urls: '/api/lastFilter'
	}, {
	  name: '获取子项目列表的过滤条件',
	  id: 'childProjectListFilter',
	  method: 'get',
	  urls: '/api/childProjectLastFilter'
	}, {
	  name: '项目列表过滤器',
	  id: 'simpleFilters',
	  method: 'get',
	  urls: '/api/simpleFilters'
	}, {
	  name: '根据代码地址获取开发模式',
	  id: 'getDevModelByCodeModule',
	  method: 'get',
	  urls: '/api/getDevModelByCodeModule'
	}, {
	  name: '查看git组是否存在',
	  id: 'checkGitGroupExist',
	  method: 'get',
	  urls: '/api/checkGitGroupExist'
	}, {
	  name: '获取甘特图根节点',
	  id: 'getGanttTreeRoot',
	  method: 'get',
	  urls: '/api/getGanttTreeRoot'
	}, {
	  name: '获取甘特图子节点',
	  id: 'getGanttSubNode',
	  method: 'get',
	  urls: '/api/getGanttSubNode'
	}, {
	  name: '获取甘特图显示列',
	  id: 'getGanttColumns',
	  method: 'get',
	  urls: '/api/getGanttColumns'
	}, {
	  name: '保存甘特图显示列',
	  id: 'saveGanttColumns',
	  method: 'post',
	  urls: '/api/saveGanttColumns'
	}, {
	  name: '保存甘特图过滤器',
	  id: 'saveGanttFilter',
	  method: 'get',
	  urls: '/api/saveGanttFilter'
	}, {
	  name: '获取甘特图过滤器',
	  id: 'getGanttFilter',
	  method: 'get',
	  urls: '/api/getGanttFilter'
	}, {
	  name: '获取里程碑计划上次访问的视图模式',
	  id: 'getGanttLastView',
	  method: 'get',
	  urls: '/api/getGanttLastView'
	}, {
	  name: '保存里程碑计划上次访问的视图模式',
	  id: 'saveGanttView',
	  method: 'post',
	  urls: '/api/saveGanttView'
	}, {
	  name: '获取甘特图上的单个树节点',
	  id: 'getGanttTreeNode',
	  method: 'get',
	  urls: '/api/getGanttTreeNode'
	}, {
	  name: '获取甘特图规划页任务列表',
	  id: 'ganttPlanning',
	  method: 'get',
	  urls: '/api/ganttPlanning'
	}, {
	  name: '获取甘特图规划页任务列表子节点',
	  id: 'ganttPlanningSubNodes',
	  method: 'get',
	  urls: '/api/ganttPlanningSubNodes'
	}, {
	  name: '保存甘特图规划',
	  id: 'addToGantt',
	  method: 'get',
	  urls: '/api/addToGantt'
	}, {
	  name: '更新甘特图上的工作项', // 不仅仅甘特在使用，里程碑更新工作项也在使用
	  id: 'updateIssueForGantt',
	  method: 'post',
	  urls: '/api/updateIssueForGantt'
	}, {
	  name: '查看region下的所有docker认证信息',
	  id: 'getDockerAccountList',
	  method: 'get',
	  urls: '/dockerAccount/list'
	}, {
	  name: '增加docker账号密码认证信息',
	  id: 'addDockerAccount',
	  method: 'post',
	  urls: '/dockerAccount/add'
	}, {
	  name: '删除docker账号密码认证信息',
	  id: 'removeDockerAccount',
	  method: 'post',
	  urls: '/dockerAccount/delete'
	}, {
	  name: '更新docker账号密码认证信息',
	  id: 'updateDockerAccount',
	  method: 'post',
	  urls: '/dockerAccount/update'
	}, {
	  name: '获取当前企业所有可用的镜像仓库region信息',
	  id: 'getDockerRegistryRegionList',
	  method: 'get',
	  urls: '/dockerRegistry/region/list'
	}, {
	  name: '搜索标签',
	  id: 'searchTags',
	  method: 'get',
	  urls: '/api/tag/searchTags'
	}, {
	  name: '打标签',
	  id: 'taggingProject',
	  method: 'post',
	  urls: '/api/tag/taggingProject'
	}, {
	  name: '修改标签标签',
	  id: 'updateTag',
	  method: 'post',
	  urls: '/api/tag/updateProjectTag'
	}, {
	  name: '取消标签',
	  id: 'removeTaggingProject',
	  method: 'post',
	  urls: '/api/tag/delTaggingProject'
	}, {
	  name: '新建标签',
	  id: 'newProjectTag',
	  method: 'post',
	  urls: '/api/tag/newProjectTag'
	}, {
	  name: '获取当前企业region下所有的镜像仓库',
	  id: 'getDockerRegistryRegionRepoList',
	  method: 'get',
	  urls: '/dockerRegistry/repo/list'
	}, {
	  name: '关联项目列表配置显示列',
	  id: 'relatedProSaveColumn',
	  method: 'post',
	  urls: '/api/saveColSetting'
	}, {
	  name: '关联项目列表获取显示列配置',
	  id: 'relatedProGetColSetting',
	  method: 'get',
	  urls: '/api/relatedProjectListColumns'
	}, {
	  name: '子项目列表配置显示列',
	  id: 'childProSaveColumn',
	  method: 'post',
	  urls: '/api/saveColumn'
	}, {
	  name: '子项目列表获取显示列配置',
	  id: 'childProGetColSetting',
	  method: 'get',
	  urls: '/api/childProjectListColumns'
	}, {
	  name: '获取项目模板列表',
	  id: 'listProjectTemplates',
	  method: 'get',
	  urls: '/api/listProjectTemplates'
	}, {
	  name: '新建项目时获取项目模板',
	  id: 'getProjectTemplateV2',
	  method: 'get',
	  urls: '/api/getProjectTemplateV2'
	}, {
	  name: '更新项目时获取项目模板',
	  id: 'getProjectTemplateWhenUpdateV2',
	  method: 'get',
	  urls: '/api/getProjectTemplateWhenUpdateV2'
	}, {
	  name: '发送钉钉刷版本消息',
	  id: 'sendRefreshVersionMessage',
	  method: 'get',
	  urls: '/api/sendRefreshVersionMessage'
	}, {
	  name: '更新项目时获取项目模板',
	  id: 'getCustomFieldV2',
	  method: 'get',
	  urls: '/api/getCustomFieldV2'
	}, {
	  name: '关联项目列表&子项目列表保存过滤器',
	  id: 'saveProjectListFilter',
	  method: 'post',
	  urls: '/api/saveProjectListFilter'
	}, {
	  name: '关联项目列表获取根节点',
	  id: 'relatedProjectRoot',
	  method: 'get',
	  urls: '/api/relatedProjectRoot'
	}, {
	  name: '子项目列表获取根节点',
	  id: 'childProjectRoot',
	  method: 'get',
	  urls: '/api/childProjectRoot'
	}, {
	  name: '获取里程碑关联信息',
	  id: 'listMilestoneRelation',
	  method: 'get',
	  urls: '/api/listMilestoneRelation'
	}, {
	  name: '插入里程碑关联信息',
	  id: 'addMilestoneRelation',
	  method: 'post',
	  urls: '/api/addMilestoneRelation'
	}, {
	  name: '删除里程碑关联信息',
	  id: 'delMilestoneRelation',
	  method: 'post',
	  urls: '/api/delMilestoneRelation'
	}, { id: 'milestoneCreateIssueAndRelation',
	  name: '创建工作项并关联里程碑',
	  method: 'post',
	  urls: '/api/milestoneCreateIssueAndRelation'
	}, { id: 'simpleIssueSearch',
	  name: '搜索工作项',
	  method: 'get',
	  urls: '/api/simpleIssueSearch'
	}, {
	  name: '分享里程碑',
	  id: 'copyMilestone',
	  method: 'post',
	  urls: '/api/copyMilestone'
	}, {
	  name: '获取项目自定义属性',
	  id: 'getCustomValues',
	  method: 'get',
	  urls: '/api/getCustomValues'
	}, {
	  name: '获取企业下的码云认证信息',
	  id: 'getMayunCredential',
	  method: 'get',
	  urls: '/code/gitee/credential/get'
	}, {
	  name: '删除企业下的码云认证信息',
	  id: 'removeMayunCredential',
	  method: 'post',
	  urls: '/code/gitee/credential/delete'
	}, {
	  name: '获取授权用户的码云仓库',
	  id: 'getMayunRepoList',
	  method: 'get',
	  urls: '/code/repo/list'
	}, {
	  name: '根据id获取项目模板详情',
	  id: 'getProjectTemplateInfo',
	  method: 'get',
	  urls: '/api/getProjectTemplateInfo'
	}, {
	  name: '查询阿里云ECS列表',
	  id: 'getAliyunEcsList',
	  method: 'get',
	  urls: '/expand/service/company/machine/getAliyunEcsList'
	}, {
	  name: '导入阿里云ECS',
	  id: 'importAliyunEcs',
	  method: 'post',
	  urls: '/expand/service/company/machine/importAliyunEcs'
	}, {
	  name: '添加子项目',
	  id: 'addChildProjects',
	  method: 'post',
	  urls: '/api/addChildProjects'
	}, {
	  name: '获取项目成员角色列表',
	  id: 'getRoles',
	  method: 'get',
	  urls: '/projects/member/getRoles'
	}, {
	  name: '批量更新成员角色',
	  id: 'batchUpdateRoles',
	  method: 'post',
	  urls: '/projects/member/batchUpdateRoles'
	}, {
	  name: '获取项目角色',
	  id: 'getRoleStatisticData',
	  method: 'get',
	  urls: '/projects/member/getRoleStatisticData'
	}, {
	  name: '获取项目现有模板信息',
	  id: 'getProjectTemplateDetail',
	  method: 'get',
	  urls: '/projects/project/getProjectTemplate'
	}, {
	  name: '获取模板为业务空间的子项目',
	  id: 'getChildrenHasBusinessTemplate',
	  method: 'get',
	  urls: '/projects/project/filterChildrenHasBusinessTemplate'
	}, {
	  name: '判断当前时间是否合法',
	  id: 'checkCurrentDateIsLegal',
	  method: 'get',
	  urls: '/projects/project/checkCurrentDateIsLegal'
	}, {
	  name: '获取待转交的项目列表',
	  id: 'getResignationList',
	  method: 'get',
	  urls: '/projects/resignation/list'
	}, {
	  name: '转交项目',
	  id: 'transferProject',
	  method: 'post',
	  urls: '/projects/resignation/transfer'
	}, {
	  name: '批量转交项目',
	  id: 'batchTransferProjects',
	  method: 'post',
	  urls: '/projects/resignation/batchTransfer'
	}, {
	  name: '删除未审批通过的草稿态项目',
	  id: 'deleteUnapprovedProject',
	  method: 'post',
	  urls: '/projects/project/deleteUnapprovedProject'
	}, {
	  name: '查询repo绑定的企业信息',
	  id: 'checkUserRepoStatus',
	  method: 'get',
	  urls: '/intro/api/checkUserRepoStatus'
	}, {
	  name: '新建流水线',
	  id: 'createPipeline',
	  method: 'post',
	  urls: '/intro/api/createPipeline'
	}, {
	  name: '读取bu信息',
	  id: 'getBuInfo',
	  method: 'get',
	  urls: '/projects/project/getBuInfo'
	}, {
	  name: '搜索BU下的部门信息',
	  id: 'searchDepartmentInBu',
	  method: 'get',
	  urls: '/projects/project/searchDivisionInBu'
	}, {
	  name: '读取Bu对应的部门信息',
	  id: 'getDivisionOfBu',
	  method: 'get',
	  urls: '/projects/project/getDivisionByBuCode'
	}, {
	  name: '搜索负责的部门模板',
	  id: 'searchOwnedTemplate',
	  method: 'get',
	  urls: '/projects/project/template/search'
	}, {
	  name: '添加模板生效部门',
	  id: 'addTemplateScope',
	  method: 'post',
	  urls: '/projects/project/template/addScope'
	}, {
	  name: '删除模板生效部门',
	  id: 'deleteTemplateScope',
	  method: 'post',
	  urls: '/projects/project/template/deleteScope'
	}, {
	  name: '读取模板详情',
	  id: 'getTemplateDetails',
	  method: 'get',
	  urls: '/projects/project/template/detail'
	}, {
	  name: '读取部门模板基本信息',
	  id: 'getDivisionTemplate',
	  method: 'get',
	  urls: '/projects/project/template/getDivisionTemplate'
	}, {
	  name: '读取模板的自定义属性列表',
	  id: 'getProjectTemplateCustomFieldList',
	  method: 'get',
	  urls: '/projects/project/template/customField/list'
	}, {
	  name: '搜索自定义属性',
	  id: 'searchCustomField',
	  method: 'get',
	  urls: '/projects/project/template/customField/search'
	}, {
	  // node 未实现
	  name: 'getTbProjectGroup',
	  id: 'getTbProjectGroup',
	  method: 'get',
	  urls: 'xxxxxx'
	}, {
	  name: '添加自定义属性到项目模板中',
	  id: 'addProjectTemplateCf',
	  method: 'post',
	  urls: '/projects/project/template/customField/add'
	}, {
	  name: '从项目模板中移除自定义属性',
	  id: 'removeProjectTemplateCf',
	  method: 'post',
	  urls: '/projects/project/template/customField/remove'
	}, {
	  name: '编辑项目模板中的自定义属性',
	  id: 'updateProjectTemplateCf',
	  method: 'post',
	  urls: '/projects/project/template/customField/update'
	}, {
	  name: '获取项目模板配置的里程碑',
	  id: 'getMilestonesInProjectTemplate',
	  method: 'get',
	  urls: '/projects/project/template/milestone/list'
	}, {
	  name: '添加项目模板中的里程碑',
	  id: 'addMilestoneInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/milestone/add'
	}, {
	  name: '删除项目模板中的里程碑',
	  id: 'deleteMilestoneInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/milestone/delete'
	}, {
	  name: '更新项目模板中的里程碑信息',
	  id: 'updateMilestoneInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/milestone/update'
	}, {
	  name: 'fetchMachineGroupList',
	  id: 'fetchMachineGroupList',
	  method: 'GET',
	  urls: '/expand/service/company/machine/group/listByRegion'
	}, {
	  name: 'createMachineGroup',
	  id: 'createMachineGroup',
	  method: 'POST',
	  urls: '/expand/service/company/machine/group/create'
	}, {
	  name: 'deleteMachineGroup',
	  id: 'deleteMachineGroup',
	  method: 'POST',
	  urls: '/expand/service/company/machine/group/delete'
	}, {
	  name: 'updateMachineGroup',
	  id: 'updateMachineGroup',
	  method: 'POST',
	  urls: '/expand/service/company/machine/group/update'
	}, {
	  name: 'batchSetMachineGroup',
	  id: 'batchSetMachineGroup',
	  method: 'POST',
	  urls: '/expand/service/company/machine/batchSetGroup'
	}, {
	  name: 'removeCodeAccessOfRegion',
	  id: 'removeCodeAccessOfRegion',
	  method: 'POST',
	  urls: '/api/removeCodeAccessOfRegion'
	}, {
	  name: 'checkMemberHasRepoAccess',
	  id: 'checkMemberHasRepoAccess',
	  method: 'GET',
	  urls: '/api/checkMyProjectsAndGroupsExist'
	}, {
	  name: '更新项目模板中里程碑的位置',
	  id: 'exchangePositionOfMilestoneInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/milestone/exchangePosition'
	}, {
	  name: '读取当前模板的立项审批自定义属性',
	  id: 'getApprovalCfListInProjectTemplate',
	  method: 'get',
	  urls: '/projects/project/template/approval/customField/list'
	}, {
	  name: '开启当前模板的立项审批',
	  id: 'enableApprovalInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/approval/enable'
	}, {
	  name: '添加当前模板立项审批的自定义属性',
	  id: 'addApprovalCfInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/approval/customField/add'
	}, {
	  name: '删除当前模板立项审批的自定义属性',
	  id: 'removeApprovalCfInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/approval/customField/remove'
	}, {
	  name: '读取当前模板配置的规则',
	  id: 'getRuleListInProjectTemplate',
	  method: 'get',
	  urls: '/projects/project/template/rules/list'
	}, {
	  name: '读取项目模板的规则',
	  id: 'getAllRuleInProjectTemplate',
	  method: 'get',
	  urls: '/projects/project/rule/list'
	}, {
	  name: '在当前模板中配置规则',
	  id: 'setRuleInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/rule/add'
	}, {
	  name: '更新当前模板中的规则配置',
	  id: 'updateRuleInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/rule/update'
	}, {
	  name: '删除当前模板中的规则配置',
	  id: 'deleteRuleInProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/rule/delete'
	}, {
	  name: '搜索用户',
	  id: 'searchUser',
	  method: 'get',
	  urls: '/projects/user/search'
	}, {
	  name: '获取用户信息',
	  id: 'getMiniUserInfo',
	  method: 'get',
	  urls: '/projects/user/getUserMiniInfo'
	}, {
	  name: '更新项目模板内容',
	  id: 'updateProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/update'
	}, {
	  name: '新建项目模板',
	  id: 'newProjectTemplate',
	  method: 'post',
	  urls: '/projects/project/template/new'
	}, {
	  name: '读取模板的生效部门',
	  id: 'getScopeOfProjectTemplate',
	  method: 'get',
	  urls: '/projects/project/template/getScope'
	}, {
	  name: '读取待清理的项目列表',
	  id: 'getProjectNeedClean',
	  method: 'get',
	  urls: '/projects/project/getCleanProjects'
	}, {
	  name: '更改自定义属性的顺序',
	  id: 'exchangeCfPosition',
	  method: 'post',
	  urls: '/projects/project/template/customField/exchangePosition'
	}];
	
	var node2ProjectApis = {
	  createSpace: {
	    urls: '/projects/project/new'
	  },
	  createGroup: {
	    urls: '/projects/project/newProjectSet'
	  },
	  searchProduct: {
	    urls: '/projects/project/searchDivisions'
	  },
	  checkProjectName: {
	    urls: '/projects/project/checkProjectName'
	  },
	  listProjectTemplates: {
	    urls: '/projects/project/getProjectTemplate/listByDivision'
	  },
	  getProjectTemplateInfo: {
	    urls: '/projects/project/getProjectTemplate/getInfo'
	  },
	  getProjectInfo: {
	    urls: '/projects/project/getProjectInfo'
	  },
	  checkPermission: {
	    urls: '/projects/project/checkPermission'
	  },
	  searchProSet: {
	    urls: '/projects/project/searchProjectSetForNewOrUpdate'
	  },
	  searchForRelation: {
	    urls: '/projects/project/searchForRelationToProjectSet'
	  },
	  getModuleTree: {
	    urls: '/projects/module/tree/all'
	  },
	  deleteModule: {
	    urls: '/projects/module/delete'
	  },
	  updateModule: {
	    urls: '/projects/module/update'
	  },
	  getInheritModuleIds: {
	    urls: '/projects/module/inheritance/getIds'
	  },
	  getParentProject: {
	    urls: '/projects/project/getParentProject'
	  },
	  inheritModuleTree: {
	    urls: '/projects/module/tree/parent'
	  },
	  getModuleDetail: {
	    urls: '/projects/module/getDetail'
	  },
	  saveInheritModules: {
	    urls: '/projects/module/inheritance/save'
	  },
	  searchModules: {
	    urls: '/projects/module/parentModules'
	  },
	  createModule: {
	    urls: '/projects/module/create'
	  },
	  subModuleTree: {
	    urls: '/projects/module/subTree/all'
	  },
	  inheritSubModuleTree: {
	    urls: '/projects/module/subTree/parent'
	  },
	  inheritParent: {
	    urls: '/projects/module/inheritance/inheritParent'
	  },
	  updateModuleOwner: {
	    urls: '/projects/module/updateOwner'
	  },
	  showProjectMember: {
	    urls: '/projects/user/search'
	  },
	  newProjectTag: {
	    urls: '/projects/tag/newProjectTag'
	  },
	  searchTags: {
	    urls: '/projects/tag/searchTags'
	  },
	  shareTags: {
	    urls: '/projects/tag/shareTags'
	  },
	  updateProjectTag: {
	    urls: '/projects/tag/updateProjectTag'
	  },
	  delTaggingProject: {
	    urls: '/projects/tag/deleteTag'
	  },
	  getVersionListOfProject: {
	    urls: '/projects/version/getListOfProject'
	  },
	  createVersion: {
	    urls: '/projects/version/newVersion'
	  },
	  getVersionListByParent: {
	    urls: '/projects/version/getListByParent'
	  },
	  getVersionDetail: {
	    urls: '/projects/version/getVersionDetail'
	  },
	  updateVersion: {
	    urls: '/projects/version/updateVersion'
	  },
	  deleteVersion: {
	    urls: '/projects/version/deleteVersion'
	  },
	  searchForEdit: {
	    urls: '/projects/version/searchForEdit'
	  },
	  getCollabProjectSetting: {
	    urls: '/projects/collab/getCollabProjectSetting'
	  },
	  selectGlobalRegionByGuid: {
	    urls: '/projects/collab/searchGlobalRegionForCollab'
	  },
	  generateInviteCode: {
	    urls: '/projects/collab/generateInviteCode'
	  },
	  setProjectCollab: {
	    urls: '/projects/collab/setProjectCollab'
	  },
	  syncHistoryDataToCollabProject: {
	    urls: '/projects/collab/syncHistoryDataToCollabProject'
	  },
	  listMembersForCollab: {
	    urls: '/projects/collab/listMembers'
	  },
	  initiateCollabProject: {
	    urls: '/projects/collab/initiate'
	  },
	  participateCollabProject: {
	    urls: '/projects/collab/participate'
	  },
	  configSpaceService: {
	    urls: '/projects/project/configProjectService'
	  },
	  getServices: {
	    urls: '/projects/project/getAllServices'
	  },
	  recordRecentVisit: {
	    urls: '/projects/project/recordRecentVisit'
	  },
	  getPermissionInProject: {
	    urls: '/projects/project/getPermissionInProject'
	  },
	  quitProject: {
	    urls: '/projects/member/quitProject'
	  },
	  getProjectDetail: {
	    urls: '/projects/project/getProjectDetail'
	  },
	  searchParentSpaces: {
	    urls: '/projects/project/searchForNewOrUpdate'
	  },
	  appInitGetApprovalStatus: {
	    urls: '/projects/project/getApprovalStatus'
	  },
	  configProjectReqLock: {
	    urls: '/projects/project/configProjectReqLock'
	  },
	  setProjectArchived: {
	    urls: '/projects/project/archive'
	  },
	  setProjectActived: {
	    urls: '/projects/project/active'
	  },
	  watchProject: {
	    urls: '/projects/project/watcher/add'
	  },
	  addWatcher: {
	    urls: '/projects/project/watcher/add'
	  },
	  cancleWatcher: {
	    urls: '/projects/project/watcher/cancle'
	  },
	  cancelWatchProject: {
	    urls: '/projects/project/watcher/cancle'
	  },
	  appInitNew: {
	    urls: '/projects/approval/application/initiation/new'
	  },
	  appInitGetTemplate: {
	    urls: '/projects/approval/application/initiation/appInitGetTemplate'
	  },
	  getProjectTemplateV2: {
	    urls: '/projects/project/getProjectTemplate/createV2'
	  },
	  getProjectTemplateWhenUpdateV2: {
	    urls: '/projects/project/getProjectTemplate/updateV2'
	  },
	  getCustomValues: {
	    urls: '/projects/project/customField/getCustomValues'
	  },
	  getCustomFieldV2: {
	    urls: '/projects/project/customField/getCustomFieldV2'
	  },
	  getOptionsOfExternal: {
	    urls: '/projects/project/customField/getOptionsOfExternal'
	  },
	  getCustomOption: {
	    urls: '/projects/project/customField/getCustomOption'
	  },
	  addChildProjects: {
	    urls: '/projects/project/addChildProjects'
	  },
	  updateProject: {
	    urls: '/projects/project/updateProject'
	  },
	  listSubPortfolios: {
	    urls: '/projects/project/listSubPortfolios'
	  },
	  getRiskList: {
	    urls: '/projects/project/risk/list'
	  },
	  getRiskSummary: {
	    urls: '/projects/project/risk/summaryWithProgress'
	  },
	  getPortfolioMiniInfo: {
	    urls: '/projects/project/getPortfolioMiniInfo'
	  },
	  getRiskRiseShowType: {
	    urls: '/projects/project/getRiskRiseShowType'
	  },
	  setRiskRiseShowType: {
	    urls: '/projects/project/setRiskRiseShowType'
	  },
	  portfolioTree: {
	    method: 'post',
	    urls: '/projects/project/portfolioComponent/tree'
	  },
	  portfolioSubTree: {
	    urls: '/projects/project/portfolioComponent/subTree'
	  },
	  addRelatedComponents: {
	    urls: '/projects/project/addRelatedComponents'
	  },
	  searchNewProduct: {
	    urls: '/projects/project/searchProduct'
	  },
	  deleteProject: {
	    urls: '/projects/project/deleteProject'
	  },
	  getMembersForEdit: {
	    urls: '/projects/member/getMembersForEdit'
	  },
	  addMembers: {
	    urls: '/projects/member/addMembers'
	  },
	  deleteMembers: {
	    urls: '/projects/member/deleteMembers'
	  },
	  editMemRoles: {
	    urls: '/projects/member/editMemRoles'
	  },
	  getProjectRolesForEdit: {
	    urls: '/projects/member/getProjectRolesForEdit'
	  },
	  getMemberInfo: {
	    urls: '/projects/member/getMemberInfo'
	  },
	  importMembers: {
	    urls: '/projects/member/cloneMembers'
	  },
	  exportMembers: {
	    urls: '/projects/member/exportMembers'
	  },
	  deleteProjectRoles: {
	    urls: '/projects/member/deleteProjectRoles'
	  },
	  updateProjectRole: {
	    urls: '/projects/member/updateProjectRole'
	  },
	  updateCustomRoleType: {
	    urls: '/projects/member/updateCustomRoleType'
	  },
	  searchBreadList: {
	    urls: '/projects/project/searchList'
	  },
	  getRoles: {
	    urls: '/projects/member/getRoles'
	  },
	  getProjectInfoForDelete: {
	    urls: '/projects/project/getProjectInfoForDelete'
	  },
	  cancelTaskForDelete: {
	    urls: '/projects/project/cancelTaskForDelete'
	  },
	  updatePortfolio: {
	    urls: '/projects/project/updatePortfolio'
	  },
	  getDefaultSpaceIcons: {
	    urls: '/projects/project/getDefaultProjectIcons'
	  },
	  getTbProjectGroup: {
	    urls: '/projects/tb/getProjectGroup'
	  }
	};
	
	if (ifUseAkProjectApi) {
	  apiOrigin = apiOrigin.map(function (a) {
	    if (typeof a === 'string') {
	      var projectApi = node2ProjectApis[a];
	      if (projectApi && projectApi.urls) {
	        a = {
	          name: a,
	          id: a,
	          urls: projectApi.urls
	        };
	        if (projectApi.method) {
	          a.method = projectApi.method;
	        }
	      }
	    } else if (a.id) {
	      var _projectApi = node2ProjectApis[a.id];
	      if (_projectApi) {
	        if (_projectApi.method) {
	          a.method = _projectApi.method;
	        }
	        if (_projectApi.urls) {
	          a.urls = _projectApi.urls;
	        }
	      }
	    }
	    return a;
	  });
	}
	var api = apiOrigin;
	
	exports.default = api;

/***/ },

/***/ 26:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _require = __webpack_require__(12),
	    getCallbackPrefix = _require.getCallbackPrefix,
	    toQueryString = _require.toQueryString,
	    buildParams = _require.buildParams;
	
	var context = void 0;
	
	// This works in non-strict mode
	context = function () {
	  return this;
	}();
	
	try {
	  // This works if eval is allowed (see CSP)
	  context = context || Function('return this')() || (1, eval)('this');
	} catch (e) {
	  // This works if the window reference is available
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object') {
	    context = window;
	  }
	}
	
	if ('document' in context) {
	  var doc = document,
	      byTag = 'getElementsByTagName',
	      head = doc[byTag]('head')[0];
	} else {
	  var XHR2 = __webpack_require__(24);
	}
	
	var httpsRe = /^http/,
	    protocolRe = /(^\w+):\/\//,
	    twoHundo = /^(20\d|1223)$/,
	    // http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	readyState = 'readyState',
	    contentType = 'Content-Type',
	    requestedWith = 'X-Requested-With',
	    uniqid = 0,
	    lastValue = void 0,
	    // data stored by the most recent JSONP callback
	xmlHttpRequest = 'XMLHttpRequest',
	    xDomainRequest = 'XDomainRequest',
	    noop = function noop() {},
	    defaultHeaders = {
	  contentType: 'application/x-www-form-urlencoded',
	  requestedWith: xmlHttpRequest,
	  accept: {
	    '*': 'text/javascript, text/html, application/xml, text/xml, */*',
	    xml: 'application/xml, text/xml',
	    html: 'text/html',
	    text: 'text/plain',
	    json: 'application/json, text/javascript',
	    js: 'application/javascript, text/javascript'
	  }
	},
	    xhr = function xhr(o) {
	  // is it x-domain
	  if (o.crossOrigin === true) {
	    var _xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null;
	    if (_xhr && 'withCredentials' in _xhr) {
	      return _xhr;
	    } else if (context[xDomainRequest]) {
	      var protocolRegExp = /^https?/;
	      if (window.location.href.match(protocolRegExp)[0] !== o.url.match(protocolRegExp)[0]) {
	        throw new Error('XDomainRequest: requests must be targeted to the same scheme as the hosting page.');
	        // As per: http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
	      }
	      return new XDomainRequest();
	    }
	    throw new Error('Browser does not support cross-origin requests');
	  } else if (context[xmlHttpRequest]) {
	    return new XMLHttpRequest();
	  } else if (XHR2) {
	    return new XHR2();
	  } else {
	    return new ActiveXObject('Microsoft.XMLHTTP');
	  }
	},
	    globalSetupOptions = {
	  dataFilter: function dataFilter(data) {
	    return data;
	  }
	};
	
	function succeed(r) {
	  var protocol = protocolRe.exec(r.url);
	  protocol = protocol && protocol[1] || context.location.protocol;
	  return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response;
	}
	
	function handleReadyState(r, success, error) {
	  return function () {
	    // use _aborted to mitigate against IE err c00c023f
	    // (can't read props on aborted request objects)
	    if (r._aborted) return error(r.request);
	    if (r._timedOut) return error(r.request, 'Request is aborted: timeout');
	    if (r.request && r.request[readyState] == 4) {
	      r.request.onreadystatechange = noop;
	      if (succeed(r)) success(r.request);else {
	        error(r.request);
	      }
	    }
	  };
	}
	
	function getRequest(fn, err) {
	  var o = this.o,
	      method = (o.method || 'GET').toUpperCase(),
	      url = typeof o === 'string' ? o : o.url,
	
	  // convert non-string objects to query-string form unless o['processData'] is false
	  data = o.processData !== false && o.data && typeof o.data !== 'string' ? toQueryString(o.data) : o.data || null,
	      http = void 0,
	      sendWait = false;
	
	  // if we're working on a GET request and we have data then we should append
	  // query string to end of URL and not post data
	  if ((o.type == 'jsonp' || method == 'GET') && data) {
	    url = urlappend(url, data);
	    data = null;
	  }
	
	  if (o.type == 'jsonp') return handleJsonp(o, fn, err, url);
	
	  // get the xhr from the factory if passed
	  // if the factory returns null, fall-back to ours
	  http = o.xhr && o.xhr(o) || xhr(o);
	
	  http.open(method, url, o.async !== false);
	  setHeaders(http, o);
	  setCredentials(http, o);
	  if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	    http.onload = fn;
	    http.onerror = err;
	    // NOTE: see
	    // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	    http.onprogress = function () {};
	    sendWait = true;
	  } else {
	    http.onreadystatechange = handleReadyState(this, fn, err);
	  }
	  o.before && o.before(http);
	  if (sendWait) {
	    setTimeout(function () {
	      http.send(data);
	    }, 200);
	  } else {
	    http.send(data);
	  }
	  return http;
	}
	
	function handleJsonp(o, fn, err, url) {
	  var reqId = uniqid++,
	      cbkey = o.jsonpCallback || 'callback',
	      // the 'callback' key
	  cbval = o.jsonpCallbackName || getCallbackPrefix(reqId),
	      cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)'),
	      match = url.match(cbreg),
	      script = doc.createElement('script'),
	      loaded = 0,
	      isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1;
	
	  if (match) {
	    if (match[3] === '?') {
	      url = url.replace(cbreg, '$1=' + cbval); // wildcard callback func name
	    } else {
	      cbval = match[3]; // provided callback func name
	    }
	  } else {
	    url = urlappend(url, cbkey + '=' + cbval); // no callback details, add 'em
	  }
	
	  context[cbval] = generalCallback;
	
	  script.type = 'text/javascript';
	  script.src = url;
	  script.async = true;
	  if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	    // need this for IE due to out-of-order onreadystatechange(), binding script
	    // execution to an event listener gives us control over when the script
	    // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	    script.htmlFor = script.id = '_exceed_' + reqId;
	  }
	
	  script.onload = script.onreadystatechange = function () {
	    if (script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded' || loaded) {
	      return false;
	    }
	    script.onload = script.onreadystatechange = null;
	    script.onclick && script.onclick();
	    // Call the user callback with the last value stored and clean up values and scripts.
	    fn(lastValue);
	    lastValue = undefined;
	    head.removeChild(script);
	    loaded = 1;
	  };
	
	  // Add the script to the DOM head
	  head.appendChild(script);
	
	  // Enable JSONP timeout
	  return {
	    abort: function abort() {
	      script.onload = script.onreadystatechange = null;
	      err({}, 'Request is aborted: timeout', {});
	      lastValue = undefined;
	      head.removeChild(script);
	      loaded = 1;
	    }
	  };
	}
	
	function setHeaders(http, o) {
	  var headers = o.headers || {},
	      h = void 0;
	
	  headers.Accept = headers.Accept || defaultHeaders.accept[o.type] || defaultHeaders.accept['*'];
	
	  var isAFormData = typeof FormData !== 'undefined' && o.data instanceof FormData;
	  // breaks cross-origin requests with legacy browsers
	  if (!o.crossOrigin && !headers[requestedWith]) headers[requestedWith] = defaultHeaders.requestedWith;
	  if (!headers[contentType] && !isAFormData) headers[contentType] = o.contentType || defaultHeaders.contentType;
	  for (h in headers) {
	    headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h]);
	  }
	}
	
	function setCredentials(http, o) {
	  if (typeof o.withCredentials !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	    http.withCredentials = !!o.withCredentials;
	  }
	}
	
	function generalCallback(data) {
	  lastValue = data;
	}
	
	function urlappend(url, s) {
	  return url + (/\?/.test(url) ? '&' : '?') + s;
	}
	
	function HttpAjax(o, fn) {
	  this.o = o;
	  this.fn = fn;
	
	  init.apply(this, arguments);
	}
	
	function setType(header) {
	  // json, javascript, text/plain, text/html, xml
	  if (header === null) return undefined; // In case of no content-type.
	  if (header.match('json')) return 'json';
	  if (header.match('javascript')) return 'js';
	  if (header.match('text')) return 'html';
	  if (header.match('xml')) return 'xml';
	}
	
	function init(o, fn) {
	  var _this = this,
	      _arguments = arguments;
	
	  this.url = typeof o === 'string' ? o : o.url;
	  this.timeout = null;
	
	  // whether request has been fulfilled for purpose
	  // of tracking the Promises
	  this._fulfilled = false;
	  // success handlers
	  this._successHandlers = [];
	  this._fulfillmentHandlers = [];
	  // error handlers
	  this._errorHandlers = [];
	  // complete (both success and fail) handlers
	  this._completeHandlers = [];
	  this._erred = false;
	  this._responseArgs = {};
	
	  var self = this;
	
	  fn = fn || function () {};
	
	  if (o.timeout) {
	    this.timeout = setTimeout(function () {
	      timedOut();
	    }, o.timeout);
	  }
	
	  if (o.success) {
	    var _loop = function _loop() {
	      var successHandler = o.success.shift();
	      _this._successHandlers.push(function (resp, originResp) {
	        successHandler(resp, o, originResp);
	      });
	    };
	
	    while (o.success.length > 0) {
	      _loop();
	    }
	  }
	
	  if (o.error) {
	    var _loop2 = function _loop2() {
	      var errorHandler = o.error.shift();
	      _this._errorHandlers.push(function (resp, msg, t) {
	        errorHandler(resp, msg, t, o);
	      });
	    };
	
	    while (o.error.length > 0) {
	      _loop2();
	    }
	  }
	
	  if (o.complete) {
	    var _loop3 = function _loop3() {
	      var completeHandler = o.complete.shift();
	      _this._completeHandlers.push(function () {
	        completeHandler(_arguments, o);
	      });
	    };
	
	    while (o.complete.length > 0) {
	      _loop3();
	    }
	  }
	
	  function complete(resp) {
	    o.timeout && clearTimeout(self.timeout);
	    self.timeout = null;
	    while (self._completeHandlers.length > 0) {
	      var _completeHandler = self._completeHandlers.shift();
	      _completeHandler(resp);
	    }
	  }
	
	  function success(resp) {
	    var originResp = resp;
	    var type = o.type || resp && setType(resp.getResponseHeader('Content-Type')); // resp can be undefined in IE
	    resp = type !== 'jsonp' ? self.request : resp;
	    // use global data filter on response text
	    var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type),
	        r = filteredResponse;
	    try {
	      resp.responseText = r;
	    } catch (e) {
	      // can't assign this in IE<=8, just ignore
	    }
	    if (r) {
	      switch (type) {
	        case 'json':
	          try {
	            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')');
	          } catch (err) {
	            return error(resp, 'Could not parse JSON in response', err);
	          }
	          break;
	        case 'js':
	          resp = eval(r);
	          break;
	        case 'html':
	          resp = r;
	          break;
	        case 'xml':
	          resp = resp.responseXML && resp.responseXML.parseError // IE trololo
	          && resp.responseXML.parseError.errorCode && resp.responseXML.parseError.reason ? null : resp.responseXML;
	          break;
	      }
	    } else if (type !== 'jsonp') {
	      // 兜底，加入r为空，则直接返回空
	      resp = r;
	    }
	
	    self._responseArgs.resp = resp;
	    self._fulfilled = true;
	    fn(resp);
	    while (self._successHandlers.length > 0) {
	      var _successHandler = self._successHandlers.shift();
	      _successHandler(resp, originResp);
	    }
	    while (self._fulfillmentHandlers.length > 0) {
	      var fulfillmentHandler = self._fulfillmentHandlers.shift();
	      fulfillmentHandler(resp);
	    }
	
	    complete(resp);
	  }
	
	  function timedOut() {
	    self._timedOut = true;
	    self.request.abort();
	  }
	
	  function error(resp, msg, t) {
	    resp = self.request;
	    self._responseArgs.resp = resp;
	    self._responseArgs.msg = msg;
	    self._responseArgs.t = t;
	    self._erred = true;
	    while (self._errorHandlers.length > 0) {
	      var _errorHandler = self._errorHandlers.shift();
	      _errorHandler(resp, msg, t);
	    }
	    complete(resp);
	  }
	
	  this.request = getRequest.call(this, success, error);
	}
	
	HttpAjax.prototype = {
	  abort: function abort() {
	    this._aborted = true;
	    this.request.abort();
	  },
	  retry: function retry() {
	    init.call(this, this.o, this.fn);
	  },
	
	
	  /**
	   * Small deviation from the Promises A CommonJs specification
	   * http://wiki.commonjs.org/wiki/Promises/A
	   */
	
	  /**
	   * `then` will execute upon successful requests
	   */
	  then: function then(success, fail) {
	    success = success || function () {};
	    fail = fail || function () {};
	    if (this._fulfilled) {
	      this._responseArgs.resp = success(this._responseArgs.resp);
	    } else if (this._erred) {
	      fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	    } else {
	      // 目前仅执行此步
	      this._fulfillmentHandlers.push(success);
	      this._errorHandlers.push(fail);
	    }
	    return this;
	  },
	
	
	  /**
	   * `always` will execute whether the request succeeds or fails
	   */
	  always: function always(fn) {
	    if (this._fulfilled || this._erred) {
	      fn(this._responseArgs.resp);
	    } else {
	      this._completeHandlers.push(fn);
	    }
	    return this;
	  },
	
	
	  /**
	   * `fail` will execute when the request fails
	   */
	  fail: function fail(fn) {
	    fn = fn || function () {};
	    if (this._erred) {
	      fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	    } else {
	      this._errorHandlers.push(fn);
	    }
	    return this;
	  },
	  catch: function _catch(fn) {
	    return this.fail(fn);
	  }
	};
	
	module.exports = HttpAjax;

/***/ },

/***/ 27:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var HttpAjax = __webpack_require__(26);
	
	var _require = __webpack_require__(12),
	    normalize = _require.normalize,
	    serial = _require.serial,
	    toQueryString = _require.toQueryString;
	
	function httpAjax(o, fn) {
	  return new HttpAjax(o, fn);
	}
	
	// collect up all form elements found from the passed argument elements all
	// the way down to child elements; pass a '<form>' or form fields.
	// called with 'this'=callback to use for serial() on each element
	function eachFormElement() {
	  var cb = this,
	      e = void 0,
	      i = void 0,
	      serializeSubtags = function serializeSubtags(e, tags) {
	    var i = void 0,
	        j = void 0,
	        fa = void 0;
	    for (i = 0; i < tags.length; i++) {
	      fa = e[byTag](tags[i]);
	      for (j = 0; j < fa.length; j++) {
	        serial(fa[j], cb);
	      }
	    }
	  };
	
	  for (i = 0; i < arguments.length; i++) {
	    e = arguments[i];
	    if (/input|select|textarea/i.test(e.tagName)) serial(e, cb);
	    serializeSubtags(e, ['input', 'select', 'textarea']);
	  }
	}
	
	// standard query string style serialization
	function serializeQueryString() {
	  return httpAjax.toQueryString(httpAjax.serializeArray.apply(null, arguments));
	}
	
	// { 'name': 'value', ... } style serialization
	function serializeHash() {
	  var hash = {};
	  eachFormElement.apply(function (name, value) {
	    if (name in hash) {
	      hash[name] && !Array.isArray(hash[name]) && (hash[name] = [hash[name]]);
	      hash[name].push(value);
	    } else hash[name] = value;
	  }, arguments);
	  return hash;
	}
	
	// [ { name: 'name', value: 'value' }, ... ] style serialization
	httpAjax.serializeArray = function () {
	  var arr = [];
	  eachFormElement.apply(function (name, value) {
	    arr.push({ name: name, value: value });
	  }, arguments);
	  return arr;
	};
	
	httpAjax.serialize = function () {
	  if (arguments.length === 0) return '';
	  var opt = void 0,
	      fn = void 0,
	      args = Array.prototype.slice.call(arguments, 0);
	
	  opt = args.pop();
	  opt && opt.nodeType && args.push(opt) && (opt = null);
	  opt && (opt = opt.type);
	
	  if (opt == 'map') fn = serializeHash;else if (opt == 'array') fn = httpAjax.serializeArray;else fn = serializeQueryString;
	
	  return fn.apply(undefined, _toConsumableArray(args));
	};
	
	httpAjax.toQueryString = toQueryString;
	
	module.exports = httpAjax;

/***/ },

/***/ 28:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright(c) Alibaba Group Holding Limited.
	 *
	 * Authors:
	 *   笑斌 <xinlei.sxl@alibaba-inc.com>
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Mustache = __webpack_require__(18);
	var HttpAjax = __webpack_require__(27);
	
	var csrfReader = __webpack_require__(29);
	
	var Exceed = function () {
	  /**
	   * 默认配置
	   * @param config.csrf CSRF设置，默认token设置为_tb_token_
	   * @param config.ENV 环境设置
	   */
	  function Exceed(config) {
	    _classCallCheck(this, Exceed);
	
	    config = config || {};
	    var finalConfig = config;
	
	    // 环境识别
	    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window._ENV) {
	      finalConfig.ENV = window._ENV;
	    }
	    if (finalConfig.env && !finalConfig.ENV) {
	      finalConfig.ENV = finalConfig.env;
	    }
	    // 未填环境时默认为production
	    if (!finalConfig.ENV) {
	      finalConfig.ENV = 'production';
	    }
	
	    // urlencode
	    if (!finalConfig.urlencode) {
	      finalConfig.urlencode = false;
	    }
	
	    // 组合为最终配置
	    this.config = finalConfig;
	
	    // 拦截器
	    this.interceptors = {
	      request: [csrfReader],
	      response: {
	        success: [],
	        error: [],
	        complete: []
	      }
	    };
	    this.apimap = {};
	  }
	
	  /**
	   * 导入APIMAP
	   * @param apimap
	   */
	
	
	  _createClass(Exceed, [{
	    key: 'use',
	    value: function use(apimap) {
	      if (apimap instanceof Array) {
	        this.apimap = apimap;
	      } else {
	        console && console.warn && console.warn('can not found ENV:' + this.config.ENV + ' in your apimap');
	      }
	    }
	
	    /**
	     * 请求用函数
	     * @param param.api 请求的接口id
	     * @param param.params 用于替换接口中的模板参数
	     * @param param.data 用于传递参数
	     * @returns {*}
	     */
	
	  }, {
	    key: 'fetch',
	    value: function (_fetch) {
	      function fetch(_x) {
	        return _fetch.apply(this, arguments);
	      }
	
	      fetch.toString = function () {
	        return _fetch.toString();
	      };
	
	      return fetch;
	    }(function (param) {
	      var _this = this;
	
	      var requestParams = void 0;
	      if (typeof param === 'string') {
	        param = {
	          api: param
	        };
	      }
	
	      this.apimap.forEach(function (item) {
	        if (item.id === param.api) {
	          // 如果存在 params 字段则调用胡子插件进行字符串模板渲染
	          if (param.params) {
	            var url = item.urls[_this.config.ENV];
	            if (_this.config.urlencode) {
	              for (var paramItem in param.params) {
	                if (typeof param.params[paramItem] === 'string' || typeof param.params[paramItem] === 'number') {
	                  param.params[paramItem] = encodeURIComponent(param.params[paramItem]);
	                }
	              }
	              item.url = Mustache.render(url, param.params);
	            } else {
	              item.url = Mustache.render(url, param.params);
	            }
	          } else {
	            item.url = item.urls[_this.config.ENV];
	          }
	
	          requestParams = item;
	          if (Array.isArray(_this.interceptors.response.success)) {
	            requestParams.success = _this.interceptors.response.success.slice();
	          } else {
	            console.warn('interceptors can only receive interceptor Array!');
	          }
	
	          if (Array.isArray(_this.interceptors.response.error)) {
	            requestParams.error = _this.interceptors.response.error.slice();
	          } else {
	            console.warn('interceptors can only receive interceptor Array!');
	          }
	
	          if (Array.isArray(_this.interceptors.response.complete)) {
	            requestParams.complete = _this.interceptors.response.complete.slice();
	          } else {
	            console.warn('interceptors can only receive interceptor Array!');
	          }
	        }
	      });
	
	      if (!requestParams) {
	        console && console.warn && console.warn('can not found API:' + param.api + ' in your current environment');
	      }
	
	      // 添加通用参数
	      if (!requestParams.url) {
	        console.warn('API url is null, please check the APIMAP');
	      }
	
	      if (requestParams.url.indexOf('?') === -1) {
	        requestParams.url += '?';
	      } else {
	        requestParams.url += '&';
	      }
	
	      requestParams.url += '_input_charset=utf-8';
	
	      // 将访问数据添加进requestParams中
	      if (param.data) {
	        requestParams.data = param.data;
	      }
	
	      this.interceptors.request.forEach(function (requestInterceptor) {
	        requestInterceptor(requestParams, _this.config);
	      });
	
	      // 请求处理部分
	      if (!requestParams.method) {
	        return HttpAjax(requestParams);
	      }
	
	      if (requestParams.method === 'file' || requestParams.method === 'FILE') {
	        var postBody = new FormData();
	        postBody.append('file', param.file);
	
	        // 如果有传上来的data则包裹在formdata中
	        if (requestParams.data) {
	          for (var postDataItem in requestParams.data) {
	            postBody.append(postDataItem.toString(), requestParams.data[postDataItem]);
	          }
	        }
	
	        return fetch(requestParams.url, {
	          method: 'POST',
	          mode: 'same-origin',
	          credentials: 'same-origin',
	          body: postBody
	        }).then(function (res) {
	          if (res.ok) {
	            return res.json();
	          }
	          return Promise.reject(res);
	        });
	      }
	      if (requestParams.contentType === 'application/json') {
	        // 兼容，仅当请求contentType为application/json同时传输的参数不为string时进入
	        if (_typeof(requestParams.data) === 'object') {
	          requestParams.data = JSON.stringify(requestParams.data);
	        }
	      }
	      return HttpAjax(requestParams);
	    })
	  }]);
	
	  return Exceed;
	}();
	
	module.exports = Exceed;

/***/ },

/***/ 29:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright(c) Alibaba Group Holding Limited.
	 *
	 * Authors:
	 *   笑斌 <xinlei.sxl@alibaba-inc.com>
	 */
	var cookie = __webpack_require__(21);
	
	module.exports = function (request, config) {
	  var finalConfig = {};
	
	  // CSRF配置生成
	  var csrfConfig = {
	    token: '_tb_token_'
	  };
	
	  if (typeof config.csrf === 'string' && config.csrf === true) {
	    finalConfig.csrf = csrfConfig;
	  } else if (typeof config.csrf === 'string' && config.csrf === false) {
	    finalConfig.csrf = false;
	  } else if (_typeof(config.csrf) === 'object' && !!config.csrf.token) {
	    finalConfig.csrf = _extends(csrfConfig, config.csrf);
	  } else {
	    finalConfig.csrf = false;
	  }
	
	  // 获取csrf标识
	  if (finalConfig.csrf) {
	    request.csrf = getCsrfToken();
	    request.url += '&' + finalConfig.csrf.token + '=' + request.csrf;
	  }
	
	  /**
	   * 读取csrfToken
	   * @returns {*}
	   */
	  function getCsrfToken() {
	    var token = null;
	    // 从cookie中读取相应值
	    var cookies = cookie.parse(document.cookie);
	    token = cookies[config.csrf.token];
	    if (token) {
	      return token;
	    }
	    return false;
	  }
	};

/***/ },

/***/ 30:
/***/ function(module, exports) {

	module.exports = window.ReduxThunk.default;

/***/ },

/***/ 32:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var en = {
	  advanced_setting: 'Advanced Setting',
	  createProject: 'Create Project',
	  unset: 'unset',
	  projectSetName: 'project set name',
	  text_package_config_edit: 'edit',
	  text_package_config_edit_role: 'Edit role',
	  text_update_package_config: ' update build config may trigger clean build package,do you confirm to update',
	  text_build_package_num_config: 'build package config',
	  text_build_package_config_help: 'build package config help',
	  text_app_package_num: 'app build package num',
	  text_online_package_num: 'online build package num',
	  text_build_package_config_switch: 'build pcakage config switch',
	  text_build_package_operation: 'operation',
	  text_build_package_update: 'edit',
	  text_build_package_input: 'please enter',
	  text_build_package_enter_num: 'please enter number over 0',
	  text_build_package_detail: 'build package detail',
	  text_build_package_app_id: 'app id',
	  text_build_package_app_name: 'app name',
	  text_choose_status: 'please choose status',
	  text_status_on: 'open',
	  text_status_off: 'close',
	  text_config_error_app_package_limit_must_over_online_limit: 'app package count limit must over online package count  limit',
	  text_build_package_app_size: 'app build package size',
	  label_select_code_template: 'Choose Template',
	  label_select_language: 'Choose Language',
	  label_pending: 'Todo',
	  label_my_create: 'Created',
	  label_my_collect: 'Favorites',
	  label_issue: 'Defect',
	  label_requirement: 'Requirement',
	  label_task: 'Task',
	  label_risk: 'Risk',
	  label_projectSet: 'Program',
	  label_project: 'Project',
	  label_productline: 'Product',
	  text_submit_time: 'Submit time',
	  label_actualDate: 'Actual Start&End Date',
	  label_select: 'select',
	  label_yes: 'Yes',
	  label_no: 'No',
	  text_please_input: 'Please input',
	  text_please_type_integer: 'Please type an integer',
	  text_please_type_number: 'Please type a number',
	  text_custom_attribute: 'Custom attribute',
	  text_Owner_department: 'Owner Team',
	  text_open_to_department: 'Public to',
	  text_owner_product: 'Owner product/BU',
	  label_search_keyword: 'Enter keywords to Search',
	  label_description: 'Description',
	  tip_desc_required: 'Enter the Description',
	  label_expectDate: 'Expected Start&End Date',
	  text_Health: 'Health',
	  text_Good: 'Good',
	  text_Medium: 'Medium',
	  text_Bad: 'Bad',
	  label_thumbnail: 'Thumbnail',
	  text_Lifecycle: 'Lifecycle',
	  text_Doing: 'Doing',
	  text_Done: 'Done',
	  text_Canceled: 'Canceled',
	  text_Visibility: 'Visibility',
	  text_Public_project: 'Public',
	  label_visitable_by_all: 'Visible to everyone',
	  text_Private_project: 'Private',
	  label_visitable_only_by_project_member: 'Only visible to members',
	  label_project_name: 'Project Name',
	  tip_project_title_required: 'Enter the project name',
	  tip_program_title_required: 'Enter the program name',
	  label_portfolio_name: 'Portfolio Name',
	  click_this_to_create_new_project: 'Click this, then you can create a new project',
	  click_this_to_choose_project: 'Click this, then you can choose a project',
	  git_repo_can_not_be_empty: 'Git repo url should not be empty',
	  git_repo_format_error: 'Code repo url is invalid',
	  git_repo_url_placeholder: 'Existing code repo url (like git@example.aliyun.com:ns/repo.git).',
	  text_Please_input_name: 'Please input name',
	  label_name: 'Name',
	  text_Parent_project: 'Parent Project',
	  label_productLine: 'ProductLine',
	  text_Parent_production: 'Parent production',
	  text_portfolio_parent: 'Portfolio parent',
	  label_parent_project: 'Parent Project',
	  label_portfolio_belongs_to: 'The portfolio belongs to',
	  label_progress_percentage: 'Schedule',
	  label_related_project: 'Related Project(Program)',
	  text_portfolio_components: 'Portfolio components',
	  label_belonged_project_set: 'Belonged Program',
	  text_Classification: 'Classification',
	  text_Namespace: 'Namespace',
	  text_Develop_project: 'Develop project',
	  label_project_type: 'Project Type',
	  text_name: 'Name',
	  text_Public: 'Public',
	  text_Accessible_for_everyone: 'Visible to everyone',
	  text_private: 'Private',
	  text_Accessible_for_project_members: 'Only visible to members',
	  text_Next: 'Next',
	  label_prev_step: 'Prev Step',
	  text_Compete: 'Complete',
	  label_base_info: 'Basic Information',
	  text_config_project_group: 'Portfolio components config',
	  label_complete: 'completed',
	  text_Administrator: 'Administrator',
	  text_Accept2: 'Accept',
	  text_Deny2: 'Deny',
	  text_Cancel_admin: 'Cancel admin',
	  text_Set_admin: 'Set admin',
	  text_Remove: 'Remove',
	  text_Pending: 'Pending',
	  text_Accepted: 'Accepted',
	  text_Invalid: 'Invalid',
	  text_Refused: 'Refused',
	  text_Selected_: 'Selected ',
	  text__items: ' items',
	  text_Accept_all: 'Accept all',
	  text_Deny_all: 'Deny all',
	  text_Active_members: 'Active Members',
	  text_Member_Name: 'Name',
	  text_Nick_Name: 'Nick Name',
	  text_email: 'Email',
	  text_Department: 'Department',
	  text_Mobile: 'Mobile',
	  text_Staff_ID: 'Staff ID',
	  text_Invitation_list: 'Invitation List',
	  label_status: 'Status',
	  text_Waiting_for_approval: 'Waiting For Approval',
	  text_Refused_list: 'Refused List',
	  text_Copy_successfully: 'Copy successfully',
	  text_Add: 'Add',
	  text_convert_billing: 'Switch Billing Policy Hint',
	  text_click_to_switch: 'Click to swtich',
	  text_switch_billing_success: 'Please close the dialog, and continue adding memeber',
	  text_switch_billing_faied: 'Switch Failed: ',
	  text_Invitation_Link: 'Invitation Link',
	  text_invitation_link_tip: 'Share the link to invite other people to this company',
	  text_This_invitation_remain_valid_till_: 'This invitation remains valid till ',
	  text_Copy: 'Copy',
	  text_RAM: 'RAM',
	  text_ram_tip1: 'You can add following sub account, or',
	  text_ram_tip2: ' go to RAM to add sub account',
	  text_ram_tip3: '. If you need help ',
	  text_ram_tip4: 'click here',
	  text_Display_name: 'Display name',
	  text_Login_user_name: 'Login user name',
	  label_ok: 'OK',
	  text_Invitation_Email: 'Invitation Email',
	  text_Email_textarea_tip: 'Please input email address, one email per line, less than 20 lines.',
	  text_Within_10_characters: 'Within 10 characters',
	  text_Apply_to_join_company: 'Apply to join company',
	  text_Name: 'Name',
	  text_Please_type_your_name_correctly: 'Please type your name correctly',
	  text_Please_input_your_email: 'Please input your email',
	  text_Invalid_emails: 'Invalid emails',
	  text_Join_Company: 'Join Company',
	  text_Your_application_is_waiting_for_approval_please_wait: 'Your application is waiting for approval please wait',
	  text_Invalid_invitation_please_contact_the_administrator: 'Invalid invitation, please contact the administrator',
	  text_Your_application_has_been_approved_you_can: 'Your application has been approved, you can',
	  text__enter_the_company: ' enter the company',
	  text_Your_application_has_been_denied_please_contact_the_administrator: 'Your application has been denied, please contact the administrator',
	  text_Please_input_company_name: 'Please input company name',
	  text_Invite_Member: 'Invite Member',
	  text_Please_select_your_company: 'Please select the company you want to access',
	  text_Switch: 'Switch',
	  text_No_company: 'No company, ',
	  text_to_create_a_new_one: ' to create a new one',
	  tip_program_title_exist: 'Program name already exists, please retry.',
	  tip_Plan_end_time_before_start_time: 'Planed complete time must be after planed start time',
	  label_solution: 'Solution',
	  label_new_projectset: 'New Program',
	  text_config_members: 'Config Members',
	  text_config_joined_projects: 'Config Programs',
	  label_next_step: 'Next Step',
	  text_program_manager: 'Program Manager',
	  tip_enter_program_manager: 'Please Enter Program Manager',
	  text_program_member: 'Program Member',
	  tip_enter_program_member: 'Please Enter Program Member',
	  label_cancel: 'Cancel',
	  label_config_scrum: 'Set Scrum Team',
	  tip_scrum_master_require: 'scrum master is required',
	  tip_product_owner_require: 'product owner is required',
	  tip_scrum_member_require: 'scrum member is required',
	  text_required_please_input: 'Required field, please input',
	  text_import: 'Import',
	  text_apply: 'Apply',
	  label_product: 'Product',
	  text_Todo: 'Todo',
	  label_view_all: 'All',
	  label_empty_data: 'No data',
	  text_my_favorite: 'My Favorite',
	  tip_empty_data: 'No relevant result',
	  label_view_more: 'View More',
	  text_todo_clear_tip: 'Congratulations, you have finished all the todo items.',
	  text_portfolio: 'Portfolio',
	  label_Plan_start_and_end_time: 'Planed Time',
	  label_Plan_start_time: 'Planed Start',
	  label_Plan_end_time: 'Planed Complete',
	  tip_plan_start_after_end: 'Planned start time must before Planned completed time',
	  label_creator_and_created_at: 'Creator and CreatedAt',
	  label_Actual_start_and_end_time: 'Actual Time',
	  label_Actual_start_time: 'Actual Start',
	  label_Actual_end_time: 'Actual Complete',
	  text_person_in_charge: 'Person in charge',
	  text_Risk_progress: 'Risk progress',
	  text_update_time: 'Update Time',
	  text_latest_complated_milestone: 'Milestone completed recently ',
	  text_edit: 'Edit',
	  label_collection: 'Collect',
	  tip_create_at: 'Created At',
	  label_visible_range: 'Visible',
	  label_detail: 'detail',
	  label_Risk_summary: 'Risk Summary',
	  text_Display_Sub_project_Risk: 'Display Sub-project Risk',
	  label_risk_level: 'Risk Level',
	  text_status: 'Status',
	  label_owner_project: 'Belonged Project',
	  text_create_time: 'Create Time',
	  label_private: 'private',
	  label_new_project: 'New Project',
	  text_tip_title: 'Tip',
	  label_create_project_step: 'Create Project',
	  label_create_git_step: 'Create Git',
	  label_create_app_step: 'Create Application',
	  label_start_project: 'enter project',
	  label_skip_project: 'skip, enter project',
	  label_config_git: 'Config Git Group',
	  label_git: 'Git Group/Project',
	  label_git_repo: 'Git repo url',
	  text_select_git_group: 'Please Select Git Group',
	  label_application_name: 'Application Name',
	  text_input_application_name: 'Please Input Application Name',
	  label_Initiate_code_template: 'Code Template',
	  label_develop_mode: 'Develop Mode',
	  text_select_develop_mode: 'Please Select Mode For Develop',
	  label_develop_mode_free: 'Free',
	  label_read_more: 'More',
	  label_develop_mode_branch: 'Branch',
	  label_develop_mode_gitFlow: 'Git Flow',
	  label_docker_build_or_not: 'Docker build',
	  label_app_release_language: 'Develop language',
	  label_application_type: 'Application type',
	  label_deploy_option: 'Deploy options',
	  label_build_config_step: 'Build Config',
	  label_deploy_config_step: 'App Config',
	  label_code: 'Code',
	  label_test: 'Test',
	  label_publish: 'Publish',
	  label_service_common: 'Common',
	  label_service_general: 'Common',
	  label_service_product: 'Product',
	  label_service_develop: 'Develop',
	  label_service_testing: 'Test',
	  label_service_publish: 'Publish',
	  label_service_other: 'Other',
	  label_service_doc: 'Doc',
	  label_service_tile_workitem: 'Workitem',
	  label_service_tile_report: 'Report',
	  label_service_tile_chart: 'Chart',
	  label_service_tile_kanban: 'Kanban',
	  label_service_tile_risk: 'Risk',
	  label_service_tile_report2: 'Weekly Report',
	  label_service_tile_document: 'Doc',
	  label_service_tile_resource: 'Resource',
	  label_service_tile_milestone: 'Milestone',
	  label_service_tile_meeting: 'Meeting',
	  label_service_tile_lark: 'Lark',
	  label_service_tile_req: 'Req',
	  label_service_tile_demo: 'Demo',
	  label_service_tile_projectChange: 'Project Change',
	  label_service_tile_version: 'Version',
	  label_service_tile_version_app_config: 'App Config',
	  label_service_tile_task: 'Task',
	  label_service_tile_sprint: 'Sprint',
	  label_service_tile_code: 'Code',
	  label_service_tile_pipeline: 'Pipeline',
	  label_service_tile_project_pipeline: 'Project Pipeline',
	  label_service_tile_issue: 'Defect',
	  label_service_tile_lab: 'Lab',
	  label_service_tile_TC: 'TC',
	  label_service_tile_regression: 'Regression',
	  label_service_tile_test: 'Test',
	  label_service_tile_crDev: 'Cr',
	  label_service_tile_app: 'App',
	  label_service_tile_alipay_doccenter: 'Javis Doc',
	  label_service_tile_product_version_app_config: 'Product Version App Config',
	  label_service_tile_product_version: 'Version',
	  label_service_tile_lib: 'Lib',
	  label_service_tile_product_version_inst: 'Inst',
	  label_service_tile_file: 'File',
	  label_service_tile_planItem: 'Plan Item',
	  label_service_desc_workitem: 'Work items,including tasks,requirements,defects,which help project management and implementation',
	  label_service_desc_report: 'Multi-dimensional project data analysis',
	  label_service_desc_chart: 'Multi-dimensional project data analysis',
	  label_service_desc_kanban: 'Improve the efficiency of collaboration by kanban view,rapid advancement of focused matters,and agile development practices',
	  label_service_desc_risk: 'Manage project risks,timely notification,and report at different levels',
	  label_service_desc_report2: 'Weekly Report',
	  label_service_desc_document: 'Keep documents and precipite knowledge',
	  label_service_desc_resource: 'Project human resource management',
	  label_service_desc_milestone: 'Milestones and specific work items in the overall planning project',
	  label_service_desc_meeting: 'Meeting management',
	  label_service_desc_lark: 'Lark knowledge base',
	  label_service_desc_req: 'Record,view requirements,customize workflows,add custom fields for easy tracking management',
	  label_service_desc_demo: 'Open Demo+',
	  label_service_desc_projectChange: 'Unified management project requirements,milestone plans,and personnel changes',
	  label_service_desc_version: '版本',
	  label_service_desc_version_app_config: 'Configure the version rule of the app: fixed version or latest version',
	  label_service_desc_task: 'Record daily to-do items and follow up on progress',
	  label_service_desc_sprint: 'Use Sprint to manage requirements to be delivered. You can lock the sprint to ensure requirements would not change',
	  label_service_desc_code: 'Code',
	  label_service_desc_pipeline: 'Self-configurable release pipeline',
	  label_service_desc_project_pipeline: 'Project Pipeline',
	  label_service_desc_issue: 'Manage defects,which can be linked to code changes and easily to be tracked by develop and test classmate',
	  label_service_desc_lab: 'Lab',
	  label_service_desc_TC: 'Test cases provide manual use case management for testing students to record and view test steps and test results',
	  label_service_desc_regression: 'The regression function provides a daily timed regression of the application-stable test function script (lab) to verify the quality of the test product',
	  label_service_desc_test: 'Test services are used to provide users with a standardized test service capability',
	  label_service_desc_crDev: 'The change request including code,package,container and is used to ensure the quality by integrating with security audit tools and  CI  process',
	  label_service_desc_app: 'Application lifecycle, metadata management, basic information related to the application, and change release can be found here',
	  label_service_desc_alipay_doccenter: 'Javis Doc',
	  label_service_desc_product_version_app_config: 'Configure the version rule of the app: fixed version or latest version',
	  label_service_desc_product_version: 'Define product version, manage defect by version',
	  label_service_desc_lib: 'Project two-party library service',
	  label_service_desc_product_version_inst: 'Product version of the product. Every time you run the product version pipeline, there will be a unique product generation',
	  label_service_desc_file: 'File service of aone2',
	  label_service_desc_planItem: 'Making Product Planning, organization and management requirement',
	
	  label_plugin_desc_model: 'Define product modules or business modules in a tree structure,used to classify requirements defects',
	  label_plugin_desc_tag: 'Tag requirements, defects, sub-projects, etc., classification management',
	  label_plugin_desc_version: 'Define product version, manage defect by version',
	  label_plugin_desc_across_enterprise: 'Share data within the project with another enterprise',
	  label_plugin_set_across_enterprise_tip: 'Share project data among cooperative Enterprises',
	  label_plugin_cancel_across_enterprise_tip: 'Cancel share project data among cooperative Enterprises',
	
	  text_feedback: 'Feedback',
	  label_quick_start: 'Quick Start',
	  label_help_doc: 'Document',
	  label_edit: 'Edit',
	  label_update_milestone: 'Edit Milestone',
	  label_new_milestone: 'New Milestone',
	  label_Actual_completed_time: 'Actual completed date',
	  tip_actual_completed_time: 'Please input actual end date',
	  tip_status_selected: 'Please select the state',
	  label_module: 'Module',
	  label_Plan_completed_time: 'Planned completed date',
	  text_expected_end_date_hint: 'Please input planned date',
	  tip_unfinished: 'Unfinished',
	  tip_finished: 'Finished',
	  text_Archived: 'Archived',
	  text_display_archived_milestone: 'Display archived milestones',
	  text_operation: 'Operation',
	  text_tag: 'Tag',
	  label_project_ascription: 'Ascription',
	  label_project_plan: 'Plan',
	  text_program_tip1: "Program contains sub-projects' data",
	  text_program_tip2: 'But cannot manage project data',
	  tip_archive_make_sure: 'Confirm to close project? Re-open is not allowed after the completion of project, please be careful',
	  tip_archived_cancel_success: 'Archive canceled',
	  tip_archived_success: 'Successful completion\n',
	  label_archive_cancel: 'Cancel Archive',
	  label_archive: 'Complete',
	  tip_project_archive: 'Once the project is complete, the project can be marked as a closed item. ' + 'Projects that have been closed are not displayed in the project list or project search results by default; ' + 'workitems of the completed project will still be counted in the chart statistics; all sprints are automatically closed after the completion of the project, ' + 'no new sprint can be added; workitems cannot be added after the completion of the project; the template cannot be modified after the completion of the project. ' + 'Re-open is not allowed after the completion of project, please be careful!',
	  tip_collection_cancel_success: 'Unfavorite success',
	  tip_collection_success: 'Favorite success',
	  label_collection_cancel: 'Cancel Collection',
	  text_Update_success: 'Update success',
	  text_Update: 'Update',
	  tip_save_success: 'Save success',
	  label_confirm: 'Confirm',
	  text_Add_member_role: '+ Add member role',
	  text_select_role: 'Please select role',
	  tip_waiting_export: 'Exporting, result will be sent by wangwang and email;',
	  tip_waiting_export_vpc: 'Exporting, result will be sent by email;',
	  text_Export_members: 'Export Members',
	  label_not_allow_to_delete_member: 'There is some members under this role that cannot be deleted!',
	  tip_delete_make_sure: 'confirm to delete',
	  label_delete: 'Delete',
	  label_add_to_dingding_calendar: 'Add to calendar',
	  label_covered_existing_member: 'Only new members will be added after exporting from other projects,are you sure to import?',
	  text_run_success: 'Run Successfully',
	  text_Import_members: 'Import Members',
	  tip_project_selected: 'Please select the project',
	  text_Success_to_remove_member: 'Success to remove member',
	  label_select_role: 'Please select a role.',
	  label_save: 'Save',
	  text_Support_markdown: 'Support markdown',
	  label_preview: 'Preview',
	  label_remove: 'Remove',
	  tip_enabled: 'Enable',
	  label_drag_sort: 'Drag and drop to change order.',
	  tip_opened: 'Enabled',
	  label_all: 'All',
	  text_remove_service_tip: 'The data will not be deleted after remove service',
	  label_add: 'Add',
	  text_create_a_new_version: 'create a new version',
	  text_Display_archived_version: 'Display archived version',
	  text_Unpublished: 'Unpublished',
	  text_Published: 'Published',
	  label_locale: 'en_US',
	  text_Related_work_item: 'Related work item',
	  label_Actual_publish_time: 'Actual Publish Time',
	  label_Plan_publish_time: 'Planed Publish Time',
	  text_Parent_version: 'Parent Version',
	  label_New_module: 'Create Module',
	  label_New_tag: 'Create Tag',
	  label_share_tag: 'Share Tag',
	  label_edit_tag: 'Edit Tag',
	  text_tag_share_info: 'Tag share to',
	  text_tag_share_sub_or_related: 'All descendant or related projects',
	  text_tag_other_project: 'Other projects:',
	  text_delete_module_success: 'Deleted successfully',
	  tip_inherit_all: 'Are you sure to inherit all modules from parent?',
	  text_Inherit_all: 'Inherit all modules from parent',
	  label_Inherit_module: 'Inherit Module',
	  tip_module_belong_to: 'The module belongs to ',
	  tip_click_to_manager_module: 'click here to manager.',
	  label_created_at: 'Created At',
	  text_module_inherit_from: 'The module is inherited from ',
	  text_module_remove_tip: ',it will be removed from the current project instead of being deleted,to delete please go to ',
	  text_parent_module: 'Parent Module',
	  remove_success: 'remove success',
	  enable_success: 'enable success',
	  label_cooperation_project: 'Cooperation Project',
	  text_initiate_cooperation: 'Initiate Cooperation',
	  text_participate_cooperation: 'Participate in Cooperation',
	  label_project_title: 'Project Title',
	  label_project_des: 'Project Description',
	  label_share_content: 'Shared Content',
	  text_choose_shared_info: 'Select the information you want to share with the partners:',
	  text_project_base_info: 'Project base information',
	  text_project_member_info: 'Project members',
	  text_project_work_item: 'Work item and related configuration',
	  label_own_info: 'Own Information',
	  text_project_owners: 'Project Owners',
	  text_project_members: 'Project Members',
	  label_participant_info: 'Partner Information',
	  text_partner_company: 'Partner Enterprise',
	  label_invitation_code: 'Invitation code',
	  delete_code_syatem_user: 'confirm to delete code system user',
	  text_code_system_help: 'code system user help',
	  code_system_user: 'code system user',
	  enter_code_system_user: 'please enter username to search',
	  label_warning: 'Warning',
	  text_delete_project_info: 'To delete project with workitems,milestones,risks,versions,modules,sprints,applications and pipelines which could not be recovered.',
	  text_delete_project_set_info: 'To delete project set with workitems,milestones,risks,versions,modules,sprints,applications and pipelines which could not be recovered. The relation of project set will be removed too.',
	  text_delete_project_portfolio_info: 'To delete project portfolio and relation of it.',
	  label_delete_project_number_str_vpc: 'There are $1 workitems,$2 milestones,$3 versions,$4 modules,$5 sprints,$6 applications and $7 pipelines and $8 documents.(The number of Testcase has not been counted yet.)',
	  label_delete_project_number_str: 'There are $1 workitems,$2 milestones,$3 versions,$4 modules,$5 sprints,$6 applications, $7 pipelines, $8 documents and $9 testcases.',
	  text_click_to_confirm_delete_project: '(Click to confirm to delete project)',
	  text_click_to_confirm_delete_project_with_many_workitem: '(Submit to delete this project,which will be executed after 2 days because there are many workitems belongs to it.)',
	  text_input_project_name_to_confirm: 'Please input project name to confirm to delete.',
	  text_error_when_check_project_name: 'Check project name failed',
	  text_submit_delete_project_tooltip: '$1 has submitted to delete this project at $2 and System will execute this task at $3.',
	  label_empty_for_i18n: ' ',
	  more_options: 'more_options',
	  title_edit_view: 'Edit View',
	  lable_crp_migrate: 'Migrate From CRP to RDC',
	  refresh_login: 'Login status expired,please refresh the page.',
	  test_create_issue_init_assignedTo: 'When you create a defect，“assignedTo” automatically set as module leader',
	  test_go_into_all_defeat_types: 'will go into all types of defects',
	  test_workflow_role_required_cf: 'Transfer permissions and required customField',
	  test_confirm_to_create_code_account: 'confirm to create code sys account',
	  test_confirm_to_delete_code_account: 'confirm to delete code sys account',
	  test_create_code_account_success: 'create sys code sys account success',
	  test_delete_code_account_success: 'delete code sys account success',
	  test_create_code_account_fail: 'create code sys account fail,code sys account exist',
	  test_delete_code_account_fail: 'delete code sys account fail',
	  test_no_code_account: 'code sys account not exist',
	  test_enter_right_code_account: 'please enter right code sys account',
	  text_project_has_sub_project: 'There are $1 sub projects,you should move them away before delete this project.',
	  text_project_is_collab: 'This project is collaborative,you should cancel this relation before delete this project.',
	  text_across_enterprise: 'Cross-company Collaboration',
	  text_project_submit_to_delete_success: 'Submit to delete project successfully',
	  text_return: 'return',
	  text_disabled: 'Disabled',
	  text_delete_confirm: 'Sure to deleted',
	  label_set_status_config_title: 'Transfer permissions and required customField setting',
	  text_target_status: 'Target status',
	  text_role_to_set_target_status: 'Roles authorized to change to the target status',
	  text_target_status_set_cfs: 'When comes to the target status, custom fields have to be filled as follows',
	  text_please_select_target_status: 'Select target status',
	  text_run_failed: 'Run failed',
	  text_select_required_cf: 'Select required custom field',
	  text_has_right_rols: 'authorized roles',
	  text_required_cf_before_status_flow: 'required custom fieldss before status change',
	
	  text_custom_rule: 'Custom rule',
	  text_add_rule: 'Add rule',
	  text_input_rule_name: 'Input rule name',
	  text_rule_name: 'Rule name',
	  text_trigger_event: 'Trigger event',
	  text_actuator: 'Actions',
	  text_return_rule_list: 'return to rule list',
	  text_add_rule_trigger: 'Add trigger event',
	  text_add_actuator_group: 'Add actuator group',
	  text_add_actuator: 'Add actuator',
	  text_status_auto_flow: 'Status auto flow',
	  text_window_to_fill_cfs: 'Alert window to fill custom field',
	  text_select_status: 'select status',
	  text_step_status_auto_flow: 'Status auto flow',
	  text_step_window_to_fill_attrs: 'Alert window to fill attributes',
	  text_when_status_is: 'when status is ',
	  text_status_flow_to: ', then status comes to ',
	  text_add_status_auto_flow: 'Add status auto flow',
	  text_start_review: 'Workitem starts review',
	  text_review_started_to_trigger_event: 'When workitem starts review, this event will be triggered.',
	  text_finish_review: 'Workitem review passed',
	  text_finish_review_to_trigger_event: 'When invited reviewers are all agreed with this review, this event will be triggered.',
	  text_run_condition: 'Run condition',
	  text_always_run: 'Always run',
	  text_rule_name_not_null: 'Rule name can not be null',
	  text_rule_actuators_not_null: 'Rule actuators can not be null',
	  text_project_cancel_to_delete_success: 'Cancel deleting project',
	  text_project_delete_success: 'Delete project successfully',
	
	  text_rdc_ram_authorization_add: 'Confirm rdc authorization config?',
	  text_rdc_ram_authorization_update: 'Confirm rdc re-authorization ?',
	  text_rdc_ram_authorization_delete: 'Confirm delete rdc authorization?',
	  text_rdc_ram_authorization_ram: 'Confirm ram authorization?',
	  button_rdc_ram_authorization_rdc: 'config',
	  button_rdc_ram_authorization_ram: 'authorization',
	  button_rdc_ram_authorization_rdc_update: 'rdc re-authorization',
	  button_rdc_ram_authorization_rdc_delete: 'cancel',
	  text_rdc_ram_authorization_rdc_no_user_id: 'no authorization',
	  text_rdc_ram_authorization_rdc_no_user_name: 'no authorization',
	  label_rdc_ram_authorization_rdc_user_id: 'authorization user ID',
	  label_rdc_ram_authorization_rdc_user_name: 'authorization user nickname',
	  text_rdc_ram_authorization_msg_fail_delete: 'delete rdc authorization fail',
	  text_rdc_ram_authorization_msg_fail_add: 'add authorization fail',
	  text_rdc_ram_authorization_msg_fail_update: 'rdc re-authorization fail',
	  text_assigned_to: 'Owner',
	  label_empty_key: 'Empty',
	  text_default_value: 'Default value',
	  text_attr_name: 'Attribute Name',
	  text_add_attr: 'Add attribute',
	  text_rule_list_with_description: '<strong>Custom rule list</strong>(rules triggered will run with order from list)',
	  text_trigger_event_can_not_be_null: 'Trigger event can not be null',
	  text_delete_actuators: 'Delete Actuator',
	  text_delete_rule_confirm: 'Sure to delete this rule?',
	  label_code_repo_type: 'Repo Type',
	  text_select_code_repo_type: 'please select your code repo name',
	  text_Search_Region_Member: 'Input keyword, return search',
	  text_disk_type_cloud: 'general cloud disk',
	  text_disk_type_cloud_efficiency: 'efficient cloud disk',
	  text_disk_type_cloud_ssd: 'SSD cloud disk',
	  text_disk_type_ephemeral_ssd: 'local cloud disk',
	  text_resource_specification: 'resource specification',
	  text_security_groupName: 'security group',
	  text_security_disk_type: 'disk type',
	  text_security_disk_size: 'disk size',
	  text_machine_name: 'machine name',
	  text_machine_password: 'please enter machine password',
	  text_lab_password: 'machine password',
	  text_machine_buy: 'buy machine',
	  text_tempalte_id: 'template id',
	  text_tempalte_region: 'region',
	  text_tempalte_name: 'template name',
	  text_tempalte_language: 'template code language',
	  text_tempalte_ip: 'ip',
	  text_tempalte_status: 'status',
	  text_tempalte_machine_password: 'machine password',
	  text_tempalte_buy_num: 'number',
	  text_buy_machine_id: 'MACHINE ID',
	  text_go_aliyun_ecs: 'Go to aliyun ecs console',
	  text_resource_specification_introduce: 'please enter the legal resources specifications, click here for detailed specifications ',
	  label_disable: 'Disable',
	  text_enable_confirm: 'Sure to enable?',
	  text_disable_confirm: 'Sure to disable?',
	  text_parent_workitem_done_or_cancel: 'Parent workitems done/cancel',
	  text_child_workitem_done_or_cancel: 'All child workitems done/cancel',
	  text_parent_workitem_done_or_cancel_description: 'This rule is provided by system, and it will be worked when enabled:' + '<br/>as parent workitem is done (<strong>meaning done normally</strong>)，' + 'all unclosed child workitems will be set done status; as parent workitem is cancelled(<strong>meaning done abnormally</strong>),all unclosed child workitems will be cancelled.',
	  text_child_workitem_done_or_cancel_description: 'This rule is provided by system, and it will be worked when enabled:<br/>as all child workitems are cancelled(<strong>meaning done abnormally</strong>),' + 'parent workitem will be auto cancelled; as all child workitem are closed(<strong>meaning be set done</strong>）), including one done workitem at least, parent workitem will be set done.',
	  text_disabled_rule: 'Disabled rules',
	  text_rule_instruction: 'Rule instruction',
	  text_save_failed: 'Save failed',
	  text_role_set_to_status: '<span class="status-config-attr">Only <strong>$1</strong> can set status as <strong>$2</strong></span>',
	  text_role_set_to_status_null: '<span class="status-config-attr">（No permission limit）</span>',
	  text_cf_required_set_to_status: '<span class="status-config-attr">customField <strong>$1</strong> required</span>',
	  text_cf_required_set_to_status_null: '<span class="status-config-attr">（no required customField）</span>',
	
	  label_new_buildImage: 'Add Image',
	  label_edit_buildImage: 'Edit Image',
	  text_modify: 'modify',
	  text_modify_time: 'modify time',
	  text_creator: 'creator',
	  text_modifier: 'modifier',
	  text_image_name: 'image name',
	  text_other_required_info: 'Other necessary info',
	  label_start_time: 'Start Date',
	  label_end_time: 'End Date',
	  text_update_project_date_to_weekend: 'Make sure the start or end time is set on weekends?',
	  label_update_project_date_hint: 'Update start or end time of the project(program)',
	  text_milestone_date_weekend_hint: 'Attention: Milestone completed time is set on weekends',
	  text_add_workitem_relation_change: 'Add new workitem relation with change',
	  text_add_workitem_relation_change_description: 'When a change was related to workitem, this event will be triggered.',
	  text_relation_change_publish: 'Related changes published',
	  text_relation_change_publish_description: 'When all changes ware published successfully, this event will be triggered.',
	  text_tab_machine_manage: 'Resource manage',
	  text_tab_ecs_image_template: 'ECS image template',
	  text_tab_buy_ecs_history: 'Machine purchase history',
	  text_tab_private_proxy_machine: 'Proxy Machine',
	  text_re_ecs_password: 're-paaword',
	  text_not_same_ecs_password: 'Enter the password twice inconsistent',
	  text_same_ecs_password: 'Enter the password twice to keep the same',
	  text_button_buy_ecs: 'Buy ecs',
	  text_button_buy_ecs_and_deploy: 'Buy Ecs and deploy',
	  text_select_ecs_template: 'Now select template name is ',
	  text_buy_ecs_number_is: 'Buy ecs number is',
	  text_sure_to_buy_ecs: ',Are you sure to buy ',
	  text_ecs_password_rule: '8 - 30 characters, must contain three items (uppercase, lowercase, numbers, () `~! @ # $% ^ & * - + = | {} []:; \'<>,. / In the special symbol）。',
	  text_buy_ecs_ing: 'Buy ecs ing...',
	  text_buy_ecs_help: 'Purchasing a machine on this page will automatically associate the machine with the current business. To buy a new machine, only charge ECS fees, you need to ensure that the account balance is sufficient',
	  text_button_close: 'Close',
	  text_button_show_ecs_history_detail: 'Show machine status',
	  text_buy_ecs_time: 'Buy time',
	  text_ecs_rehion: 'region',
	  text_buy_ecs_operator: 'operator',
	  text_buy_ecs_account: 'Buy account',
	  text_buy_ecs_num: 'Ecs number',
	  text_buy_ecs_type: 'Operate type',
	  text_operate: 'Machine Status',
	  text_now_ram_other: 'now is other',
	  text_ram_nickname: 'Nick name',
	  text_ram_help: 'Appropriate binding authorization, Rdc the members of  business, you can specify the cloud account through Alibaba Cloud identity, complete the purchase of ECS machines and other operations. See details',
	  text_ram_help_doc: 'help document',
	  text_ram_now_status: 'now status',
	  text_ram_now_bind_and_authorization: 'Authorized and bound',
	  text_ram_region_user: 'Rdc can use Aliyun main account',
	  text_ram_region_username: 'identity to complete the operation.',
	  text_ram_no_bind: 'not bind',
	  text_ram_bind_and_authorzation: 'Authorize and bind',
	  text_ram_authorization_step_1: 'The first step, authorized rdc right to use my identity to complete the operation。',
	  text_ram_step_finish: ' Completed',
	  text_ram_bind_step_2: 'The second step, configure the Rdc to use my identity to complete the operation.',
	  text_ram_bind_step_2_pre: 'The second step, configure the Rdc to use my',
	  text_ram_bind_step_2_suffix: ' identity to complete the operation.',
	  text_ram_unbind: 'Unblock the current binding',
	  text_ram_unbind_text_pre: 'Rdc  no longer use the current binding Aliyun main account',
	  text_ram_unbind_text_suffix: 'to operate your resource',
	  text_ram_now_bind_account: 'Now bind account is',
	  text_ram_confirm_bind: 'Are you sure to rebind',
	  text_ram_please_bind_first: 'Please authorize and  bind first',
	  text_template_help: 'To ensure you create the correct template, please refer to the document for ECS instance related parameters, see the help document',
	  text_build_image_requirement: 'the image need to be public and size is less than 1 GB',
	  text_ecs_instance_detail_help: '1. to ensure that you can create a ECS template correctly, you may need to know the related parameters of the ECS instance, please refer to this document',
	  text_create_template_help: '2. if you need further guidance, please refer to this document',
	  text_custom_image_help: 'if you need a custom image, please refer to',
	  text_only_vpc_instance_help: 'the yunxiao can only create a ECS instance based VPC, and if you want to create a VPC, please refer to',
	  text_create_vswitch_help: 'to create VSwitch, please refer to',
	  text_create_security_group_help: 'to create security group, please refer to',
	  text_input_correct_resource_specification_help: 'please enter the legal resource specification. If you need to know the details of the resource specifications, please refer to',
	  text_add_template_help_doc: 'help document',
	  text_guide_for_inherit_from_parent: 'No configuration from parent project, please open the switch of using self project configuration and add rule.',
	  text_use_self_project_config: 'Use current project configuration(inherited from parent project configuration as closed)',
	  text_rule_custom_buttons: '<strong>Custom button</strong>(button will be displayed on workitem detail page, and you can configuration actions on button and run the button to trigger the actions)',
	  text_rule_button_name: 'Button name',
	  text_actuator_content: 'Action content',
	  text_button_anthorized_role: 'Operation rights',
	  text_button_visible_scope: 'Visible scope',
	  text_button_name_not_null: 'Button name can not be null',
	  tip_inherit_parent_permission_denied: 'Permission denied. Current operation can be done only by project admins, and you can contact project admins to get rights',
	  tip_not_allowed_on_current_page: 'Not allowed on current page',
	  text_all_statuses: '(all statuses)',
	  text_all_roles: '(all project roles)',
	  text_docker_repo_operate_failed: 'docker image operate failed ,please retry',
	  label_delete_milestone: 'Delete Milestone',
	  text_delete_success: 'Delete successfully',
	  label_milestone_overall_title: ' Overall Plan',
	  label_export: 'Export',
	  label_set_to_completed: 'Set to completed',
	  text_client_button: 'If deleted, the tag will disappear on all workitems, and delete it?',
	  text_delete_share_tag_message: 'This is a shared tag,after deletion, it will not be displayed in this project',
	  label_go_to_today: 'Today',
	  hint_loading: 'Loading,please wait',
	  text_add_url_link: 'Add url link',
	  tip_input_url: 'Input url',
	  text_url_link: 'Url link',
	  text_url_link_example: 'Link contains project id and workitem id, eg. http://example.com?akProjectId=xxx&issueId=xxx',
	  label_project_obj_name: 'Project(Program) Name',
	  label_project_creator: 'Project Creator',
	  label_admin_pm: 'Owner(PM)',
	  label_milestone_cnt: 'Milestone Count',
	  label_duration: 'Duration',
	  text_day_singular: ' day',
	  text_day_plural: ' days',
	  hint_delay: 'Extended',
	  hint_double_click_edit: 'Double-click to edit the content',
	  hint_milestone_name_length: 'Milestone name length must be less than 50',
	  hint_milestone_des_length: 'Milestone description length must be less than 1000',
	  hint_milestone_name_null: 'Milestone name must not be null',
	  text_milestone_date_weekend: 'Make sure the milestone is set on weekends?',
	  text_set_workitem_readonly: 'Set Workitem readonly',
	  tip_workitem_readonly: 'workitems on this type will be set readonly',
	  tip_division_deleted: 'The current division has been deleted, please update',
	  tip_milestone_before_project: 'Milestone planned completed date($1) is earlier than project start date,the project start date($2) will be adjusted to the planned completed time of milestone,confirm the update?',
	  tip_milestone_after_project: 'Milestone planned completed date($1) is later than project end date,the project end date($2) will be adjusted to the planned completed time of milestone,confirm the update?',
	  label_set_cancel: 'Set Canceled',
	  tip_milestone_cnt_hint: 'The project(program) has ',
	  tip_goto_milestone: ' milestone(s),click to view',
	  tip_milestone_null: 'The project(program) has milestones',
	  label_milestone_set_start_date: 'Milestone planned completed date is not set, please set on project setting page',
	  label_milestone_illustration: 'Illustration',
	  label_milestone_illustration_doing: 'Uncompleted and Undelayed Milestones',
	  label_milestone_illustration_done: 'Completed Milestones',
	  label_milestone_illustration_done_delay: 'Completed but Delayed Milestones',
	  label_milestone_illustration_doing_delay: 'Uncompleted and Delayed Milestones',
	  label_milestone_illustration_cancel: 'Cancelled Milestones',
	  label_milestone_illustration_multi: 'Multiple milestones at the same time',
	  label_project_member: 'Project Member',
	  label_investment_duration: 'Investment',
	  label_plan: 'Plan',
	  label_in_actuality: 'In Actuality',
	  label_view: 'View',
	  label_milestone_endDate_null_hint_pre: 'A total of $total milestones,',
	  label_milestone_endDate_null_hint_end: ' have not set planned completed date',
	  label_unit: '',
	  label_milestone_set_endDate: 'Set Milestone Completed Date',
	  label_milestone_name: 'Milestone Name',
	  label_next_milestone: 'Next Milestone',
	  label_recent_complete_milestone: 'Recently Completed Milestone',
	  label_set_endDate: 'Set Date',
	  label_none: 'None',
	  label_milestone_set_endDate_tip_pre: 'The following are milestones without  planned completed date in ',
	  label_milestone_set_endDate_tip_end: '',
	  label_filter_and_display: 'Filter',
	  label_display: 'Display',
	  label_filter_by_project_tag: 'Filter by Project Tag',
	  text_display_project_divider: 'Display project divider',
	  text_display_delayed_unfinished_milestone: 'Display delayed and uncompleted milestones',
	  hint_hide_group_member: 'Hide this member',
	  hint_delete_group: 'Delete this group',
	  hint_hide_group: 'Hide this group',
	  text_confirm_hide_member: 'Hiding this member from the group will not change the member\'s role,are you sure to do this?',
	  label_group_by_role: 'Group by role',
	  label_group_by_custom: 'Group by custom',
	  hint_delete_group_member: 'Delete this member',
	  text_confirm_delete_member: 'Confirm to delete this member from custom group？',
	  text_title_hide_member: 'Hide Member',
	  text_title_delete_member: 'Delete Member',
	  text_title_hide_group: 'Hide Group',
	  text_title_delete_group: 'Delete Group',
	  text_confirm_hide_group: 'Confirm to hide group:($1)?',
	  text_confirm_delete_group: 'Confirm to delete group:($1)? Inventments of member in this group will be deleted with the group.',
	  hint_add_group_member: 'Add Member',
	  hint_add_group: 'Add Group',
	  text_group_name: 'Name',
	  hint_edit_group: 'Edit this group',
	  text_title_edit_group: 'Edit Group',
	  label_form_group: 'Group',
	  label_form_member: 'Member',
	  text_add_member_ps: 'Directions: ',
	  text_add_member_ps_prefix: 'If the user you want is not in the project, please go to ',
	  text_add_member_ps_here: 'here',
	  text_add_member_ps_postfix: ' and set him as a project member',
	  tip_input_group_name: 'Please input name',
	  tip_input_select_group: 'Please select group',
	  tip_input_select_member: 'Please select user',
	  label_project_announcement: 'Project Announcement',
	  hit_no_optional_group: 'No optional group',
	  hit_no_optional_member: 'No optional member',
	  label_edit_invest_date: 'Enter Editing Mode',
	  hint_edit_invest_date: 'Click to enter edit mode, click on the date cell to edit member investment quickly',
	  hint_exit_edit_invest_date: 'After exiting the editing mode, click on the cell can not edit the member investment',
	  label_exit_edit_invest_date: 'Exit Editing Mode',
	  label_back_to_old_version: 'Back to Old Version',
	  hint_exit_full_screen: 'Currently in full screen mode, press esc to exit',
	  text_total_members: 'Total ($1)',
	  text_hide_project_divider: 'Hide project divider',
	  label_history_version: 'Previous Versions',
	  label_current_version: 'Current Version',
	  label_return: 'Return',
	  label_revert_to_version: 'Revert to this version',
	  tip_revert_version: 'Reverting to this version will overwrite the current announcement, are you sure to revert?',
	  label_use_build_image_or_not: 'Set build image or not',
	  label_relate_existing_projects: 'Relate Existing Projects',
	  label_more: 'More',
	  label_lock: 'Lock',
	  label_unlock: 'Unlock',
	  label_exit_project: 'Exit Project',
	  label_approval_project: 'Approval Project',
	  text_lock_req_hint: 'If requirement locked, actions are forbidden including adding,updating,removing,cancelling,archiving and deleting requirements in the project.',
	  text_project_locked_hint: 'Requirements are locked,adding,updating,removing,cancelling,archiving and deleting requirements in the project must take the approval process',
	  tip_cancel_archive_make_sure: 'Confirm to cancel archive？',
	  tip_project_cancel_archive: 'When project is unarchived, sprints, work items and others will not be automatically restored',
	  tip_project_unlock_confirm: 'Confirm to unlock project?',
	  label_approver: 'Approver',
	  label_cc: 'Cc',
	  label_project_approval: 'Project Initiation Approval',
	  label_project_approval_undo: 'Not yet applied for project approval',
	  label_project_approval_doing: 'Project approval is in progress',
	  label_project_approval_pass: 'Project approval has passed',
	  label_project_approval_fail: 'Failed to approve the project',
	  label_tips_start_project_approval: 'select more to start project approval',
	  label_tips_restart_project_approval: 'select more to restart project approval',
	  label_project_info: 'Project Base Info',
	  label_milestone: 'Milestone',
	  tip_input_approver: 'Please input approvers',
	  label_announcement: 'Announcement',
	  label_summary_members: 'Members',
	  label_manager: 'Manage',
	  label_version: 'Version',
	  label_new: 'New',
	  label_total_risk_num: 'Total ($1) Risk(s), ',
	  label_service: 'Service',
	  label_sprint: 'Sprint',
	  label_milestone_plan: 'Milestone Plan',
	  tip_multi_milestone: 'and other $1 milestones',
	  label_insert_term: 'Insert Term',
	  label_term: 'Term',
	  label_create_term: 'Create Term',
	  tip_no_term_list: 'no terms',
	  label_aone_data_module: 'Aone Data',
	  label_relation: 'relation',
	  text_preview: 'preview',
	  text_system_error: 'System error',
	  label_High: 'High',
	  label_Low: 'Low',
	  label_total_projects: 'A total of $total projects',
	  label_child_project: 'Child Project',
	  label_developer: 'Developer',
	  label_branch: 'Branch',
	  label_Change_content: 'Change Content',
	  label_env: 'Project Env',
	  label_Change: 'Change',
	  text_cr_releasing: 'Releasing',
	  text_cr_pending: 'Pending',
	  text_cr_pending_integration: 'Pending integration',
	  text_cr_in_integration: 'In integration',
	  text_application: 'Apply',
	  text_cr_developing: 'Developing',
	  text_cr_test: 'Testing',
	  text_cr_finish: 'Finish',
	  text_cr_closed: 'Closed',
	  text_cr_second_base: 'Environment updating',
	  text_cr_in_audit: 'In Audit',
	  text_cr_compiling: 'Compiling',
	  label_New_change: 'New change',
	  text_New_RPM_change: 'New RPM Change"',
	  text_Publish_2nd_party_lib: 'Publish 2nd party lib"',
	  text_Load_3rd_party_lib: 'Load 3rd party lib',
	  text_Change_module: 'Change module',
	  label_total_crs: 'A total of $total changes',
	  tip_input_related_project_name: 'Enter name of the related projects to search',
	  label_docker_repo_url: 'Set build image url',
	  text_tab_swarm: 'Swarm cluster import',
	  text_tab_k8s: 'kubernetes cluster import',
	  text_tab_account: 'Docker image account management',
	  label_shown_project_block: 'Displayed Panels',
	  label_hidden_project_block: 'Hidden Panels',
	  label_click_to_edit_layout: 'Click to Config Layout Display',
	  label_empty_announcement: 'No Announcement',
	  label_comma: ', ',
	  label_new_and_relate_project: 'Create Project and Relate',
	  label_select_project_template: 'Please select a project template:',
	  label_agile_product_develop: 'Agile Product Development',
	  label_classic_project: 'Project Management',
	  label_defect_tracking: 'Defect Tracking',
	  tip_agile_product_develop: '<div>- Manage the R&D process using mainstream agile methodology (Scrum/Kanban)</div><div>- Assist continuous improvement with metrics such as Cumulative Flow Diagram</div>',
	  tip_classic_project: '<div>- Complete one or more clear goals within a certain time range</div><div>- Track project progress, risks, resources, milestones, etc.</div>',
	  tip_defect_tracking: '<div>Normative defect management process, timely and effective tracking, quality assurance</div>',
	  tip_select_related_project: 'Please select related projects',
	  label_relate_existing: 'Relate Existing',
	  label_display_columns: 'Display Columns',
	  label_milestone_gantt: 'Gantt Chart',
	  label_plan_gantt: 'Planning Gantt chart',
	  label_plan_task: 'Planning Task',
	  text_plan_task_hint: 'Check tasks to add to Gantt Chart',
	  label_title: 'Title',
	  label_plan_start: 'Planned Start',
	  label_plan_end: 'Planned Complete',
	  tip_gantt_owners: 'Project PM, Milestone Owner or Task Assigner',
	  text_Display_archived_project: 'Display completed projects',
	  label_project_template: 'Project(Program) Template',
	  label_open: 'Expand',
	  label_close: 'Collapse',
	  label_open_all: 'Expand All',
	  label_close_all: 'Collapse All',
	  text_create_card_holder: 'Input title @assigner, press Enter',
	  sub_issue_search_placeholder: 'Input subject or ID, press Enter',
	  confirm_cancel_relation: 'Sure to cancel relation ?',
	  cancel_relation: 'Cancel relation',
	  label_copy_from_other_project: 'Copy from other projects',
	  label_select_milestone_copy: 'Please select the milestone',
	  label_copy_milestone: 'Copy milestone',
	  label_current_project_set: 'Now project (Set)',
	  label_current_project: 'Now project',
	  label_more_info: 'More info',
	  label_project_message: 'Project message',
	  text_ecs_region: 'region',
	  text_ecs_instanceId: 'instanceId',
	  text_ecs_instanceName: 'instanceName',
	  text_setting: 'Setting',
	  text_default_open: 'Default open',
	
	  label_belonged_project: 'Project',
	  text_public_team: 'Public in team',
	  text_Accessible_for_team: 'Visible to team staff',
	
	  label_step_1_project_info: '1. Fill in project information',
	  label_step_2_project_template: '2. Select project template',
	  label_req_workflow: 'Requirement workflow',
	  label_task_workflow: 'Task workflow',
	  label_bug_workflow: 'Bug workflow',
	  label_system_template: 'Standard template',
	  label_division_template: 'Team template',
	
	  label_owner_division: 'Team',
	
	  label_colon: ' : ',
	  label_product_is_required: 'BU/Product is required',
	  tip_create_project: 'Please input project\'s name, the length is not more than 20.',
	
	  label_project_archive: 'Complete project',
	  text_delete_project: 'delete project',
	  label_more_option: 'more option',
	  label_project_setting: 'project setting',
	  label_turn_on_share: 'turn on share data to other',
	  tip_delete_project: 'delete project and all the project content',
	  tip_archive_project: 'Once the project is complete, the project can be marked as a closed project. Re-open is not allowed, please be careful.',
	  tip_archive_tip_info: '<div>' + '<div>When the project is completed, the project will be closed.' + '<span style="color: #fb8c00; font-weight: 600">Warning: The project cann\'t be reopened when closed.</span>' + '</div>' + '<div>It will cause the following changes:</div>' + '<div>-<span style="color: #fb8c00">Project</span>: The completed project is not displayed in ' + 'the project list or project search result by default; the template cannot be modified after the project is completed; the progress is automatically set to 100%.</div>' + '<div>-<span style="color: #fb8c00">Chart</span>: Workitems for completed projects will still be counted during chart statistics</div>' + '<div>-<span style="color: #fb8c00">Sprint</span>：Sprint Creation is not allowed in completed projects</div>' + '<div>-<span style="color: #fb8c00">Workitem</span>：Workitem Creation is not allowed in completed projects</div>' + '</div>',
	  label_is_admin: 'is admin',
	  label_input_username: 'type username to search',
	  label_create_child_project: 'Create child project',
	  label_relate_child_project: 'Related child project',
	  label_create_child_project_set: 'Create child project set',
	  label_relate_child_project_set: 'Related child project set',
	  text_relate_child_project: 'Associate the following items into sub projects',
	  layout_setting: 'Layout settings',
	  label_app_template: 'App Template',
	  label_build_config: 'Build Config',
	  label_app_create_review: 'App Info Review',
	  label_sure_to_create_app: 'Create',
	  label_go_to_application: 'View App',
	  label_repo_source: 'Code Source',
	  label_repo: 'Repo',
	  label_gitee: 'Gitee',
	  label_template_name: 'Template name',
	  label_select_app_template: 'Select Application Template',
	  label_language: 'Language',
	  label_other_language: 'other languages',
	  label_deploy_options: 'Deploy Options',
	  label_aol: 'ECS',
	  label_aliyuncontainer: 'Aliyun Container Service',
	  label_kubernetes: 'Kubernetes',
	  label_edas: 'EDAS',
	  label_sofa: 'SOFA',
	  label_non_product: 'Non Product',
	  text_edit_roles: 'edit roles',
	  text_del_role: 'Del role',
	  text_del_role_confirm: 'Are you sure to del this role?',
	  text_switch_open: 'ON',
	  text_switch_closed: 'OFF',
	  text_function_closed: 'Function not open',
	  text_user_name: 'username',
	  text_project_option: 'project option',
	  text_project_explanation: 'Project is the active in a period  of time to achieve one\'s goals with expected start date, end date, and the flow of establish, approval, finish',
	  text_nameSpace_explanation: 'Name space is long standing for cooperation between the feature team, ',
	  tips_child_must_project_when_parent_is_project: 'The current template must be \'project\' when parent project\'s template is \'project\'',
	  tips_parent_must_business_when_child_is_business: 'The parent\'s template cann\'t be \'project\' when current project\'s template is \'business\'',
	  tips_change_to_project_fail_error: 'The template cann\'t be \'project\' when has chilren which template is \'business\'. Please set these project\'s template to be \'project\':',
	  text_child_has_business: 'Has Business In Children',
	  text_set_project_expected_date: 'Set Expected Date',
	  label_closed_project: 'Closed',
	  text_lifecycle_abandoned: 'This field will be discarded. If the project is finished or discarded, go to Settings > More > Close / Delete.',
	  text_edit_progress: 'Edit Progress',
	  text_resignation_batch_transfer: 'Batch transfer',
	  text_resignation_transfer_tip: ' participating projects',
	  text_resignation_transfer_tip_title: 'View transfer rules',
	  text_resignation_transfer_tip_desc_0: 'After transferring project to others, following actions will be performed',
	  text_resignation_transfer_tip_desc_1: '1.Replace my role of the project to others',
	  text_resignation_transfer_tip_desc_2: '2.Change unfinished work-items which assigned to me in this project to others',
	  text_resignation_transfer_tip_desc_3: '3.Change unfinished work-items which tracked by me in this project to others',
	  text_resignation_transfer: 'Transfer',
	  text_resignation_project_name: 'Project name',
	  text_resignation_role: 'Role',
	  text_resignation_undone_number: 'Number of undone workItems',
	  text_resignation_department: 'Department',
	  text_resignation_operation: 'Operation',
	  text_resignation_transfer_project: 'Transfer project',
	  text_resignation_transfer_to: 'Transfered to',
	  text_resignation_choose_user: 'Please choose user',
	  text_resignation_transfer_success: 'Transfer succeed',
	  text_resignation_transfer_failed: 'Transfer failed',
	  text_resignation_projects_selected_empty: 'Please choose transfered projects',
	  label_submit_approval: 'Submit Approval',
	  label_submit: '提交',
	  text_plan_start_time_can_not_be_null: 'Planed start date can not be null',
	  text_plan_end_time_can_not_be_null: 'Planed end date can not be null',
	  text_cancel_approval_hint: 'Cancelling the approval process will terminate the project creation process',
	  text_approval_list_hint: 'Please go to the top navigation "To Do" to view the progress after submitting',
	  text_error_get_bu: 'get bu info error',
	  text_business_recent90PV_zero_option: 'This project has no pv in recent 90 days, please delete it if is abandon',
	  text_project_recent90PV_zero_option: 'This project has no pv in recent 90 days, please close it if is finished ; or delete if if is abandon',
	  text_project_recent90PV_not_zero_option_1: 'The expect end date of this project is $1. Please close it if finished; If is delayed, please',
	  text_project_recent90PV_not_zero_option_2: 'Change Expect End Date',
	  text_project_recent90PV_not_zero_option_3: 'Change Project Template',
	  text_project_recent90PV_not_zero_option_4: 'If is long run, please',
	  text_remove_staff_code_access_of_this_region: 'remove all code access of this user in the company',
	  text_remove_code_access_failed: 'the following repos or groups are not removed ,please deal by yourself ',
	  text_system_remind: 'system remind',
	  text_remove_member_remind: 'if you delete the user, he/she will not be able to enter this company and his/her applications will be transferred to admin',
	  text_project_group_in_code: 'group',
	  label_project_template_setting: 'Project Template',
	  label_project_template_root_setting: 'Division Template',
	  label_project_services_setting: 'Project Services',
	  label_system_default: 'System',
	  label_inherit: 'Inherit',
	  text_cf_detail: 'Details',
	  text_cf_name: 'Name',
	  label_field_format: 'Format',
	  label_cf_description: 'Description',
	  label_cf_required: 'Required',
	  label_cf_possible_value: 'Possible Values',
	  text_create_group_success: 'group create success',
	  text_delete_group_success: 'group delete success',
	  text_update_group_success: 'group update success',
	  label_deleted_project: '已删除',
	  text_project_group: 'Project Group',
	  label_git_third: 'Git Group/Repo',
	  text_product_line_edit_hint: 'Edit more info on productLine edit page'
	};
	
	exports.default = en;

/***/ },

/***/ 33:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var zh = {
	  advanced_setting: '高级配置',
	  createProject: '新建项目',
	  unset: '未设置',
	  projectSetName: '项目集名称',
	  text_package_config_edit: '编辑',
	  text_package_config_edit_role: '编辑角色',
	  text_update_package_config: '更新配置会触发构建物清理,确认更新么',
	  text_build_package_num_config: '构建物保留数配置',
	  text_build_package_config_help: '构建物配置帮助',
	  text_app_package_num: '应用保留数量',
	  text_online_package_num: '生产环境数量',
	  text_build_package_config_switch: '配置生效开关',
	  text_build_package_operation: '操作',
	  text_build_package_update: '修改',
	  text_build_package_input: '请输入',
	  text_build_package_enter_num: '请输入正整数',
	  text_build_package_detail: '构建物信息',
	  text_build_package_app_id: '应用id',
	  text_build_package_app_name: '应用名称',
	  text_app_package_num_table: '应用构建物数量',
	  text_online_package_num_table: '生产环境构建物数量',
	  text_choose_status: '请选择配置开关',
	  text_status_on: '开',
	  text_status_off: '关',
	  text_config_error_app_package_limit_must_over_online_limit: '应用保留数要大于生产环境保留数',
	  text_build_package_app_size: '应用构建物大小',
	  label_select_code_template: '选择模板',
	  label_select_language: '选择语言',
	  label_pending: '待处理',
	  label_my_create: '我创建',
	  label_my_collect: '我收藏',
	  label_issue: '缺陷',
	  label_requirement: '需求',
	  label_task: '任务',
	  label_risk: '风险',
	  label_projectSet: '项目集',
	  label_project: '项目',
	  label_productline: '产品线',
	  text_submit_time: '提交时间',
	  label_actualDate: '实际起止时间',
	  label_select: '请选择',
	  label_yes: '是',
	  label_no: '否',
	  text_please_input: '请输入',
	  text_please_type_integer: '请输入一个整数',
	  text_please_type_number: '请输入一个数字',
	  text_custom_attribute: '自定义属性',
	  text_Owner_department: '负责团队',
	  text_open_to_department: '公开到',
	  text_owner_product: '归属产品/BU',
	  label_search_keyword: '请输入关键字搜索',
	  label_description: '描述',
	  tip_desc_required: '请输入描述',
	  label_expectDate: '计划起止时间',
	  text_Health: '健康度',
	  text_Good: '好',
	  text_Medium: '中',
	  text_Bad: '差',
	  label_thumbnail: '标识图',
	  text_Lifecycle: '生命周期',
	  text_Doing: '进行中',
	  text_Done: '已完成',
	  text_Canceled: '已取消',
	  text_Visibility: '公开性',
	  text_Public_project: '公开',
	  label_visitable_by_all: '所有人可访问',
	  text_Private_project: '私密',
	  label_visitable_only_by_project_member: '仅成员可访问',
	  label_project_name: '项目名称',
	  tip_project_title_required: '请输入项目名称',
	  click_this_to_create_new_project: '点击新建项目',
	  click_this_to_choose_project: '点击选择已有项目',
	  git_repo_can_not_be_empty: 'Git库URL不能为空',
	  git_repo_format_error: '代码库URL不合法',
	  git_repo_url_placeholder: '已有代码库URL（如git@example.aliyun.com:ns/repo.git）',
	  tip_program_title_required: '项目集的名称不能为空',
	  label_portfolio_name: '项目组合名称',
	  text_Please_input_name: '请输入名称',
	  label_name: '名称',
	  text_Parent_project: '上级项目',
	  label_productLine: '产品线',
	  text_Parent_production: '上级产品',
	  text_portfolio_parent: '父项目组合',
	  label_parent_project: '父项目',
	  label_portfolio_belongs_to: '所属项目组合',
	  label_progress_percentage: '进度',
	  label_related_project: '关联项目(集)',
	  text_portfolio_components: '项目组合组件',
	  label_belonged_project_set: '所属项目集',
	  text_Classification: '项目分类',
	  text_Namespace: '业务空间',
	  text_Develop_project: '研发项目',
	  label_project_type: '项目类型',
	  text_name: '名称',
	  text_Public: '公开',
	  text_Accessible_for_everyone: '所有人可访问',
	  text_private: '私密',
	  text_Accessible_for_project_members: '仅成员可访问',
	  text_public_team: '在团队内公开',
	  text_Accessible_for_team: '负责团队内的人员可见',
	  text_Next: '下一步',
	  label_prev_step: '上一步',
	  text_Compete: '完成',
	  label_base_info: '基本信息',
	  text_config_project_group: '配置项目组合组件',
	  label_complete: '完成',
	  text_Administrator: '管理员',
	  text_Accept2: '接受',
	  text_Deny2: '拒绝',
	  text_Cancel_admin: '取消管理员',
	  text_Set_admin: '设置管理员',
	  text_Remove: '删除',
	  text_Pending: '未处理',
	  text_Accepted: '已接受',
	  text_Invalid: '失效',
	  text_Refused: '已拒绝',
	  text_Selected_: '已选中',
	  text__items: '条',
	  text_Accept_all: '全部接受',
	  text_Deny_all: '全部拒绝',
	  text_Active_members: '活跃成员',
	  text_Member_Name: '姓名',
	  text_Nick_Name: '昵称',
	  text_email: '邮箱',
	  text_Department: '部门',
	  text_Mobile: '手机号码',
	  text_Staff_ID: '编号',
	  text_Invitation_list: '待接受邀请',
	  label_status: '状态',
	  text_Waiting_for_approval: '待审批',
	  text_Refused_list: '已拒绝',
	  text_Copy_successfully: '复制成功',
	  text_Add: '添加成员',
	  text_convert_billing: '切换套餐提示',
	  text_click_to_switch: '点击切换',
	  text_switch_billing_success: '请关闭该提示框，继续添加成员',
	  text_switch_billing_faied: '切换失败：',
	  text_Invitation_Link: '通过链接邀请',
	  text_invitation_link_tip: '请复制下面的链接发送给用户，邀请其加入企业',
	  text_This_invitation_remain_valid_till_: '该邀请链接有效期至',
	  text_Copy: '复制',
	  text_RAM: '通过RAM添加',
	  text_ram_tip1: '您可以添加下方的子账号，或',
	  text_ram_tip2: '前往RAM添加子账号',
	  text_ram_tip3: '，如果您还不了解RAM，点此',
	  text_ram_tip4: '查看帮助',
	  text_Display_name: '显示名',
	  text_Login_user_name: '登录名',
	  label_ok: '确定',
	  text_Invitation_Email: '发送邮件邀请',
	  text_Email_textarea_tip: '请添加成员的邮箱地址，每行一个，一次最多添加20个。',
	  text_Within_10_characters: '10个字符以内',
	  text_Apply_to_join_company: '申请加入企业',
	  text_Name: '企业名称',
	  text_Please_type_your_name_correctly: '请正确输入姓名',
	  text_Please_input_your_email: '请输入您的邮箱',
	  text_Invalid_emails: '邮箱格式错误，请重新输入',
	  text_Join_Company: '申请加入企业',
	  text_Your_application_is_waiting_for_approval_please_wait: '你的申请正在审批中，请耐心等待...',
	  text_Invalid_invitation_please_contact_the_administrator: '邀请链接已失效，请联系管理员',
	  text_Your_application_has_been_approved_you_can: '你的审批已被批准，请点击',
	  text__enter_the_company: '前往企业',
	  text_Your_application_has_been_denied_please_contact_the_administrator: '你的申请未被批准，如有异议，请联系管理员',
	  text_Please_input_company_name: '请输入企业名称',
	  text_Invite_Member: '邀请成员',
	  text_Please_select_your_company: '请选择您想访问的企业',
	  text_Switch: '切换',
	  text_No_company: '您还没有加入企业，',
	  text_to_create_a_new_one: '新建第一家企业',
	  tip_program_title_exist: '项目集已被占用,请重试',
	  tip_Plan_end_time_before_start_time: '计划结束时间不可以晚于开始时间',
	  label_solution: '解决方案',
	  label_new_projectset: '新建项目集',
	  text_config_members: '配置成员',
	  text_config_joined_projects: '配置参与项目',
	  label_next_step: '下一步',
	  text_program_manager: '项目集经理',
	  tip_enter_program_manager: '请输入项目集经理',
	  text_program_member: '项目集成员',
	  tip_enter_program_member: '请输入项目集成员',
	  label_cancel: '取消',
	  label_config_scrum: '配置Scrum 团队',
	  tip_scrum_master_require: '请为您的Scrum团队选择Scrum Master',
	  tip_product_owner_require: '请为您的Scrum团队选择Product Owner',
	  tip_scrum_member_require: '请设置您的Scrum团队成员',
	  text_required_please_input: '该字段不能为空,请输入',
	  text_import: '导入',
	  text_apply: '应用',
	  label_product: '产品',
	  text_Todo: '待办',
	  label_view_all: '查看全部',
	  label_empty_data: '暂无数据',
	  text_my_favorite: '我的收藏',
	  tip_empty_data: '没有相关结果',
	  label_view_more: '查看更多',
	  text_todo_clear_tip: '恭喜你，已完成所有待办',
	  text_portfolio: '项目组合',
	  label_Plan_start_and_end_time: '计划起止时间',
	  label_Plan_start_time: '计划开始时间',
	  label_Plan_end_time: '计划结束时间',
	  tip_plan_start_after_end: '计划结束时间不能早于计划开始时间',
	  label_creator_and_created_at: '创建人和创建时间',
	  label_Actual_start_and_end_time: '实际起止时间',
	  label_Actual_start_time: '实际开始时间',
	  label_Actual_end_time: '实际结束时间',
	  text_person_in_charge: '负责人',
	  text_Risk_progress: '风险完成度',
	  text_update_time: '更新时间',
	  text_latest_complated_milestone: '最新完成里程碑',
	  text_edit: '编辑',
	  label_collection: '收藏',
	  tip_create_at: '创建于',
	  label_visible_range: '可见范围',
	  label_detail: '查看详情',
	  label_Risk_summary: '风险汇总',
	  text_Display_Sub_project_Risk: '显示下级项目风险',
	  label_risk_level: '风险等级',
	  text_status: '状态',
	  label_owner_project: '归属项目',
	  text_create_time: '创建时间',
	  label_private: '私有',
	  label_new_project: '新建项目',
	  text_tip_title: '提示',
	  label_create_project_step: '创建项目',
	  label_create_git_step: '创建代码库',
	  label_create_app_step: '创建应用',
	  label_start_project: '进入项目',
	  label_skip_project: '跳过，进入项目',
	  label_config_git: '配置代码库',
	  label_git: 'Git组/库',
	  label_git_repo: 'Git库地址',
	  label_git_third: '代码组/库',
	  label_git_repo_third: '代码库地址',
	  text_select_git_group: '请选择您的Git库所在的组',
	  label_application_name: '应用名',
	  text_input_application_name: '请输入您的代码所属的应用名称',
	  label_Initiate_code_template: '初始化模板',
	  label_develop_mode: '开发模式',
	  text_select_develop_mode: '请选择开发模式',
	  label_develop_mode_free: '自由模式',
	  label_read_more: '了解更多',
	  label_develop_mode_branch: '分支模式',
	  label_develop_mode_gitFlow: 'Git Flow',
	  label_docker_build_or_not: 'Docker构建',
	  label_docker_repo_url: '镜像地址',
	  label_app_release_language: '开发语言',
	  label_application_type: '程序类型',
	  label_deploy_option: '部署方式',
	  label_build_config_step: '配置代码内容',
	  label_deploy_config_step: '配置应用',
	  label_code: '编码',
	  label_test: '测试',
	  label_publish: '发布',
	  label_service_common: '通用',
	  label_service_general: '通用',
	  label_service_product: '产品',
	  label_service_develop: '开发',
	  label_service_testing: '测试',
	  label_service_publish: '发布',
	  label_service_other: '其他',
	  label_service_doc: '文档',
	  label_service_tile_workitem: '工作项',
	  label_service_tile_report: '报表',
	  label_service_tile_chart: '图表',
	  label_service_tile_kanban: '看板',
	  label_service_tile_risk: '风险',
	  label_service_tile_report2: '周报',
	  label_service_tile_document: '文档',
	  label_service_tile_resource: '资源',
	  label_service_tile_milestone: '计划',
	  label_service_tile_meeting: '会议纪要',
	  label_service_tile_lark: '语雀',
	  label_service_tile_req: '需求',
	  label_service_tile_demo: 'Demo',
	  label_service_tile_projectChange: '项目变更',
	  label_service_tile_version: '版本',
	  label_service_tile_version_app_config: '应用配置',
	  label_service_tile_task: '任务',
	  label_service_tile_sprint: '迭代',
	  label_service_tile_code: '代码',
	  label_service_tile_pipeline: '流水线',
	  label_service_tile_project_pipeline: '代项目流水线',
	  label_service_tile_issue: '缺陷',
	  label_service_tile_lab: '实验室',
	  label_service_tile_TC: '测试用例',
	  label_service_tile_regression: '回归',
	  label_service_tile_test: '测试',
	  label_service_tile_crDev: '变更',
	  label_service_tile_app: '应用',
	  label_service_tile_alipay_doccenter: 'Javis文档',
	  label_service_tile_product_version_app_config: '应用配置',
	  label_service_tile_product_version: '版本',
	  label_service_tile_lib: '二方库',
	  label_service_tile_product_version_inst: '制品',
	  label_service_tile_file: '文件',
	  label_service_tile_planItem: '规划',
	  label_service_desc_workitem: '工作项，包含任务，需求，缺陷，帮助项目管理和落地实现',
	  label_service_desc_report: '多维度项目数据分析',
	  label_service_desc_chart: '多维度项目数据分析',
	  label_service_desc_kanban: '以看板视图管理工作进展，聚焦事项的快速推进，配合敏捷开发实践，提高协作效率',
	  label_service_desc_risk: '管理项目的风险，及时通知，层层上报',
	  label_service_desc_report2: '便捷生成项目周报，汇报项目进展',
	  label_service_desc_document: '记录文档，沉淀知识',
	  label_service_desc_resource: '项目的人力资源管理',
	  label_service_desc_milestone: '整体规划项目中各个里程碑以及具体的工作项',
	  label_service_desc_meeting: '会议纪要统一管理',
	  label_service_desc_lark: '接入语雀团队知识库',
	  label_service_desc_req: '记录、查看需求，可自定义工作流，可添加自定义字段，方便跟踪管理',
	  label_service_desc_demo: '接入Demo+项目',
	  label_service_desc_projectChange: '统一管理项目的需求、里程碑计划和人员等变更',
	  label_service_desc_version: '版本',
	  label_service_desc_version_app_config: '配置应用的版本规则：固定版本或最新版本',
	  label_service_desc_task: '记录日常待办事项，跟进进展',
	  label_service_desc_sprint: '按迭代周期规划和管理要交付的需求，迭代锁定后不宜变更需求，确保聚焦，确保完成交付',
	  label_service_desc_code: '代码',
	  label_service_desc_pipeline: '可以自行配置的发布流水线',
	  label_service_desc_project_pipeline: '代项目流水线',
	  label_service_desc_issue: '管理缺陷，可关联到代码变更，方便开发及测试同学跟踪',
	  label_service_desc_lab: '实验室',
	  label_service_desc_TC: '测试用例提供了手工用例管理功能，用于测试同学将测试步骤和测试结果进行记录和查看',
	  label_service_desc_regression: '回归功能提供将基于应用稳定的测试功能脚本（实验室）进行每日定时的回归，用于验证测试产品的质量',
	  label_service_desc_test: '测试服务用于提供给用户场景化的测试服务能力',
	  label_service_desc_crDev: '承载应用内容的变更过程，包括代码，包、容器等变更，集成了持续集成和各种审核工具，是发布的前站服务',
	  label_service_desc_app: '应用生命周期、元数据管理，跟应用相关的基本信息、变更发布都可以在这里找到',
	  label_service_desc_alipay_doccenter: 'Javis文档',
	  label_service_desc_product_version_app_config: '配置应用的版本规则：固定版本或最新版本',
	  label_service_desc_product_version: '定义产品版本，按版本管理需求缺陷',
	  label_service_desc_lib: '项目二方库服务',
	  label_service_desc_product_version_inst: '产品版本制品。每运行一次产品版本流水线，都会有一次唯一的制品产生',
	  label_service_desc_file: 'aone2文件服务',
	  label_service_desc_planItem: '制定产品的规划，组织和管理需求',
	
	  label_plugin_desc_model: '以树形结构定义产品模块或业务模块，按模块分类管理需求',
	  label_plugin_desc_tag: '可以给需求、缺陷、子项目等打标签，分类管理',
	  label_plugin_desc_version: '定义产品版本，按版本管理需求缺陷',
	  label_plugin_desc_across_enterprise: '与另一个企业共享该项目内的数据',
	  label_plugin_set_across_enterprise_tip: '开启共享，合作企业之间共享项目数据',
	  label_plugin_cancel_across_enterprise_tip: '取消共享，将不再与其他合作企业共享数据',
	
	  text_feedback: '反馈',
	  label_quick_start: '快速开始',
	  label_help_doc: '文档与帮助',
	  label_edit: '编辑',
	  label_update_milestone: '编辑里程碑',
	  label_new_milestone: '新建里程碑',
	  label_Actual_completed_time: '实际完成时间',
	  tip_actual_completed_time: '请输入实际完成时间',
	  tip_status_selected: '请选择状态',
	  label_module: '模块',
	  label_Plan_completed_time: '计划完成时间',
	  text_expected_end_date_hint: '请输入计划完成时间',
	  tip_unfinished: '未完成',
	  tip_finished: '已完成',
	  text_Archived: '已归档',
	  text_display_archived_milestone: '显示归档里程碑',
	  text_operation: '操作',
	  text_tag: '标签',
	  label_project_ascription: '项目归属',
	  label_project_plan: '项目计划',
	  text_program_tip1: '“项目集”集合了多个项目的数据，方便查看和统计',
	  text_program_tip2: '但不能管理项目数据。',
	  tip_archive_make_sure: '确定结项吗？',
	  tip_archived_cancel_success: '取消归档成功',
	  tip_archived_success: '结项成功',
	  label_archive_cancel: '取消归档',
	  label_archive: '结项',
	  label_project_archive: '项目结项',
	  tip_project_archive: '项目完成后，可将项目标记为结项。已结项的项目默认不显示在项目列表、项目搜索结果中；已结项项目的工作项数据在图表统计时仍然会统计在内；结项后所有迭代自动关闭，不可新增迭代；结项后不可新增工作项；结项后不可修改模板；结项后不可重新开启，请谨慎操作。',
	  tip_collection_cancel_success: '取消收藏成功',
	  tip_collection_success: '收藏成功',
	  label_collection_cancel: '取消收藏',
	  text_Update_success: '更新成功',
	  text_Update: '更新',
	  tip_save_success: '保存成功',
	  label_confirm: '确认',
	  text_Add_member_role: '+ 添加角色',
	  text_select_role: '请选择角色',
	  tip_waiting_export: '正在导出，导出结果将以旺旺和邮件方式告知；',
	  tip_waiting_export_vpc: '正在导出，导出结果将以邮件方式告知；',
	  text_Export_members: '导出成员',
	  label_not_allow_to_delete_member: '该角色下有成员, 不能删除!',
	  tip_delete_make_sure: '确定删除吗？',
	  label_delete: '删除',
	  label_add_to_dingding_calendar: '加入钉钉日历',
	  label_covered_existing_member: '导入后会保留现有成员并追加新成员, 确定导入其他项目的成员吗？',
	  text_run_success: '操作成功',
	  text_Import_members: '导入成员',
	  tip_project_selected: '请选择项目',
	  text_Success_to_remove_member: '删除成员成功',
	  label_select_role: '请选择角色',
	  label_save: '保存',
	  text_Support_markdown: '支持Markdown',
	  label_preview: '预览',
	  label_remove: '移除',
	  tip_enabled: '启用',
	  label_drag_sort: '可拖拽改变顺序',
	  tip_opened: '已启用',
	  label_all: '全部',
	  text_remove_service_tip: '移除服务不会丢失数据，重新启用数据仍然存在。',
	  label_add: '添加',
	  text_create_a_new_version: '新建版本',
	  text_Display_archived_version: '显示归档版本',
	  text_Unpublished: '未发布',
	  text_Published: '已发布',
	  label_locale: 'zh_CN',
	  text_Related_work_item: '关联工作项',
	  label_Actual_publish_time: '实际发布时间',
	  label_Plan_publish_time: '计划发布时间',
	  text_Parent_version: '父版本',
	  label_New_module: '新建模块',
	  label_New_tag: '新建标签',
	  label_share_tag: '分享标签',
	  label_edit_tag: '编辑标签',
	  text_tag_share_info: '标签分享给',
	  text_tag_share_sub_or_related: '所有子孙项目／所有关联项目',
	  text_tag_other_project: '其他项目：',
	  text_delete_module_success: '模块删除成功',
	  tip_inherit_all: '确定继承父项目的全部模块?',
	  text_inferit_parent_project_config: '继承父项目的配置',
	  text_Inherit_all: '继承全部',
	  label_Inherit_module: '继承模块',
	  tip_module_belong_to: '本模块归属于',
	  tip_click_to_manager_module: '点击前往管理',
	  label_created_at: '创建时间',
	  text_module_inherit_from: '此模块继承自项目 ',
	  text_module_remove_tip: ' ，此操作仅从当前项目移除该模块，不会删除模块，如需删除请前往 ',
	  text_parent_module: '父模块',
	  remove_success: '移除成功',
	  enable_success: '启用成功',
	  label_cooperation_project: '对外合作项目',
	  text_initiate_cooperation: '发起合作',
	  text_participate_cooperation: '参与合作',
	  label_project_title: '项目名称',
	  label_project_des: '项目描述',
	  label_share_content: '共享内容',
	  text_choose_shared_info: '选择共享哪些信息给合作方:',
	  text_project_base_info: '项目的基本信息',
	  text_project_member_info: '项目的成员信息',
	  text_project_work_item: '工作项相关的数据和配置',
	  label_own_info: '本方信息',
	  text_project_owners: '项目负责人',
	  text_project_members: '项目成员',
	  label_participant_info: '合作方信息',
	  text_partner_company: '合作方企业',
	  label_invitation_code: '邀请码',
	  text_code_system_help: '系统账户帮助',
	  code_system_user: '系统账户',
	  enter_code_system_user: '输入用户名进行搜索',
	  more_options: '更多选择',
	  title_edit_view: '编辑视图',
	  lable_crp_migrate: 'CRP迁移',
	  refresh_login: '登录状态过期，请刷新页面。',
	  test_create_issue_init_assignedTo: '创建缺陷时，“指派给”自动置为模块负责人',
	  test_go_into_all_defeat_types: '将生效到所有缺陷类型',
	  test_workflow_role_required_cf: '流转权限 & 流转必填属性',
	  text_delete_confirm: '确认删除吗？',
	  label_set_status_config_title: '设置流转权限&流转必填属性',
	  text_return: '返回',
	  text_disabled: '禁用',
	  test_confirm_to_create_code_account: '确认保存系统账户',
	  test_confirm_to_delete_code_account: '确认删除系统账户',
	  test_create_code_account_success: '保存系统账户成功',
	  test_delete_code_account_success: '删除系统账户成功',
	  test_create_code_account_fail: '保存系统账户失败,系统账户已存在',
	  test_delete_code_account_fail: '删除系统账户失败',
	  test_no_code_account: '当前不存在系统账户',
	  test_enter_right_code_account: '请输入正确系统账户',
	  label_warning: '警告',
	  text_delete_project: '删除项目',
	  text_delete_project_info: '删除项目，将同时删除归属于该项目的工作项、里程碑、风险、版本、模块、迭代、应用、流水线等数据，且无法恢复！',
	  text_delete_project_set_info: '删除项目集，将解除该项目集合与关联项目（集）的关联关系，同时删除归属于该项目集的工作项、里程碑、风险、版本、模块、迭代等数据，且无法恢复！',
	  text_delete_project_portfolio_info: '删除项目组合，将解除该项目组合与项目组合组件的关联关系。',
	  label_delete_project_number_str_vpc: '该项目中有$1个归属的工作项，$2个里程碑，$3个版本，$4个模块，$5个迭代，$6个应用，$7个流水线, $8个文档。(测试用例数量暂未统计)',
	  label_delete_project_number_str: '该项目中有$1个归属的工作项，$2个里程碑，$3个版本，$4个模块，$5个迭代，$6个应用，$7个流水线, $8个文档，$9个测试用例',
	  text_click_to_confirm_delete_project: '(点击确认将直接删除)',
	  text_click_to_confirm_delete_project_with_many_workitem: '(由于归属该项目的工作项数据较多，确认删除后，将默认保留2天，期间可取消删除，否则2天后自动删除)',
	  text_input_project_name_to_confirm: '确定删除，请输入项目名称验证',
	  text_error_when_check_project_name: '项目名称检验失败',
	  text_submit_delete_project_tooltip: '$1于 $2 将此项目登记删除，系统将于 $3 执行删除操作。',
	  label_empty_for_i18n: '',
	  text_project_has_sub_project: '该项目下有$1个子项目，移走后才能删除。',
	  text_project_is_collab: '该项目为跨企业合作项目，请先解除跨企业协作关系',
	  text_across_enterprise: '跨企业协作',
	  text_project_submit_to_delete_success: '项目登记删除成功',
	  text_target_status: '目标状态',
	  text_role_to_set_target_status: '只有以下角色能将状态置为目标状态',
	  text_target_status_set_cfs: '流转到目标状态时，以下属性必填',
	  text_please_select_target_status: '请选择目标状态',
	  text_run_failed: '操作失败',
	  text_select_required_cf: '请选择必填属性',
	  text_has_right_rols: '有权限的角色',
	  text_required_cf_before_status_flow: '状态流转前必填属性',
	  text_role_set_to_status: '<span class="status-config-attr">只有 <strong>$1</strong> 能将状态置为 <strong>$2</strong></span>',
	  text_role_set_to_status_null: '<span class="status-config-attr">（无权限限制）</span>',
	  text_cf_required_set_to_status: '<span class="status-config-attr">字段 <strong>$1</strong> 必填</span>',
	  text_cf_required_set_to_status_null: '<span class="status-config-attr">(无必填字段)</span>',
	
	  text_custom_rule: '自定义规则',
	  text_add_rule: '添加规则',
	  text_input_rule_name: '请输入规则名称',
	  text_rule_name: '规则名称',
	  text_trigger_event: '触发事件',
	  text_actuator: '执行操作',
	  text_return_rule_list: '返回规则列表',
	  text_add_rule_trigger: '添加触发事件',
	  text_add_actuator_group: '添加操作组',
	  text_add_actuator: '添加操作',
	  text_status_auto_flow: '状态自动流转',
	  text_window_to_fill_cfs: '弹框填写属性',
	  text_attr_auto_flow: '自动更新属性',
	  text_select_status: '选择状态',
	  text_step_status_auto_flow: '状态自动流转',
	  text_step_window_to_fill_attrs: '弹框填写属性',
	  text_when_status_is: '当状态为',
	  text_status_flow_to: '，则流转到',
	  text_add_status_auto_flow: '添加状态流转',
	  text_start_review: '需求发起评审',
	  text_review_started_to_trigger_event: '需求发起评审时，会触发此事件',
	  text_finish_review: '需求评审通过',
	  text_finish_review_to_trigger_event: '工作项当前评审的邀评人全部通过该评审时，会触发此事件',
	  text_run_condition: '执行条件',
	  text_always_run: '始终执行',
	  text_rule_name_not_null: '规则名称不能为空',
	  text_rule_actuators_not_null: '规则执行操作不能为空',
	  text_project_cancel_to_delete_success: '取消项目删除登记成功',
	  text_project_delete_success: '项目删除成功',
	
	  text_rdc_ram_authorization_add: '确认进行绑定么',
	  text_rdc_ram_authorization_update: '确认重新进行云效授权么',
	  text_rdc_ram_authorization_delete: '确认解除当前绑定么',
	  text_rdc_ram_authorization_ram: '确认进行RAM授权么',
	  button_rdc_ram_authorization_rdc: '绑定',
	  button_rdc_ram_authorization_ram: '授权',
	  button_rdc_ram_authorization_rdc_update: '重新云效授权',
	  button_rdc_ram_authorization_rdc_delete: '解绑',
	  text_rdc_ram_authorization_rdc_no_user_id: '未授权',
	  text_rdc_ram_authorization_rdc_no_user_name: '未授权',
	  label_rdc_ram_authorization_rdc_user_id: '授权用户ID',
	  label_rdc_ram_authorization_rdc_user_name: '授权用户昵称',
	  text_rdc_ram_authorization_msg_fail_delete: '解除授权失败',
	  text_rdc_ram_authorization_msg_fail_add: '添加授权失败',
	  text_rdc_ram_authorization_msg_fail_update: '重新授权失败',
	  text_assigned_to: '指派给',
	  label_empty_key: '空',
	  text_default_value: '默认值',
	  text_attr_name: '属性名',
	  text_add_attr: '添加属性',
	  text_rule_list_with_description: '<strong>自定义流程规则</strong>（被触发的规则将会按列表的顺序执行）',
	  text_trigger_event_can_not_be_null: '触发事件不能为空',
	  text_delete_actuators: '删除操作组',
	  text_delete_rule_confirm: '确认删除该规则吗？',
	  label_code_repo_type: '代码库名称',
	  text_select_code_repo_type: '请选择您的代码库名称',
	  text_Search_Region_Member: '输入关键字，回车搜索',
	  text_disk_type_cloud: '普通云盘',
	  text_disk_type_cloud_efficiency: '高效云盘',
	  text_disk_type_cloud_ssd: 'SSD云盘',
	  text_disk_type_ephemeral_ssd: '本地云盘',
	  text_resource_specification: '资源规格',
	  text_security_groupName: '所属安全组',
	  text_security_disk_type: '磁盘类型',
	  text_security_disk_size: '磁盘大小',
	  text_machine_name: '机器名称',
	  text_machine_password: '请输入机器密码',
	  text_lab_password: '机器密码',
	
	  text_machine_buy: '购买机器',
	  text_tempalte_id: '模板id',
	  text_tempalte_region: '所属区域',
	  text_tempalte_name: '模板名称',
	  text_tempalte_language: '语言',
	  text_tempalte_ip: 'ip',
	  text_tempalte_status: '状态',
	  text_tempalte_machine_password: '机器密码',
	  text_tempalte_buy_num: '购买数量',
	  text_buy_machine_status: '机器状态',
	  text_buy_machine_buy_sucess: '购买成功',
	  text_buy_machine_buy_starting: '机器启动中',
	  text_buy_machine_buy_running: '机器启动完成',
	  text_buy_machine_id: '机器ID',
	  text_go_aliyun_ecs: '前往阿里云ECS控制台',
	  text_resource_specification_introduce: '请键入合法资源规格，点此处查看详细规格说明',
	  label_disable: '禁用',
	  text_enable_confirm: '确认启用吗',
	  text_disable_confirm: '确认禁用吗',
	  text_parent_workitem_done_or_cancel: '父工作项完成/取消',
	  text_child_workitem_done_or_cancel: '所有子工作项全部完成/取消',
	  text_parent_workitem_done_or_cancel_description: '此规则为系统提供，如果启用，那么以下描述将生效：<br/>当父工作项已完成时（<strong>被置为正常结束状态视为已完成</strong>），' + '所有未关闭的子工作项将自动置为已完成；当父工作项被取消时（<strong>被置为异常结束状态视为已取消</strong>），所有未关闭的子工作项将自动取消。',
	  text_child_workitem_done_or_cancel_description: '此规则为系统提供，如果启用，那么以下描述将生效：<br/>当所有子工作项都被取消时（<strong>被置为异常结束状态视为已取消</strong>），' + '父工作项自动被取消；当所有子工作项都已关闭，且至少有一个工作项是已完成（<strong>被置为正常结束状态视为已完成</strong>）状态，则父工作项自动被置为已完成。',
	  text_disabled_rule: '未启用规则',
	  text_rule_instruction: '规则说明',
	  text_save_failed: '保存失败',
	  label_new_buildImage: '新增镜像',
	  label_edit_buildImage: '编辑镜像',
	  text_modify: '修改',
	  text_modify_time: '修改时间',
	  text_creator: '创建者',
	  text_modifier: '修改者',
	  text_image_name: '镜像名称',
	  text_other_required_info: '其他必要信息',
	  label_start_time: '开始时间',
	  label_end_time: '结束时间',
	  text_update_project_date_to_weekend: '确定将开始时间或结束时间设置在周末?',
	  label_update_project_date_hint: '修改项目(集)的起止时间',
	  text_milestone_date_weekend_hint: '注意：该里程碑设置在周末',
	  text_add_workitem_relation_change: '工作项新关联变更',
	  text_add_workitem_relation_change_description: '工作项新关联了一个变更，会触发次事件',
	  text_relation_change_publish: '工作项关联的变更发布上线',
	  text_relation_change_publish_description: '工作项关联的所有变更全部发布上线时，会触发此事件',
	  text_tab_machine_manage: '机器管理',
	  text_tab_ecs_image_template: 'ECS镜像模板',
	  text_tab_buy_ecs_history: '机器购买历史',
	  text_tab_private_proxy_machine: '代理机',
	  text_re_ecs_password: '确认密码',
	  text_not_same_ecs_password: '两次输入密码不一致',
	  text_same_ecs_password: '两次输入密码保持一致',
	  text_button_buy_ecs: '购买机器',
	  text_button_buy_ecs_and_deploy: '购买机器并部署',
	  text_select_ecs_template: '选择模板为',
	  text_buy_ecs_number_is: ',购买机器数量为',
	  text_sure_to_buy_ecs: '台,确认购买么',
	  text_ecs_password_rule: '8 - 30 个字符，必须同时包含三项（大写字母、小写字母、数字、 ()`~!@#$%^&*-+=|{}[]:;\'<>,.?/ 中的特殊符号）。',
	  text_buy_ecs_ing: '机器购买中...',
	  text_buy_ecs_help: '在该页面购买机器，将会自动将机器关联到当前企业。购买新机器，只收取ECS费用，需要保证账户余额充足',
	  text_import_ecs_help: '在该页面导入机器，只支持VPC网络ECS导入',
	  text_button_close: '关闭',
	  text_button_show_ecs_history_detail: '查看机器状态',
	  text_buy_ecs_time: '购买时间',
	  text_ecs_rehion: '所属区域',
	  text_buy_ecs_operator: '操作人',
	  text_buy_ecs_account: '购买账户',
	  text_buy_ecs_num: '购买数量',
	  text_buy_ecs_type: '操作类型',
	  text_operate: '机器状态',
	  text_now_ram_other: '当前是别人',
	  text_ram_nickname: '昵称',
	  text_ram_help: '适当绑定授权后，云效中本企业的成员，可以通过云效用指定阿里云账户的身份，完成购买ECS机器等操作。详见',
	  text_ram_help_doc: '帮助文档',
	  text_ram_now_status: '当前状态',
	  text_ram_now_bind_and_authorization: '已授权并绑定',
	  text_ram_region_user: '云效中本企业可以用阿里云主账户',
	  text_ram_region_username: '的身份完成操作',
	  text_ram_no_bind: '尚未绑定',
	  text_ram_bind_and_authorzation: '我授权并绑定',
	  text_ram_authorization_step_1: ' 第一步，授权云效有权用我的身份完成操作。',
	  text_ram_step_finish: ' 已完成',
	  text_ram_bind_step_2: ' 第二步，配置云效中本企业用我的身份完成操作。',
	  text_ram_bind_step_2_pre: '第二步，配置云效中本企业用我',
	  text_ram_bind_step_2_suffix: '的身份完成操作',
	  text_ram_unbind: '解除当前绑定',
	  text_ram_unbind_text_pre: '云效中本企业不再用当前绑定的阿里云主账户',
	  text_ram_unbind_text_suffix: '的身份完成操作',
	  text_ram_now_bind_account: '当前已绑定账户',
	  text_ram_confirm_bind: '确认要进行替换么',
	  text_ram_please_bind_first: '请先进行授权绑定',
	  text_template_help: '为保证您正确创建模板，请参考文档以了解ECS实例相关参数,详见',
	  text_build_image_requirement: '为保证正确使用构建镜像，录入的镜像需要是公共镜像，并且大小不超过1G，镜像地址需带digest信息(执行命令 docker images --digests)',
	  text_build_image_help: '自定义构建镜像的具体使用详见',
	  text_ecs_instance_detail_help: '1. 为保证您可以正确创建ECS模板，您可能需要了解ECS实例相关参数，请参考',
	  text_create_template_help: '2. 如您需更进一步的详细引导，请参考',
	  text_custom_image_help: '若需要自定义镜像，请参考',
	  text_only_vpc_instance_help: '云效中只能创建基于VPC的ECS实例，若要创建VPC，请参考',
	  text_create_vswitch_help: '创建VSwitch，请参考',
	  text_create_security_group_help: '创建安全组，请参考',
	  text_input_correct_resource_specification_help: '请您键入合法资源规格，若需了解资源规格详情，请参考',
	  text_add_template_help_doc: '帮助文档',
	  text_guide_for_inherit_from_parent: '父级项目未配置任何规则，打开项目自主配置开关，可自行添加。',
	  text_use_self_project_config: '开启本项目自主配置（关闭时，配置继承自父级项目）',
	  text_rule_custom_buttons: '<strong>自定义按钮</strong>（按钮将显示在工作项详情，可配置按钮对应的操作，点击按钮将执行对应的操作）',
	  text_rule_button_name: '按钮名称',
	  text_actuator_content: '操作内容',
	  text_button_anthorized_role: '执行权限',
	  text_button_select_anthorized_role: '请选择角色，如不设定则为所有角色都有权限',
	  text_button_visible_scope: '显示范围',
	  text_button_select_visible_scope: '请选择可见的状态',
	  text_button_name_not_null: '按钮名称不能为空',
	  tip_inherit_parent_permission_denied: '没有操作权限，当前操作只有项目管理员可操作，如需操作，请联系项目管理员',
	  tip_not_allowed_on_current_page: '本页面不支持当前操作',
	  text_all_statuses: '（所有状态）',
	  text_all_roles: '（所有角色）',
	  text_docker_repo_operate_failed: '镜像操作失败，请重试',
	  label_delete_milestone: '删除里程碑',
	  text_delete_success: '删除成功',
	  label_milestone_overall_title: '的整体计划',
	  label_export: '导出',
	  label_set_to_completed: '置为完成',
	  text_client_button: '删除后，该标签会在当前项目的所有工作项上消失，确定删除？',
	  text_delete_share_tag_message: '该标签是共享标签，删除后这个标签将不在这个项目内展示',
	  label_go_to_today: '今天',
	  hint_loading: '加载中，请稍后',
	  text_add_url_link: '添加跳转链接',
	  tip_input_url: '请输入url链接',
	  text_url_link: '跳转链接',
	  text_url_link_example: '链接将携带项目Id和工作项Id信息，如：http://example.com?akProjectId=xxx&issueId=xxx',
	  label_project_obj_name: '项目(集)名称',
	  label_admin_pm: '负责人(PM)',
	  label_project_creator: '项目创建人',
	  label_milestone_cnt: '里程碑数量',
	  label_duration: '时长',
	  text_day_singular: '天',
	  text_day_plural: '天',
	  hint_delay: '超期',
	  hint_double_click_edit: '双击可修改此内容',
	  hint_milestone_name_length: '里程碑名称不能超过50个字',
	  hint_milestone_des_length: '里程碑描述不能超过1000个字',
	  hint_milestone_name_null: '里程碑名称不能为空',
	  text_milestone_date_weekend: '确定将该里程碑设置在周末?',
	  text_set_workitem_readonly: '设置工作项为只读',
	  tip_workitem_readonly: '该类型下的工作项将被置为只读状态，任何人无法编辑。',
	  tip_division_deleted: '由于组织架构调整，当前部门已被删除，请及时核对并更新部门信息！',
	  tip_milestone_before_project: '里程碑的计划完成时间($1)早于项目开始时间($2)，项目的开始时间将更新为里程碑的计划完成时间，确认更新吗？',
	  tip_milestone_after_project: '里程碑的计划完成时间($1)晚于项目结束时间($2)，项目的结束时间将更新为里程碑的计划完成时间，确认更新吗？',
	  label_set_cancel: '置为取消',
	  tip_milestone_cnt_hint: '该项目(集)有',
	  tip_goto_milestone: '个里程碑，可点击前往查看',
	  tip_milestone_null: '该项目(集)没有里程碑',
	  label_milestone_set_start_date: '里程碑计划完成时间未设置，请设置时间',
	  label_milestone_illustration: '图例说明',
	  label_milestone_illustration_doing: '未完成，未超期的里程碑',
	  label_milestone_illustration_done: '已完成的里程碑',
	  label_milestone_illustration_done_delay: '超期完成的里程碑',
	  label_milestone_illustration_doing_delay: '超期未完成的里程碑',
	  label_milestone_illustration_cancel: '已取消的里程碑',
	  label_milestone_illustration_multi: '时间点相同的多个里程碑',
	  label_project_member: '项目成员',
	  label_investment_duration: '投入时长',
	  label_plan: '计划',
	  label_in_actuality: '实际',
	  label_view: '查看',
	  label_milestone_endDate_null_hint_pre: '总共$total个，有',
	  label_milestone_endDate_null_hint_end: '个未设置计划完成时间',
	  label_unit: '个',
	  label_milestone_set_endDate: '设置里程碑时间',
	  label_milestone_name: '里程碑名称',
	  label_next_milestone: '下一个里程碑',
	  label_recent_complete_milestone: '最近完成里程碑',
	  label_set_endDate: '设置时间',
	  label_none: '无',
	  label_milestone_set_endDate_tip_pre: '以下是',
	  label_milestone_set_endDate_tip_end: '中未设置时间点的里程碑',
	  label_filter_and_display: '过滤',
	  label_display: '显示',
	  label_filter_by_project_tag: '按项目标签过滤',
	  text_display_project_divider: '显示项目分隔线',
	  text_display_delayed_unfinished_milestone: '只显示超期未完成的里程碑',
	  hint_hide_group_member: '隐藏该成员',
	  hint_delete_group: '删除该分组',
	  hint_hide_group: '隐藏该分组',
	  text_confirm_hide_member: '确定从分组中隐藏该成员吗？在角色分组中隐藏成员，不会改变项目上的成员的角色。',
	  label_group_by_role: '按成员角色分组',
	  label_group_by_custom: '按自定义分组',
	  hint_delete_group_member: '删除该成员',
	  text_confirm_delete_member: '确定从分组中删除该成员吗？',
	  text_title_hide_member: '隐藏成员',
	  text_title_delete_member: '删除成员',
	  text_title_hide_group: '隐藏分组',
	  text_title_delete_group: '删除分组',
	  text_confirm_hide_group: '确定隐藏分组：($1) 吗？',
	  text_confirm_delete_group: '确定删除分组：($1) 吗？删除后，该分组中所有成员的投入信息将被清除。',
	  hint_add_group_member: '添加人员',
	  hint_add_group: '添加分组',
	  text_group_name: '分组名',
	  hint_edit_group: '编辑该分组',
	  text_title_edit_group: '编辑分组',
	  label_form_group: '分组',
	  label_form_member: '人员',
	  text_add_member_ps: '说明：',
	  text_add_member_ps_prefix: '如果要添加的人员不在当前项目中，请先前往',
	  text_add_member_ps_here: '这里',
	  text_add_member_ps_postfix: '将其添加为项目成员并为其设置角色。',
	  tip_input_group_name: '请输入名字',
	  tip_input_select_group: '请选择分组',
	  tip_input_select_member: '请选择人员',
	  label_project_announcement: '项目公告',
	  hit_no_optional_group: '无可选分组',
	  hit_no_optional_member: '无可选人员',
	  label_edit_invest_date: '进入编辑',
	  hint_edit_invest_date: '点击进入编辑态后，可以通过点击日期单元格快捷编辑成员投入时间',
	  hint_exit_edit_invest_date: '退出编辑态后，点击单元格不可编辑成员投入时间',
	  label_exit_edit_invest_date: '退出编辑',
	  label_back_to_old_version: '返回旧版',
	  label_display_full_screen: '全屏显示',
	  hint_exit_full_screen: '当前为全屏模式，Esc退出',
	  text_total_members: '等($1)人',
	  text_hide_project_divider: '隐藏项目分隔线',
	  label_history_version: '历史版本',
	  label_current_version: '当前版本',
	  label_return: '返回',
	  label_revert_to_version: '还原为此版本',
	  tip_revert_version: '还原为此版本会覆盖当前的公告，确定还原吗？',
	  label_use_build_image_or_not: '自定义构建镜像',
	  label_relate_existing_projects: '关联已有项目',
	  tip_input_related_project_name: '输入关联项目的名称进行搜索',
	  label_more: '更多',
	  label_lock: '锁定',
	  label_unlock: '解锁',
	  label_exit_project: '退出项目',
	  label_approval_project: '立项审批',
	  text_lock_req_hint: '锁定后不能往项目添加需求，不能修改本项目需求，不能把需求移出本项目，不能取消、归档和删除需求',
	  text_project_locked_hint: '项目需求已锁定，添加、修改、删除和取消需求须走审批流程',
	  tip_cancel_archive_make_sure: '确定取消归档吗？',
	  tip_project_cancel_archive: '项目取消归档时，迭代、工作项等不会自动取消归档',
	  tip_project_unlock_confirm: '确认取消锁定项目吗？',
	  label_approver: '审批人员',
	  label_cc: '抄送',
	  label_project_approval: '立项审批',
	  label_project_approval_undo: '尚未立项审批',
	  label_project_approval_doing: '立项审批中',
	  label_project_approval_pass: '立项审批通过',
	  label_project_approval_fail: '立项审批未通过',
	  label_tips_start_project_approval: '在"更多"中可以开始立项审批',
	  label_tips_restart_project_approval: '在"更多"中可以重新开始立项审批',
	  label_project_info: '项目基本信息',
	  label_milestone: '里程碑',
	  tip_input_approver: '请输入审批人员',
	  label_announcement: '公告',
	  label_summary_members: '成员',
	  label_manager: '管理',
	  label_version: '版本',
	  label_new: '新建',
	  label_total_risk_num: '共有($1)个风险，',
	  label_service: '服务',
	  label_sprint: '迭代',
	  label_milestone_plan: '里程碑计划',
	  tip_multi_milestone: '等$1个里程碑',
	  label_insert_term: '插入词条',
	  label_term: '词条',
	  label_create_term: '创建词条',
	  tip_no_term_list: '尚未创建词条',
	  label_aone_data_module: 'Aone数据模块',
	  label_relation: '关联',
	  text_preview: '样式预览',
	  text_system_error: '系统错误',
	  label_High: '高',
	  label_Low: '低',
	  label_total_projects: '共$total个项目',
	  label_child_project: '子项目',
	  label_developer: '开发',
	  label_branch: '分支',
	  label_Change_content: '变更原因',
	  label_env: '项目环境',
	  label_Change: '变更',
	  text_cr_releasing: '发布中',
	  text_cr_pending: '待发布',
	  text_cr_pending_integration: '待集成',
	  text_cr_in_integration: '集成中',
	  text_application: '申请',
	  text_cr_developing: '开发中',
	  text_cr_test: '测试中',
	  text_cr_finish: '已完成',
	  text_cr_closed: '已关闭',
	  text_cr_second_base: '环境更新中',
	  text_cr_in_audit: '审批中',
	  text_cr_compiling: '编译审计中',
	  label_New_change: '新建变更',
	  text_New_RPM_change: '新建RPM变更',
	  text_Publish_2nd_party_lib: '新建二方库发布',
	  text_Load_3rd_party_lib: '新建三方库引入',
	  text_Change_module: '新建模块变更',
	  label_total_crs: '共 $total 个变更',
	  text_tab_swarm: 'swarm集群证书导入',
	  text_tab_k8s: 'kubernetes集群证书导入',
	  text_tab_account: 'docker镜像账号管理',
	  label_shown_project_block: '显示的区块',
	  label_hidden_project_block: '未显示的区块',
	  label_click_to_edit_layout: '点击配置概况页布局',
	  label_empty_announcement: '暂无公告',
	  label_comma: '，',
	  label_new_and_relate_project: '新建并关联',
	  label_select_project_template: '请选择一个项目模板：',
	  label_agile_product_develop: '敏捷产品研发',
	  label_classic_project: '经典项目管理',
	  label_defect_tracking: '缺陷跟踪',
	  tip_agile_product_develop: '<div>- 使用主流敏捷方法学(Scrum/看板方法)管理研发过程</div><div>- 通过累积流图等度量工具辅助持续改进</div>',
	  tip_classic_project: '<div>- 在一定的时间范围内，完成一个或多个明确的目标</div><div>- 跟踪项目的进度、风险、资源、里程碑计划等等</div>',
	  tip_defect_tracking: '<div>规范的缺陷管理流程，及时有效的跟踪，保障质量</div>',
	  tip_select_related_project: '请选择关联项目',
	  label_relate_existing: '关联已有',
	  label_display_columns: '显示列',
	  label_milestone_gantt: '甘特图',
	  label_plan_gantt: '规划甘特图',
	  label_plan_task: '规划任务',
	  text_plan_task_hint: '勾选任务，添加到甘特图',
	  label_title: '标题',
	  label_plan_start: '计划开始',
	  label_plan_end: '计划完成',
	  tip_gantt_owners: '项目PM，里程碑负责人或任务指派人',
	  text_Display_archived_project: '显示已结项项目',
	  label_project_template: '项目(集)模板',
	  label_open_all: '展开所有',
	  label_close_all: '收起所有',
	  label_open: '展开',
	  label_close: '收起',
	  text_create_card_holder: '输入标题 @指派人，回车新建',
	  sub_issue_search_placeholder: '输入标题或ID查找，回车关联',
	  confirm_cancel_relation: '确认取消关联吗？',
	  cancel_relation: '取消关联',
	  label_current_project_set: '当前项目集',
	  label_current_project: '当前项目',
	  label_copy_from_other_project: '从其他项目复制',
	  label_select_milestone_copy: '请选择要复制的里程碑',
	  label_copy_milestone: '复制里程碑',
	  label_more_info: '更多信息',
	  label_project_message: '项目背景',
	  text_ecs_region: '所属区域',
	  text_ecs_instanceId: '实例id',
	  text_ecs_instanceName: '实例名称',
	  text_setting: '设置',
	  text_default_open: '默认开启',
	
	  label_step_1_project_info: '1. 填写项目信息',
	  label_step_2_project_template: '2. 选择项目模板',
	  label_req_workflow: '需求工作流',
	  label_task_workflow: '任务工作流',
	  label_bug_workflow: '缺陷工作流',
	
	  label_system_template: '标准模板',
	  label_division_template: '团队模板',
	  // 英文模式下为Department 防止过长
	  label_owner_division: '负责团队',
	  label_belonged_project: '所属项目',
	  label_colon: '：',
	  label_product_is_required: 'BU/产品不能为空',
	  tip_create_project: '请填写项目名称，建议不超过20个字',
	  label_more_option: '更多操作',
	  label_project_setting: '项目设置',
	  label_turn_on_share: '开启跨企业共享',
	  tip_delete_project: '删除项目，将同时删除归属于该项目的所有内容',
	  tip_archive_project: '项目完成后，可将项目标记为结项。结项后不可重新开启，请谨慎操作。',
	  tip_archive_tip_info: '<div>' + '<div>项目完成后，可将项目标记为结项。<span style="color: #fb8c00; font-weight: 600">结项后不可重新开启，请谨慎操作。</span></div>' + '<div>结项后会引起如下变化：</div>' + '<div>-<span style="color: #fb8c00">项目</span>：已结项的项目默认不显示在项目列表、项目搜索结果中；结项后不可修改模板；进度自动置为100%</div>' + '<div>-<span style="color: #fb8c00">图表</span>：已结项项目的工作项数据在图表统计时仍然会统计在内</div>' + '<div>-<span style="color: #fb8c00">迭代</span>：结项后不可新增迭代</div>' + '<div>-<span style="color: #fb8c00">工作项</span>：结项后不可新增工作项</div>' + '</div>',
	  label_is_admin: '有管理权限',
	  label_input_username: '请输入人名搜索',
	  label_create_child_project: '创建子项目',
	  label_relate_child_project: '关联子项目',
	  label_create_child_project_set: '创建子项目集',
	  label_relate_child_project_set: '关联子项目集',
	  text_relate_child_project: '将以下项目关联成子项目',
	  label_app_template: '应用模板',
	  label_build_config: '构建配置',
	  label_app_create_review: '应用信息预览',
	  label_sure_to_create_app: '确定创建应用',
	  label_go_to_application: '查看应用',
	  layout_setting: '布局设置',
	  label_repo_source: '代码源',
	  label_repo: '仓库',
	  label_gitee: '码云',
	  label_template_name: '模板名称',
	  label_select_app_template: '选择应用模板',
	  label_language: '编程语言',
	  label_other_language: '其他语言',
	  label_deploy_options: '部署选项',
	  label_aol: 'RDC脚本部署',
	  label_aliyuncontainer: '阿里云容器服务Swarm集群',
	  label_kubernetes: 'Kubernetes部署',
	  label_edas: 'EDAS部署',
	  label_sofa: 'SOFA部署',
	  text_edit_roles: '编辑角色标签',
	  text_del_role: '删除角色',
	  text_del_role_confirm: '确定删除当前角色吗？',
	  text_roles_name: '角色名称',
	  text_switch_open: '开',
	  text_switch_closed: '关',
	  text_function_closed: '功能未开启',
	  label_non_product: '非产品类',
	  text_user_name: '用户名称',
	  text_project_option: '项目操作',
	  text_project_explanation: '需要在一定时间内完成的项目，通常经历立项、审批、结项流程',
	  text_nameSpace_explanation: '长期存在的协作空间，无结项流程',
	  tips_child_must_project_when_parent_is_project: '父项目模板为"项目"，子项目模板不可选择"业务空间"',
	  tips_parent_must_business_when_child_is_business: '当前项目的模板是\'业务空间\'时，父项目模板不能是\'项目\'类型',
	  tips_change_to_project_fail_error: '子项目有业务空间，当前项目的模板不能设为\'项目\'类型。请将以下子项目模板设为\'项目\'类型:',
	  text_child_has_business: '子项目有业务空间',
	  text_set_project_expected_date: '设置项目计划起止日期',
	  label_closed_project: '已结项',
	  text_lifecycle_abandoned: '该字段将被废弃,若项目完结或废弃，请到设置>更多>结项/删除',
	  text_edit_progress: '编辑进度',
	  text_resignation_batch_transfer: '批量转交',
	  text_resignation_transfer_tip: ' 参与的项目',
	  text_resignation_transfer_tip_title: '查看转交规则',
	  text_resignation_transfer_tip_desc_0: '将我参与的项目转交给他人后，将执行以下操作',
	  text_resignation_transfer_tip_desc_1: '1.将我在该项目中的成员角色替换成他人',
	  text_resignation_transfer_tip_desc_2: '2.将该项目中指派给我的，未完成的工作项，改为指派给他人',
	  text_resignation_transfer_tip_desc_3: '3.将该项目中抄送给我的，未完成的工作项，改为抄送给他人',
	  text_resignation_transfer: '转交',
	  text_resignation_project_name: '项目名称',
	  text_resignation_role: '角色',
	  text_resignation_undone_number: '未完成工作项数',
	  text_resignation_department: '部门',
	  text_resignation_operation: '操作',
	  text_resignation_transfer_project: '转交项目',
	  text_resignation_transfer_to: '转交给',
	  text_resignation_choose_user: '请选择用户',
	  text_resignation_transfer_success: '转交成功',
	  text_resignation_transfer_failed: '转交失败',
	  text_resignation_projects_selected_empty: '请选择要转交的项目',
	  label_submit_approval: '提交审批',
	  label_submit: '提交',
	  text_plan_start_time_can_not_be_null: '项目计划开始时间不能为空',
	  text_plan_end_time_can_not_be_null: '项目计划结束时间不能为空',
	  text_cancel_approval_hint: '取消审批会终止项目创建流程',
	  text_approval_list_hint: '提交后请到顶部导航“待办”>"我提交的"查看进展',
	  text_error_get_bu: '获取Bu信息失败',
	  text_business_recent90PV_zero_option: '项目已有90天无人访问，如项目已废弃，请删除',
	  text_project_recent90PV_zero_option: '项目已有90天无人访问，如项目已完成，请结项；如项目已废弃，请删除',
	  text_project_recent90PV_not_zero_option_1: '计划结束时间为$1。如项目已完成，请结项；如需延期,请',
	  text_project_recent90PV_not_zero_option_2: '调整预计结束时间',
	  text_project_recent90PV_not_zero_option_3: '切换为业务空间类模板',
	  text_project_recent90PV_not_zero_option_4: ';如需长期使用，请',
	  text_create_group_success: '创建分组成功',
	  text_delete_group_success: '删除分组成功',
	  text_update_group_success: '修改分组成功',
	  text_remove_staff_code_access_of_this_region: '该用户在当前企业下有代码仓库或组的权限，回收用户代码权限',
	  text_remove_code_access_failed: '用户已删除成功，但下列仓库或项目组的权限未删除(因当前操作人没有权限),请联系有权限的用户手工处理',
	  text_system_remind: '系统提示',
	  text_remove_member_remind: '删除用户后，用户将不能进入企业，用户的应用和流水线会转交给管理员',
	  text_project_group_in_code: '项目组',
	  label_project_template_setting: '项目模板',
	  label_project_template_root_setting: '全局配置',
	  label_project_services_setting: '项目服务',
	  label_system_default: '系统',
	  label_inherit: '上级',
	  text_cf_detail: '属性详情',
	  text_cf_name: '属性名称',
	  label_field_format: '格式',
	  label_cf_description: '提示文案',
	  label_cf_required: '必填',
	  label_cf_possible_value: '待选值',
	  label_deleted_project: '已删除',
	  text_project_group: '项目分组',
	  text_product_line_edit_hint: '更多信息请到产品线页面编辑'
	};
	
	exports.default = zh;

/***/ },

/***/ 34:
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },

/***/ 35:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = handleAction;
	
	var _fluxStandardAction = __webpack_require__(55);
	
	function isFunction(val) {
	  return typeof val === 'function';
	}
	
	function handleAction(type, reducers) {
	  return function (state, action) {
	    // If action type does not match, return previous state
	    if (action.type !== type) return state;
	
	    var handlerKey = _fluxStandardAction.isError(action) ? 'throw' : 'next';
	
	    // If function is passed instead of map, use as reducer
	    if (isFunction(reducers)) {
	      reducers.next = reducers['throw'] = reducers;
	    }
	
	    // Otherwise, assume an action map was passed
	    var reducer = reducers[handlerKey];
	
	    return isFunction(reducer) ? reducer(state, action) : state;
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 47:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },

/***/ 52:
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },

/***/ 53:
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	};
	
	module.exports = exports["default"];

/***/ },

/***/ 54:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _createAction = __webpack_require__(59);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(35);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(60);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	exports.createAction = _createAction2['default'];
	exports.handleAction = _handleAction2['default'];
	exports.handleActions = _handleActions2['default'];

/***/ },

/***/ 55:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFSA = isFSA;
	exports.isError = isError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashIsplainobject = __webpack_require__(57);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	  return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	  return _lodashIsplainobject2['default'](action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isError(action) {
	  return action.error === true;
	}

/***/ },

/***/ 56:
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },

/***/ 57:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(56),
	    isArguments = __webpack_require__(34),
	    keysIn = __webpack_require__(58);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },

/***/ 58:
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(34),
	    isArray = __webpack_require__(52);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },

/***/ 59:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createAction;
	function identity(t) {
	  return t;
	}
	
	function createAction(type, actionCreator, metaCreator) {
	  var finalActionCreator = typeof actionCreator === 'function' ? actionCreator : identity;
	
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var action = {
	      type: type,
	      payload: finalActionCreator.apply(undefined, args)
	    };
	
	    if (args.length === 1 && args[0] instanceof Error) {
	      // Handle FSA errors where the payload is an Error object. Set error.
	      action.error = true;
	    }
	
	    if (typeof metaCreator === 'function') {
	      action.meta = metaCreator.apply(undefined, args);
	    }
	
	    return action;
	  };
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 60:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = handleActions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _handleAction = __webpack_require__(35);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(61);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _reduceReducers = __webpack_require__(53);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	function handleActions(handlers, defaultState) {
	  var reducers = _ownKeys2['default'](handlers).map(function (type) {
	    return _handleAction2['default'](type, handlers[type]);
	  });
	
	  return typeof defaultState !== 'undefined' ? function (state, action) {
	    if (state === undefined) state = defaultState;
	    return _reduceReducers2['default'].apply(undefined, reducers)(state, action);
	  } : _reduceReducers2['default'].apply(undefined, reducers);
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 61:
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = ownKeys;
	
	function ownKeys(object) {
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}
	
	module.exports = exports['default'];

/***/ },

/***/ 1107:
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },

/***/ 1171:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_LIST = undefined;
	exports.getCompanyList = getCompanyList;
	exports.setUserChooseRegion = setUserChooseRegion;
	exports.getCompanyListSuccess = getCompanyListSuccess;
	
	var _utils = __webpack_require__(5);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _fetch = __webpack_require__(4);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GET_LIST = exports.GET_LIST = 'GET_LIST';
	
	function getCompanyList() {
	  var data = window.companyList.result;
	  return function (dispatch) {
	    dispatch(getCompanyListSuccess(data));
	  };
	}
	
	function deleteEnterprisePrefix(url) {
	  var urlSplit = url.split('/');
	  var urlJoin = [];
	  for (var i = 0; i < urlSplit.length; i++) {
	    if (urlSplit[i] === 'enterprise' || urlSplit[i - 1] === 'enterprise') {
	      continue;
	    }
	    urlJoin.push(urlSplit[i]);
	  }
	  return urlJoin.join('/');
	}
	
	function redirectToCallbackPath() {
	  var callback = _utils2.default.getUrlParam('callbackPath');
	  if (callback === '') {
	    window.location.href = '/my';
	  } else {
	    window.location.href = deleteEnterprisePrefix(decodeURI(callback));
	  }
	}
	
	function setUserChooseRegion(targetRegionIdentifier) {
	  return function () {
	    return _fetch2.default.fetch({
	      api: 'setUserChooseRegion',
	      data: {
	        region: targetRegionIdentifier,
	        staffId: window.AK_GLOBAL.keludeUser.staffId
	      }
	    }).then(function () {
	      // redirectToCallbackPath();
	      window.location.href = '/my';
	    }).fail(function () {
	      // redirectToCallbackPath();
	      window.location.href = '/my';
	    });
	  };
	}
	
	function getCompanyListSuccess(data) {
	  return {
	    type: GET_LIST,
	    data: data
	  };
	}

/***/ },

/***/ 1172:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.INIT_STATE = undefined;
	
	var _immutable = __webpack_require__(47);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INIT_STATE = exports.INIT_STATE = _immutable2.default.fromJS({
	  list: []
	});

/***/ },

/***/ 1754:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(8);
	
	var _redux = __webpack_require__(9);
	
	var _index = __webpack_require__(5);
	
	var _actions = __webpack_require__(1171);
	
	var Actions = _interopRequireWildcard(_actions);
	
	var _index2 = __webpack_require__(2089);
	
	var _index3 = _interopRequireDefault(_index2);
	
	var _aisc = __webpack_require__(3);
	
	var _fetch = __webpack_require__(4);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	var _utils = __webpack_require__(5);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = _aisc.Feedback.toast;
	
	var Row = _aisc.Grid.Row,
	    Col = _aisc.Grid.Col;
	
	
	var emailSuffix = ['qq.com', '163.com', '126.com', 'gmail.com', 'aliyun.com', 'alibaba-inc.com'];
	
	var WARNING_FLAG = 'warning';
	var TIP_FLAG = 'tip';
	var NONE_FLAG = 'none';
	
	var REFER_PROFILE_SETTING = 'profileSetting';
	
	var BindEmailPanel = function (_Component) {
	  _inherits(BindEmailPanel, _Component);
	
	  function BindEmailPanel() {
	    _classCallCheck(this, BindEmailPanel);
	
	    var _this = _possibleConstructorReturn(this, (BindEmailPanel.__proto__ || Object.getPrototypeOf(BindEmailPanel)).call(this));
	
	    _this.checkEmailInput = function (inputEmail) {
	      if (/^.+@.+\..+$/.test(inputEmail)) {
	        return true;
	      }
	      return false;
	    };
	
	    _this.onInputUpdate = function (value) {
	      var options = void 0;
	
	      if (!value || value.indexOf('@') > 0) {} else {
	        options = emailSuffix.map(function (mail) {
	          return {
	            label: value + '@' + mail,
	            value: value + '@' + mail,
	            disabled: false
	          };
	        });
	      }
	
	      _this.setState({
	        comboBoxDataSource: options,
	        comboBoxValue: value
	      });
	    };
	
	    _this.onSearchButtonClick = function (value) {
	      _this.setState({
	        comboBoxDataSource: null,
	        comboBoxValue: value.key
	      });
	
	      if (!_this.checkEmailInput(_this.state.comboBoxValue)) {
	        if (!_this.state.emailInputFocus) {
	          _this.setState({
	            warningOrTipFlag: WARNING_FLAG
	          });
	        }
	        return;
	      }
	
	      setTimeout(function () {
	        if (_this.state.emailInputFocus) {
	          return;
	        }
	
	        _fetch2.default.fetch({
	          api: 'ucSendValidationEmail',
	          data: {
	            uuid: _utils2.default.getQueryString('uuid'),
	            inputEmail: value.key,
	            _csrf: window._csrf
	          }
	        }).then(function () {
	          _this.setState({
	            allowSearchButtonClick: false,
	            warningOrTipFlag: TIP_FLAG,
	            part2Visible: true,
	            lastTargetEmail: value.key,
	            resetSecondRemain: 60
	          });
	
	          _this.timer = setInterval(function () {
	            var count = _this.state.resetSecondRemain;
	            count -= 1;
	            _this.setState({
	              resetSecondRemain: count,
	              searchButtonText: (0, _index.i18n)(count + ' \u91CD\u65B0\u53D1\u9001', count + ' Resend')
	            });
	            if (count < 1) {
	              _this.setState({
	                allowSearchButtonClick: true,
	                searchButtonText: (0, _index.i18n)('\u91CD\u65B0\u53D1\u9001', 'Resend')
	              });
	              clearInterval(_this.timer);
	            }
	          }, 1000);
	        });
	      }, 300);
	    };
	
	    _this.onEmailInputBlur = function () {
	      _this.setState({
	        emailInputFocus: false
	      });
	      if (!_this.checkEmailInput(_this.state.comboBoxValue)) {
	        _this.setState({
	          warningOrTipFlag: WARNING_FLAG
	        });
	      } else {
	        _this.setState({
	          warningOrTipFlag: NONE_FLAG
	        });
	      }
	    };
	
	    _this.onEmailInputFocus = function () {
	      _this.setState({
	        emailInputFocus: true
	      });
	      if (_this.state.warningOrTipFlag === WARNING_FLAG) {
	        _this.setState({
	          warningOrTipFlag: NONE_FLAG
	        });
	      }
	    };
	
	    _this.onValidationCodeInputChange = function (inputVerificationCode) {
	      _this.setState({
	        inputVerificationCode: inputVerificationCode,
	        isVerificationCodeError: false
	      });
	    };
	
	    _this.onSubmitButtonClick = function () {
	      if (_this.state.comboBoxValue !== _this.state.lastTargetEmail) {
	        _this.setState({
	          isVerificationCodeError: true
	        });
	        return;
	      }
	      _fetch2.default.fetch({
	        api: 'updateEmailWithValidationCode',
	        data: {
	          uuid: _utils2.default.getQueryString('uuid'),
	          inputEmail: _this.state.comboBoxValue,
	          inputValidationCode: _this.state.inputVerificationCode,
	          _csrf: window._csrf
	        }
	      }).then(function (data) {
	        if (!data.result) {
	          _this.setState({
	            isVerificationCodeError: true
	          });
	          return;
	        }
	        var content = _this.state.refer === REFER_PROFILE_SETTING ? (0, _index.i18n)('修改成功，即将返回个人设置', 'Update successfully, auto jumping...') : (0, _index.i18n)('绑定成功，即将进入云效', 'Bind successfully, auto jumping');
	        Toast.success({
	          content: content,
	          duration: 3000
	        });
	        setTimeout(function () {
	          window.location.href = _utils2.default.getQueryString('from') + '?uuid=' + _utils2.default.getQueryString('uuid') + '&ticket=' + _utils2.default.getQueryString('ticket') + '&ctx=' + _utils2.default.getQueryString('ctx');
	        }, 3000);
	      });
	    };
	
	    _this.onGotoMailboxButtonClick = function () {
	      window.open('http://mail.' + _this.state.comboBoxValue.match(/@(.*)/)[1]);
	    };
	
	    _this.field = new _aisc.Field(_this);
	    _this.state = {
	      comboBoxDataSource: [],
	      comboBoxValue: '',
	      warningOrTipFlag: NONE_FLAG,
	      part2Visible: false,
	      emailInputFocus: false,
	      lastTargetEmail: null,
	      searchButtonText: (0, _index.i18n)('发送验证邮件', 'Send Validate Email'),
	      allowSearchButtonClick: true,
	      resetSecondRemain: 0,
	      inputVerificationCode: null,
	      isVerificationCodeError: false,
	      refer: 'UC'
	    };
	    return _this;
	  }
	
	  _createClass(BindEmailPanel, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (_utils2.default.getQueryString('refer')) {
	        this.setState({
	          refer: _utils2.default.getQueryString('refer')
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.allowSearchButtonClick) {
	        $('.search-input button')[0].setAttribute("disabled", "true");
	      } else {
	        $('.search-input button')[0].removeAttribute("disabled");
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: _index3.default.backgroundWhite },
	        _react2.default.createElement(
	          Row,
	          null,
	          _react2.default.createElement(
	            Col,
	            { offset: '4', span: '16' },
	            _react2.default.createElement(
	              'div',
	              { className: _index3.default.background },
	              _react2.default.createElement('img', { className: _index3.default.centerImage, src: __webpack_require__(1107) }),
	              _react2.default.createElement(
	                'div',
	                {
	                  className: _index3.default.centerTip },
	                this.state.refer === REFER_PROFILE_SETTING ? (0, _index.i18n)('请输入您的新邮箱', 'Please enter your new email address.') : (0, _index.i18n)('您的账号暂未绑定邮箱，请绑定后使用', 'Please bind your email to this account.')
	              ),
	              _react2.default.createElement(
	                Row,
	                null,
	                _react2.default.createElement(
	                  Col,
	                  { className: _index3.default.companyNameInputWrap, offset: '5', span: '14' },
	                  _react2.default.createElement(_aisc.Search, {
	                    placeholder: (0, _index.i18n)('请输入您的工作邮箱', 'Enter your email address'),
	                    onChange: this.onInputUpdate,
	                    searchText: this.state.searchButtonText,
	                    onSearch: this.onSearchButtonClick,
	                    searchIcon: false,
	                    dataSource: this.state.comboBoxDataSource,
	                    className: (0, _index.cs)(_index3.default.emailInput, 'search-input'),
	                    autoWidth: true,
	                    onInputBlur: this.onEmailInputBlur,
	                    onInputFocus: this.onEmailInputFocus
	                  }),
	                  _react2.default.createElement(
	                    'div',
	                    { style: {
	                        marginTop: '10px',
	                        marginBottom: '0px',
	                        height: '30px'
	                      } },
	                    this.state.warningOrTipFlag === WARNING_FLAG && _react2.default.createElement(
	                      'div',
	                      { style: {
	                          color: 'red'
	                        } },
	                      (0, _index.i18n)('请正确输入邮箱地址', 'Please enter your email correctly')
	                    ),
	                    this.state.warningOrTipFlag === TIP_FLAG && _react2.default.createElement(
	                      'div',
	                      null,
	                      (0, _index.i18n)('验证码已经发送到您的邮箱，马上去验证。', 'Send validation code successfully.'),
	                      _react2.default.createElement(
	                        _aisc.Button,
	                        {
	                          onClick: this.onGotoMailboxButtonClick,
	                          shape: 'text', size: 'small' },
	                        (0, _index.i18n)('登录邮箱', 'Go to check.')
	                      )
	                    )
	                  ),
	                  this.state.part2Visible && _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_aisc.Input, {
	                      state: this.state.isVerificationCodeError ? 'error' : null,
	                      onChange: this.onValidationCodeInputChange,
	                      placeholder: (0, _index.i18n)('请输入您收到的验证码', 'Enter the validation code'),
	                      className: _index3.default.validationCodeInput,
	                      maxLength: 6 }),
	                    _react2.default.createElement(
	                      'div',
	                      { style: {
	                          marginTop: '10px',
	                          marginBottom: '0px',
	                          height: '30px'
	                        } },
	                      this.state.isVerificationCodeError && _react2.default.createElement(
	                        'div',
	                        { style: { color: 'red' } },
	                        (0, _index.i18n)('请正确输入验证码', 'Please input verification code correctly')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _aisc.Button,
	                      { style: {
	                          width: '100%'
	                        }, type: 'primary',
	                        onClick: this.onSubmitButtonClick },
	                      this.state.refer === REFER_PROFILE_SETTING ? (0, _index.i18n)('完成修改', 'Submit') : (0, _index.i18n)('立即开启', 'Start a new journey')
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BindEmailPanel;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    list: state.get('list')
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return (0, _redux.bindActionCreators)(Actions, dispatch);
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BindEmailPanel);

/***/ },

/***/ 1755:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(11);
	
	var _reactRedux = __webpack_require__(8);
	
	var _store = __webpack_require__(1757);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _constants = __webpack_require__(1172);
	
	var _bindEmailPanel = __webpack_require__(1754);
	
	var _bindEmailPanel2 = _interopRequireDefault(_bindEmailPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _store2.default)(_constants.INIT_STORE);
	
	(0, _reactDom.render)(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: store },
	  _react2.default.createElement(_bindEmailPanel2.default, null)
	), document.getElementById('ak-container'));
	
	window.Dplus && window.Dplus.pageDone();

/***/ },

/***/ 1756:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxActions = __webpack_require__(54);
	
	var _constants = __webpack_require__(1172);
	
	var _actions = __webpack_require__(1171);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var rootReducer = (0, _reduxActions.handleActions)(_defineProperty({}, _actions.GET_LIST, function (state, action) {
	  return state.set('list', action.data);
	}), _constants.INIT_STATE);
	
	exports.default = rootReducer;

/***/ },

/***/ 1757:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(9);
	
	var _reduxThunk = __webpack_require__(30);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(1756);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logger = function logger(store) {
	  return function (next) {
	    return function (action) {
	      console.group(action.type);
	      console.info('dispatching', action);
	      var result = next(action);
	      console.log('next state', store.getState());
	      console.groupEnd(action.type);
	      return result;
	    };
	  };
	};
	
	var createStoreWithMiddleware = (0, _redux.applyMiddleware)(_reduxThunk2.default
	//logger,
	)(_redux.createStore);
	
	function configureStore(initialState) {
	  return createStoreWithMiddleware(_reducers2.default, initialState);
	}

/***/ },

/***/ 2089:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"backgroundWhite":"backgroundWhite_2PNnF","background":"background_1BAcs","centerImage":"centerImage_3ck7Y","centerTip":"centerTip_353KS","companyNameInputWrap":"companyNameInputWrap_2p6C1","companyNameInput":"companyNameInput_5aGtq","invalidNameTip":"invalidNameTip_2N3Zt","submitCompanyNameButton":"submitCompanyNameButton_3f7Fz","createCompanySuccess":"createCompanySuccess_Zhnfk","validationCodeInput":"validationCodeInput_2LNZ-","emailInput":"emailInput_mq-fA"};

/***/ }

});


/** WEBPACK FOOTER **
 ** ucBindEmail.js
 **/